import {IDataSpell} from "../_interfaces/IDataSpell";

const data_spells_dummy:IDataSpell={
    discipline: "",
    circle: 0,
    url: "",
    name: "",
    threads: 0,
    weaving: 0,
    attune: 0,
    casting: "",
    distance: "",
    dur: "",
    eff: "",
    desc: [],
    sameAs: "",
    as: {txt: "", what: [], mod: 0},
    at: [{txt: ""},
        {txt: ""}]
}

const data_spells: IDataSpell[] = [
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Element_Widerstehen",
        name: "Element Widerstehen [Erde]",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+3 auf Physische und Mystische Rüstung gegen Element",
        desc: ["Element [Erde, Feuer, Holz, Luft, Wasser]. Dies sind fünf verschiedene Zauber, die für jedes Element separat gelernt werden müssen. Jeder Zauber befähigt einen Charakter, eine plötzliche und längerfristige Exposition durch das entsprechende Element besser auszuhalten. Der Zauberer beschwört das Element in seine Handfläche und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schmilzt das Element dahin, während der Zauberer das Ziel berührt. Das Ziel addiert +3 zu seiner Physischen und Mystischen Rüstung gegen auf dem entsprechenden Element beruhenden Schaden.", "Die verschiedenen Elementversionen dieses Zaubers können alle in derselben Zaubermatrix platziert werden."],
        sameAs: "Element Widerstehen",
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +1)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Element_Widerstehen",
        name: "Element Widerstehen [Feuer]",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+3 auf Physische und Mystische Rüstung gegen Element",
        desc: ["Element [Erde, Feuer, Holz, Luft, Wasser]. Dies sind fünf verschiedene Zauber, die für jedes Element separat gelernt werden müssen. Jeder Zauber befähigt einen Charakter, eine plötzliche und längerfristige Exposition durch das entsprechende Element besser auszuhalten. Der Zauberer beschwört das Element in seine Handfläche und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schmilzt das Element dahin, während der Zauberer das Ziel berührt. Das Ziel addiert +3 zu seiner Physischen und Mystischen Rüstung gegen auf dem entsprechenden Element beruhenden Schaden.", "Die verschiedenen Elementversionen dieses Zaubers können alle in derselben Zaubermatrix platziert werden."],
        sameAs: "Element Widerstehen",
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +1)"},
            {txt: "Zusätzliches Ziel (+Rang)"}],
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Element_Widerstehen [Holz]",
        name: "Element Widerstehen",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+3 auf Physische und Mystische Rüstung gegen Element",
        desc: ["Element [Erde, Feuer, Holz, Luft, Wasser]. Dies sind fünf verschiedene Zauber, die für jedes Element separat gelernt werden müssen. Jeder Zauber befähigt einen Charakter, eine plötzliche und längerfristige Exposition durch das entsprechende Element besser auszuhalten. Der Zauberer beschwört das Element in seine Handfläche und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schmilzt das Element dahin, während der Zauberer das Ziel berührt. Das Ziel addiert +3 zu seiner Physischen und Mystischen Rüstung gegen auf dem entsprechenden Element beruhenden Schaden.", "Die verschiedenen Elementversionen dieses Zaubers können alle in derselben Zaubermatrix platziert werden."],
        sameAs: "Element Widerstehen",
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +1)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Element_Widerstehen",
        name: "Element Widerstehen [Luft]",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+3 auf Physische und Mystische Rüstung gegen Element",
        desc: ["Element [Erde, Feuer, Holz, Luft, Wasser]. Dies sind fünf verschiedene Zauber, die für jedes Element separat gelernt werden müssen. Jeder Zauber befähigt einen Charakter, eine plötzliche und längerfristige Exposition durch das entsprechende Element besser auszuhalten. Der Zauberer beschwört das Element in seine Handfläche und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schmilzt das Element dahin, während der Zauberer das Ziel berührt. Das Ziel addiert +3 zu seiner Physischen und Mystischen Rüstung gegen auf dem entsprechenden Element beruhenden Schaden.", "Die verschiedenen Elementversionen dieses Zaubers können alle in derselben Zaubermatrix platziert werden."],
        sameAs: "Element Widerstehen",
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +1)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Element_Widerstehen",
        name: "Element Widerstehen [Wasser]",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+3 auf Physische und Mystische Rüstung gegen Element",
        desc: ["Element [Erde, Feuer, Holz, Luft, Wasser]. Dies sind fünf verschiedene Zauber, die für jedes Element separat gelernt werden müssen. Jeder Zauber befähigt einen Charakter, eine plötzliche und längerfristige Exposition durch das entsprechende Element besser auszuhalten. Der Zauberer beschwört das Element in seine Handfläche und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schmilzt das Element dahin, während der Zauberer das Ziel berührt. Das Ziel addiert +3 zu seiner Physischen und Mystischen Rüstung gegen auf dem entsprechenden Element beruhenden Schaden.", "Die verschiedenen Elementversionen dieses Zaubers können alle in derselben Zaubermatrix platziert werden."],
        sameAs: "Element Widerstehen",
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +1)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Erde_Reinigen",
        name: "Erde Reinigen",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "VAR",
        distance: "10 Schritt",
        dur: "1 Runde",
        area: "2 Schritt Radius",
        eff: "Reinigt Erde und Boden",
        desc: ["Erde. Dieser Zauber entfernt Unreinheiten und fremde Stoffe aus dem Boden, die den Boden unfruchtbar machen. Der Zauberer zeigt auf das Zentrum des Wirkungsbereichs und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Bodens ab. Boden, der größtenteils unbefleckt ist, hat eine Mystische Verteidigung von 6; krankheitsverseuchte oder vergiftete Erde hat dieselbe Mystische Verteidigung wie die Krankheit oder das Gift; Erde, die von einem Dämon verdorben wurde, hat eine Mystische Verteidigung gleich der des Dämons. Wenn die Probe gelingt, wird der Boden im Wirkungsbereich von Verunreinigungen befreit und kann wieder Pflanzen ernähren.", "Dieser Zauber kann in derselben Zaubermatrix platziert werden wie der Zauber Wasser Reinigen."],
        sameAs: "Wasser Reinigen",
        as: {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)", what: ['dist'], mod: 2},
        at: [{txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Erdpfeile",
        name: "Erdpfeile",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "2 Runden",
        eff: "WIL + 3/Physisch und -2 auf Physische Rüstung",
        eff_roll: {attribute: 'wil', mod: 3},
        eff_resist: 'pr',
        desc: ["Erde. Dieser Zauber verwandelt Erde in Kristallpfeile, die auf einen Feind zufliegen und dabei kurzzeitig seine Rüstung zerreißen. Der Zauberer wirft eine Handvoll Erde in die Luft und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe, wie viel Schaden verursacht wird, bevor die Physische Rüstung abgezogen wird. Der Schaden wird nur einmal verursacht; die Wirkungsdauer bezieht sich auf die rüstungssenkende Wirkung. Die Rüstung des Ziels kehrt nach Ende der Wirkungsdauer in ihren normalen Zustand zurück."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Physische Rüstung -2)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Flammenwaffe",
        name: "Flammenwaffe",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "Addiert Stufe 4/W6 Feuerschaden zur Waffe/Physisch",
        desc: ["Feuer. Dieser Zauber entflammt eine Waffe. Der Zauberer schnippt mit den Fingern und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Trägers der Waffe ab. Wenn die Probe gelingt, springt eine Flamme von seinen Fingern auf die Waffe über und hüllt sie, abgesehen vom Griff, vollständig ein. Der Träger der Waffe addiert einen zusätzlichen W6 zur Schadensprobe der Waffe. Der Zauber kann auf Waffen aus jedem Material – Holz, Metall, Knochen und so weiter – gewirkt werden. Die Flamme beschädigt die Waffe nicht."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Kletterschub",
        name: "Kletterschub",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Minuten",
        eff: "+3 auf Klettern-Proben",
        desc: ["Erde. Dieser Zauber verbessert die Kletterfähigkeit eines Charakters. Der Zauberer begibt sich auf alle Viere, berührt dann das Ziel, während dieses zu klettern beginnt, und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel einen Bonus von +3 auf seine Klettern-Proben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Luftr%C3%BCstung",
        name: "Luftrüstung",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "+3 auf Physische Rüstung",
        desc: ["Luft. Dieser Zauber erschafft ein schützendes Kissen aus Luft. Der Zauberer atmet langsam aus und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schießt Luft unter die Kleidung des Ziels, drückt nach außen, um ein Kissen zu erschaffen, und sorgt sowohl für Polsterung als auch für Belüftung. Das Ziel addiert +3 Punkte zu seiner Physischen Rüstung, und die Auswirkungen von Erschöpfung werden (nach Maßgabe des Spielleiters) gesenkt. Wenn das Ziel keine Kleidung oder Rüstung trägt, profitiert es nicht von dem Zauber – es gibt dann nichts, was das Luftpolster zusammenhält, sodass es sich buchstäblich in Luft auflöst. Dieser Zauber ist bei den Feuerschürfern beliebt, die in der Nähe des Todesmeers arbeiten."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Physische Rüstung +2)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Nahrung_Erhitzen",
        name: "Nahrung Erhitzen",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "6",
        distance: "Berührung",
        dur: "Rang + 5 Minuten",
        eff: "Erhitzt und regeneriert Nahrung",
        desc: ["Feuer. Dieser Zauber erhitzt Nahrung und führt ihr vorteilhafte Magie zu. Der Zauberer bläst in seine Hände, als wollte er sie aufwärmen, woraufhin sie in einem sanften Rot leuchten. Dann berührt er die Nahrung und legt eine Spruchzauberei(6)-Probe ab. Gelingt die Probe, überträgt sich das Leuchten auf die Nahrung, die innerhalb einer Minute dampfend heiß wird. Das Verzehren der Nahrung erhöht die Effektivität von Erholungsproben. Ein Charakter, der eine erhitzte Mahlzeit zu sich nimmt, addiert einen Bonus von +4 zu seiner nächsten Erholungs-Probe."],
        as: {txt: "Wirkung Verstärken (+1 Mahlzeit)"},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkung Verstärken (+1 Mahlzeit)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Schnauben",
        name: "Schnauben",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "VAR",
        distance: "Berührung",
        dur: "1 Runde",
        area: "2 Schritt Radius",
        eff: "WIL + 5",
        eff_roll: {attribute: 'wil', mod: 5},
        desc: ["Feuer. Dieser Zauber löscht ein Feuer. Der Zauberer atmet kräftig durch die Nase aus, bewegt dann seine Hand über dem Feuer und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Feuers ab (gewöhnlich 6; durch einen Zauber erschaffene Feuer haben eine Mystische Verteidigung gleich dem Neutralisierungsmindestwurf des Zaubers). Wenn die Probe gelingt, legt der Zauberer eine Wirkungsprobe gegen die Schadensstufe des Feuers ab. Gelingt diese Probe ebenfalls, wird die Schadensstufe des Feuers pro Erfolg um -2 gesenkt. Wenn das Feuer nicht vollständig gelöscht wird, steigt seine Schadensstufe mit einer Geschwindigkeit von +1 pro Minute wieder bis zur ursprünglichen Intensität an."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Unterschlupf",
        name: "Unterschlupf",
        threads: 4,
        weaving: 5,
        attune: 10,
        casting: "6",
        distance: "20 Schritt",
        dur: "10 Stunden",
        eff: "Erschafft einen zweckmäßigen Unterschlupf für eine Person",
        desc: ["Holz. Dieser Zauber biegt und webt Bäume so zusammen, dass sie einen geeigneten Schlafplatz für die Nacht bilden. Der Zauberer steht in der Nähe des gewünschten Ortes seines Unterschlupfs, stellt sich vor, welche Form er annehmen wird, bringt in einer Pantomime die örtliche Flora in die nötige Form und legt dann eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, erschafft er den gewünschten Unterschlupf, der pro Erfolg einer Person Platz bietet. Der standardmäßige Unterschlupf ist kunstlos, aber effektiv. Der Zauberer kann zusätzliche Fäden weben, um den Unterschlupf unzugänglicher zu machen, zum Beispiel versteckt zwischen den Wurzeln eines Baums oder in den Ästen eines Baums, was den Mindestwurf für sämtliche Entdeckenproben um +2 pro Faden erhöht."],
        as: {txt: "Wirkung Verstärken (+1 Person)"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Person)"},
            {txt: "Wirkung Verstärken (Entdeckungsmindestwurf +2)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Wasser_Reinigen",
        name: "Wasser Reinigen",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "VAR",
        distance: "Berührung",
        dur: "1 Runde",
        eff: "WIL + 8",
        eff_roll: {attribute: 'wil', mod: 8},
        desc: ["Wasser. Dieser Zauber entfernt Verunreinigungen aus Wasser. Der Zauberer benetzt seine Lippen mit einem Tropfen Wasser und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Wassers ab. Wasser, das einfach nur schlammig ist, hat eine Mystische Verteidigung von 6; krankheitsverseuchtes oder vergiftetes Wasser hat dieselbe Mystische Verteidigung wie die Krankheit oder das Gift; Wasser, das von einem Dämonen verseucht wurde, hat eine Mystische Verteidigung gleich der des Dämons. Getränke mit einem hohen Wasseranteil, wie etwa Wein, Saft, Bier oder Milch, können mit diesem Zauber gereinigt werden, wobei alle schmackhaften \"Verunreinigungen\" entfernt werden und nur reines Wasser zurückbleibt. Das Ergebnis der Wirkungsprobe gibt die Menge an Wasser oder Getränken in Quart an, die gereinigt wird.", "Dieser Zauber kann in derselben Zaubermatrix platziert werden wie der Zauber Erde Reinigen."],
        sameAs: "Erde Reinigen",
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"}]
    },
    {
        discipline: "Elementarist",
        circle: 1,
        url: "/wiki/Wasserdicht",
        name: "Wasserdicht",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "6",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "Weist Wasser ab",
        desc: ["Wasser. Dieser Zauber versiegelt einen unbelebten Gegenstand gegen Wasser. Der Zauberer taucht seinen Finger in etwas Öl, fährt mit ihm an den Kanten des Ziels entlang und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, kann das Ziel (das ein unbelebter Gegenstand sein muss) nicht nass werden. Wenn der Zauber auf ein Kleidungsstück gewirkt wird, heißt das, dass Wasser davon abperlt. Wird der Zauber auf einen Behälter gewirkt, wird dieser versiegelt, bis er das nächste Mal geöffnet wird. Zu diesem Zeitpunkt endet der Zauber sofort. Das Ziel darf nicht größer als 1 Kubikschritt sein."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Kubikschritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 2,
        url: "/wiki/Luftmatratze",
        name: "Luftmatratze",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "6",
        distance: "Berührung",
        dur: "10 Stunden",
        eff: "+2 auf Erholungsproben",
        desc: ["Luft. Dieser Zauber erschafft eine Matratze aus Luft, die die Heilung fördert. Der Zauberer beschwert die Ecken einer Decke jeweils mit irgendeinem der vier Elemente, die nicht Luft sind – Baumzweige, Steine oder Erdklumpen und so weiter –, pustet dann in seine geballte Faust, als ob er einen Ballon aufblasen wollte, und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, bildet sich unter der Decke ein Kissen aus Luft und verwandelt die Decke so in eine bequeme, einen Fuß dicke Matratze. Jeder, der auf der Matratze 6 Stunden am Stück schläft, erhält einen Bonus von +2 auf die erste Erholungsprobe, die er innerhalb 1 Stunde nach dem Aufwachen abgelegt, und gilt als ausgeschlafen. Die Matratze bleibt aufgeblasen, bis die Wirkungsdauer des Zaubers endet oder die Decke bewegt oder beschädigt wird."],
        as: {txt: "Zusätzliches Ziel (+1)"},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkung Verstärken (-1 Stunde benötigter Schlaf, aber mindestens 4 Stunden)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 2,
        url: "/wiki/Umhang_des_Waldj%C3%A4gers",
        name: "Umhang des Waldjägers",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "Findet mit geisterhafter Hilfe eine Kreatur in einem Waldgebiet",
        desc: ["Holz. Bindung. Dieser Zauber beschwört einen Holzelementar und bindet ihn temporär an ein freiwilliges Ziel. Der Zauberer legt eine Hand an einen Baum, dann die andere an die Stirn des Ziels und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, werden die Adern und Augen des Ziels grün, und es kann das langsame Geschwätz von Holzelementaren und -geistern in natürlichen Gebieten hören und verstehen.", "Jederzeit innerhalb der Wirkungsdauer des Zaubers kann der gebundene Charakter ankündigen, dass er eine lebende Kreatur sucht. Auf diese Ankündigung hin helfen ihm die Holzgeister aktiv bei seiner Suche, was ihm einen Bonus von +5 auf alle Proben gewährt, die für die Suche notwendig sind. Außerdem erhöht sich die Bewegungsrate des Charakters um 4.", "Sobald ein gebundener Charakter erst einmal auf der Jagd ist, lässt jede Ablenkung von dieser Jagd den Zauber sofort enden. Wenn der Zauber aus irgendeinem Grund vorzeitig endet, werden die Sinne des Ziels gelähmt. Es erleidet einen Malus von -3 auf alle Proben, bis es eine volle Nacht lang geschlafen hat, und der Zauberer darf diesen Zauber erst nach einem vollen Tag wieder wirken. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+2 auf Proben mit Bezug zur Suche)"},
            {txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Elementarist",
        circle: 2,
        url: "/wiki/Vereiste_Oberfl%C3%A4che",
        name: "Vereiste Oberfläche",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "6",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        area: "Gebiet von 60 Quadratschritt, maximal 20 Schritt Ausdehnung in jede Richtung",
        eff: "WIL",
        eff_roll: {attribute: 'wil', mod: 0},
        desc: ["Wasser – Kälte. Dieser Zauber erschafft eine vereiste, glatte Oberfläche, die schwierig zu überqueren ist. Der Zauberer bläst auf die Oberfläche, die er beeinflussen will, und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, wird das Zielgebiet sofort von Eis bedeckt. Der Punkt, auf den der Zauberer bläst, ist eine Ecke des Gebiets; das Eis breitet sich von diesem Punkt bis zu einer maximalen Größe gleich dem Wirkungsbereich aus. Die Wirkungsprobe des Zauberers bestimmt den Mindestwurf, der nötig ist, um das Eis zu überqueren, ohne auszurutschen. Charaktere, die über die vereiste Oberfläche laufen wollen, müssen eine Geschicklichkeitsprobe – oder eine geeignete Talent- oder Fertigkeitsprobe – gegen diesen Mindestwurf ablegen (Kreaturen legen eine Geschicklichkeits- oder Niederschlagsprobe ab). Wenn die Probe gelingt, können sie sich mit ihrer halben Bewegungsrate über die vereiste Oberfläche bewegen. Wenn die Probe misslingt, sind sie Niedergeschlagen."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+10 Quadratschritt)"}]
    },
    {
        discipline: "Elementarist",
        circle: 2,
        url: "/wiki/Waffe_Verlangsamen",
        name: "Waffe Verlangsamen",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "-4 auf Schadensproben",
        eff_roll: {attribute: 'str', mod: -4},
        desc: ["Luft. Dieser Zauber verlangsamt eine Waffe und verringert dadurch ihre Fähigkeit, Schaden anzurichten. Der Zauberer mimt einen langsamen Angriff und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Trägers der Waffe ab. Wenn die Probe gelingt, verdickt sich die Luft rund um die Zielwaffe, die sich dadurch jedes Mal verlangsamt, wenn sie einen Gegner trifft. Der Träger erleidet einen Malus von -4 auf seine Schadensproben. Nichts hält den Träger davon ab, die verlangsamte Waffe fallen zu lassen und eine andere zu verwenden, aber jeder, der während der Wirkungsdauer des Zaubers die Waffe aufhebt und benutzt, erleidet den entsprechenden Malus."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Malus -2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 2,
        url: "/wiki/Weidenschild",
        name: "Weidenschild",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "6",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+2 auf Körperlichen und Mystischen Verteidigungsbonus des Schildes",
        desc: ["Holz. Dieser Zauber verbessert die Biegsamkeit von Schilden. Der Zauberer verschränkt seine Finger, berührt dann den Schild und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, sprießen Wurzeln und Blätter aus dem Schild, der so biegsam wie eine Weide wird. Während der Wirkungsdauer des Zaubers erhöhen sich der Körperliche und Mystische Verteidigungsbonus des Schildes jeweils um +2."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +1)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 2,
        url: "/wiki/Windfinger",
        name: "Windfinger",
        threads: 2,
        weaving: 6,
        attune: 11,
        casting: "6",
        distance: "10 Schritt",
        dur: "Rang + 5 Minuten",
        eff: "WIL",
        eff_roll: {attribute: 'wil', mod: 0},
        desc: ["Luft. Dieser Zauber erschafft ein Paar unsichtbarer Hände, die Gegenstände anheben und manipulieren können. Für Beobachter scheint eine sanfte Brise den Gegenstand zu bewegen. Der Zauberer wackelt mit den Fingern und legt eine Spruchzauberei(6)- Probe ab. Wenn die Probe gelingt, ist die Geschicklichkeitsstufe der Hände gleich der Wirkungsstufe, und sie können bis zu 10 Pfund heben. Die Hände können innerhalb der Zauberreichweite alles erreichen, was der Zauberer sieht. Sie können Gegenstände tragen oder bewegen, aber sie können nicht dazu benutzt werden, um anzugreifen, und auch sie selbst können nicht angegriffen werden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+10 Pfund)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Elementarist",
        circle: 3,
        url: "/wiki/Blitzschlag",
        name: "Blitzschlag",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "WIL + 6/Physisch",
        eff_roll: {attribute: 'wil', mod: 6},
        eff_resist: 'pr',
        desc: ["Luft – Elektrizität. Dieser Zauber trifft ein Ziel mit elektrischen Blitzen. Der Zauberer reckt seine Hände gen Himmel, zeigt dann auf das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schießen knisternde Blitze aus den Fingern des Zauberers und treffen das Ziel. Die Wirkungsprobe bestimmt, wie viel Schaden verursacht wird.", "Die ursprüngliche Spruchzauberei-Probe wird gegen jedes zusätzliche Ziel verwendet, das sich ergeben mag. Zusätzliche Erfolge bei sekundären Zielen verursachen keine zusätzlichen Blitzschläge."],
        as: {txt: "Zusätzliches Ziel (+1)"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 3,
        url: "/wiki/Eisbola",
        name: "Eisbola",
        threads: 0,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "2 Runden",
        eff: "WIL + 2/Physisch",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'pr',
        desc: ["Wasser – Kälte. Dieser Zauber erschafft eine Waffe aus Eis, die auf einen Gegner geworfen wird. Der Zauberer wirft zwei Kiesel, Münzen oder andere Gegenstände auf das Ziel und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, verwandeln sich die zwei Gegenstände in dornenbewehrte Kugeln, die durch eine Kette aus Eis verbunden sind und sich um das Ziel wickeln. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden in der ersten Runde verursacht wird. Wenn er bei der Wirkungsprobe Bonuswürfel erzielt, zersplittern Kugeln und Kette. Wenn Kugeln und Kette den Treffer überstehen, gilt das Ziel als Bedrängt, bis es sich am Ende der folgenden Runde befreit."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 3,
        url: "/wiki/Pflanzenmen%C3%BC",
        name: "Pflanzenmenü",
        threads: 3,
        weaving: 7,
        attune: 12,
        casting: "6",
        distance: "10 Schritt",
        dur: "Rang Stunden",
        eff: "WIL + 2",
        eff_roll: {attribute: 'wil', mod: 2},
        desc: ["Holz. Dieser Zauber verwandelt Pflanzenmaterial jeglicher Art in eine leckere Mahlzeit. Dazu werden drei intakte Pflanzen benötigt, egal wie kümmerlich. Der Zauberer schneidet oder reißt die Pflanzen in kleine Stücke und legt dann eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe die Anzahl der Mahlzeiten, die erschaffen werden. Jede Mahlzeit besteht aus den folgenden Teilen: Appetithäppchen, Suppe, Salat, Brot, Hauptgericht, Gemüse und Nachtisch. Alle Mahlzeiten sind identisch. Diese Mahlzeiten können so erscheinen, als enthielten sie Fleisch, aber das ist nicht der Fall. Sie sind jedoch genauso nahrhaft und schmackhaft wie ihre echten Gegenstücke.", "Der Zauber kann nur Arten von Nahrung erschaffen, die der Zauberer vor längstens einem Jahr und einem Tag zum letzten Mal gekostet hat – eine gute Entschuldigung, um gelegentlich bis zum Exzess erlesene Speisen zu essen. Nicht gegessene Mahlzeiten verschwinden, wenn der Zauber endet."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Elementarist",
        circle: 3,
        url: "/wiki/Pflanzenwachstum",
        name: "Pflanzenwachstum",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "8",
        distance: "Berührung",
        dur: "1 Runde",
        area: "2 Schritt Radius",
        eff: "Beschleunigt Pflanzenwachstum",
        desc: ["Holz. Dieser Zauber beschleunigt das Wachstum von Pflanzen. Der Zauberer sprenkelt Wasser auf den Boden und legt eine Spruchzauberei(8)-Probe ab. Wenn die Probe gelingt, wachsen die Pflanzen im Wirkungsbereich innerhalb einer Runde so hoch wie sonst in einer Woche. Wenn der Zauber endet, kehrt die Wachstumsrate wieder zu ihrem normalen Wert zurück, aber die Pflanzen schrumpfen nicht wieder – die Wirkung ist permanent. Dieser Zauber kann pro Tag nur so oft gewirkt werden, wie der Spruchzauberei-Rang des Zauberers beträgt, und pro betroffenem Wirkungsbereich nur einmal pro Woche."],
        as: {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)", what: ["dist"], mod: 2},
        at: [{txt: "Wirkung Verstärken (+1 Tag Wachstum)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Elementarist",
        circle: 3,
        url: "/wiki/Umhang_des_Reflektierenden_Teichs",
        name: "Umhang des Reflektierenden Teichs",
        threads: 2,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 10 Minuten",
        eff: "Gewährt durch Empathie Einsicht in ein Ziel",
        desc: ["Wasser. Bindung. Dieser Zauber beschwört einen Wasserelementar und bindet ihn temporär an ein freiwilliges Ziel. Der Zauberer schaut dem Ziel in die Augen (oder in einen Spiegel), berührt sie sanft und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, werden die Augen des Ziels friedlich und verlockend, während starke Emotionen sie zeitweilig verlassen.", "Der gebundene Charakter kann andere in Unterhaltungen verwickeln und ihre Haltung und ihre Eigenheiten auf schmeichelnde Weise nachahmen, was ihm einen Bonus von +4 auf Konversationsproben verleiht. Für jeden Erfolg bei solchen Proben kann er eine allgemeine Frage bezüglich der Haltung und der Gefühle des Ziels stellen. Der Charakter kann auf diese Weise mehrere Konversationsproben ablegen, aber für jede nachfolgende Probe erhöht sich der Mindestwurf jeweils um +5. Nachfolgende Proben können spezifischere Informationen beschaffen, aber sie müssen für die Unterhaltung (nach Maßgabe des Spielleiters) unmittelbar relevant sein. Wenn dem Charakter eine Konversationsprobe misslingt, endet der Zauber augenblicklich.", "Falls der gebundene Charakter irgendeine starke Meinung oder Emotion ausdrückt, die das Ziel nicht zuerst ausgedrückt hat, die Interaktion energisch manipuliert oder das Ziel unter Druck setzt, endet der Zauber augenblicklich. Wenn der Zauber aus irgendeinem Grund vorzeitig endet, erhält der gebundene Charakter einen Malus von -5 auf alle auf Charisma basierenden Proben, bis er eine volle Nacht lang geschlafen hat, und der Zauberer darf diesen Zauber erst nach einem vollen Tag wieder wirken. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+2 auf Konversationsproben)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Elementarist",
        circle: 3,
        url: "/wiki/Winde_der_Ablenkung",
        name: "Winde der Ablenkung",
        threads: 0,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Runden",
        eff: "Verbessert Proben auf Hieb Ausweichen",
        desc: ["Luft. Dieser Zauber erschafft eine Wand aus starken Winden, die stark genug sind, um physische Angriffe abzuwehren. Der Zauberer gibt rauschende Geräusche von sich und legt eine Spruchzauberei-Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, umgibt ihn eine Wand aus wirbelnder Luft. Er erhält einen Bonus von +3 auf jede Probe auf Hieb Ausweichen. Mit diesem Zauber kann der Zauberer Hieb Ausweichen auch dann einsetzen, wenn er Überrascht oder Aus dem Toten Winkel angegriffen wird."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Elementarist",
        circle: 4,
        url: "/wiki/Erzitternde_Erde",
        name: "Erzitternde Erde",
        threads: 2,
        weaving: 8,
        attune: 13,
        casting: "MVE",
        distance: "Selbst",
        dur: "Rang Runden",
        area: "10 Schritt Radius",
        eff: "Malus auf Charakteraktionen",
        desc: ["Erde. Dieser Zauber lässt den Boden um den Zauberer herum erbeben. Der Zauberer presst seine Hände auf die Erde und legt eine Spruchzauberei-Probe ab, die mit der Mystischen Verteidigung jedes Charakters innerhalb des Wirkungsbereichs verglichen wird. Wenn die Probe gelingt, taumeln die Ziele aufgrund der plötzlichen und starken Bewegungen des Bodens, gelten als Bedrängt und halbieren ihre Bewegungsrate (abrunden), bis sie sich aus dem Wirkungsbereich hinausbewegen oder der Zauber endet. Der Zauber wirkt nicht gegen den Zauberer selbst."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Ziele Ausnehmen (-Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 4,
        url: "/wiki/Gewitterschritt",
        name: "Gewitterschritt",
        threads: 0,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "+2 auf Initiative, Bewegungsrate und Körperliche Verteidigung",
        desc: ["Luft – Elektrizität. Dieser Zauber lädt das Ziel elektrisch auf und beschleunigt seine Bewegung. Der Zauberer muss mit nassen Füßen unter dem offenen Himmel stehen. Er scheuert seine Füße auf dem Boden vor und zurück und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, umgeben grüne Blitze die Füße des Zauberers. Das Ziel bewegt sich auf einem zischenden, einen Fuß breiten Blitz, der bei jedem Schritt pop macht und mit ihm von Ort zu Ort springt. Während der Wirkungsdauer des Zaubers addiert das Ziel jeweils +2 zu seiner Initiative, Bewegungsrate und Körperlichen Verteidigung."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+1 auf alle Wirkungen)"}]
    },
    {
        discipline: "Elementarist",
        circle: 4,
        url: "/wiki/Hainerneuerung",
        name: "Hainerneuerung",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang + 5 Runden",
        eff: "Heilt das Ziel kontinuierlich",
        desc: ["Holz. In jeder Runde, in der dieser Zauber wirkt, heilt er das Ziel ein kleines bisschen. Der Zauberer hält etwas getrocknete Pflanzenmasse in seinen Fingern, bläst sie davon und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erwacht die Pflanzenmasse wieder zum Leben, schwebt kurz um das Ziel herum und umgibt es mit einem vorübergehenden grünen Leuchten. Entweder das Ziel oder der Zauberer muss eine Erholungsprobe ausgeben, und das Ziel heilt in jeder Runde der Wirkungsdauer bei seiner Initiative 4 Schadenspunkte. Dies zählt nicht als Erholungsprobe und erhält daher auch keine Boni, die normalerweise bei Erholungsproben zum Tragen kämen.", "Außerhalb eines Kampfes wird der geheilte Schaden auf 1 Schadenspunkt pro Runde gesenkt und nicht durch zusätzliche Erfolge beeinflusst."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+2 geheilte Schadenspunkte)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 4,
        url: "/wiki/Schneesturm",
        name: "Schneesturm",
        threads: 2,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "30 Schritt",
        dur: "Rang Runden",
        area: "4 Schritt Radius",
        eff: "WIL + 2/Physisch",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'pR',
        desc: ["Wasser – Kälte. Dieser Zauber beschwört einen kleinen Schneesturm gegen Feinde. Der Zauberer zittert und reibt sich die Schultern, legt dann seine Hände zusammen, als ob er einen Schneeball hält, und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, füllen Eis, Hagel und Schnee den Wirkungsbereich, der während der Wirkungsdauer des Zaubers an einem Ort bleibt.", "Aufgrund der \"Wetterbedingungen\" wird die Bewegungsrate aller Ziele im Wirkungsbereich halbiert. In jeder Runde bestimmt die Wirkungsprobe des Zauberers, wie viel Schaden jedes Ziel innerhalb des Wirkungsbereichs erleidet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Elementarist",
        circle: 4,
        url: "/wiki/Speer_des_Elements",
        name: "Speer des Elements",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "verschieden (s. Text)",
        area: "verschieden (s. Text)",
        eff: "WIL + 4/Physisch",
        eff_roll: {attribute: 'wil', mod: 4},
        eff_resist: 'pr',
        desc: ["Element [Erde, Feuer, Holz, Luft oder Wasser]. Dieser Zauber formt einen Speer aus einem der Elemente. Es gibt je einen Speer des Elements für Erde, Feuer, Holz, Luft und Wasser. Jede Version des Zaubers muss separat gelernt, aber sie können alle in derselben Matrix platziert werden.", "Der Zauberer berührt etwas von dem gewünschten Element und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, formt sich ein Speer aus dem Element, der auf das Ziel zufliegt und es trifft. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden verursacht wird. Unabhängig vom Ergebnis verschwindet der Speer nach dem Angriff.", "Jeder Speer verursacht eine andere sekundäre Wirkung:", "Erdspeere zwingen das Ziel, einem Niederschlag gegen einen Mindestwurf gleich der erlittenen Schadenspunkte zu widerstehen.", "Feuerspeere verursachen einen zusätzlichen Stufe 4/W6- Schadenswürfel.", "Aus Holzspeeren sprießen Ranken, die sich um das Ziel schließen, sodass es bis zum Ende der nächsten Runde Bedrängt ist.", "Luftspeere verursachen einen Donnerhall, wenn sie auf das Ziel treffen. Die Wirkungsprobe wird mit der Mystischen Verteidigung jedes Charakters innerhalb von 2 Schritt Entfernung zum Ziel verglichen. Wenn sie gelingt, erleiden alle betroffenen Charaktere bis zum Ende der nächsten Runde einen Malus von -2 auf ihre Aktionsproben.", "Wasserspeere heilen, statt zu verletzen; das Ziel darf sofort – ohne dafür eine Aktion aufwenden zu müssen – eine seiner Erholungsproben mit einem Bonus von +2 ablegen (die nicht von weiteren Heilmitteln beeinflusst werden darf)."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden, sofern anwendbar)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 4,
        url: "/wiki/Windsto%C3%9F",
        name: "Windstoß",
        threads: 0,
        weaving: 8,
        attune: 13,
        casting: "MVG",
        distance: "20 Schritt",
        dur: "1 Runde",
        area: "6 Schritt breit",
        eff: "WIL + 5",
        eff_roll: {attribute: 'wil', mod: 5},
        desc: ["Luft. Dieser Zauber erschafft einen heulenden Windstoß. Der Zauberer legt beide Hände an seine Lippen und bläst fest, hebt dann seine Arme und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Anwesenden innerhalb der Reichweite ab. Wenn die Probe gelingt, fegt ein mächtiger Windstoß in einer 6 Schritt breiten Linie vom Zauberer in die Richtung, in die er blickt. Alle, die sich im Weg des Windstoßes befinden, müssen eine erfolgreiche Niederschlagsprobe gegen das Ergebnis der Wirkungsprobe des Zauberers ablegen, um nicht Niedergeschlagen zu werden."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Elementarist",
        circle: 5,
        url: "/wiki/Erdstab",
        name: "Erdstab",
        threads: 1,
        weaving: 9,
        attune: 14,
        casting: "6",
        distance: "Berührung",
        dur: "Rang + 10 Minuten",
        eff: "Erhöht Erfolge bei Elementaristenzaubern",
        desc: ["Erde. Dieser Zauber erschafft einen Kampfstab aus einer Handvoll Erde oder einem Stein, oder indem er direkt aus der Erde hervorkommt. Der Zauberer berührt das Material und legt dann eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, formt sich ein fünf Fuß langer Kampfstab (mit allen entsprechenden Attributen), der im Kampf als Nahkampfwaffe verwendet werden kann. Jeder Elementarist erschafft einen Erdstab mit einem für ihn charakteristischen Aussehen. Während der Elementarist in den Kreisen seiner Disziplin aufsteigt, verändert sich auch das Aussehen des Stabs (im Allgemeinen wird er markanter und verzierter). Während der Erdstab in der Hand gehalten wird, werden alle erfolgreich gewirkten Elementaristenzauber so behandelt, als wären sie mit einem zusätzlichen Erfolg gewirkt worden. Nur wer das Talent Fadenweben [Elementarismus] beherrscht, kann den Erdstab im Kampf führen. Wenn ein Charakter ohne Kenntnis dieses Talents den Erdstab im Kampf führt, endet der Zauber, sobald der Stab verwendet wird, ruft keine Wirkung hervor und verwandelt sich in seine Ursprungskomponenten zurück."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Waffenschaden Erhöhen (+2 Stufen)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Elementarist",
        circle: 5,
        url: "/wiki/Feuerball",
        name: "Feuerball",
        threads: 1,
        weaving: 9,
        attune: 14,
        casting: "MVG",
        distance: "30 Schritt",
        dur: "2 Runden",
        area: "4 Schritt Radius",
        eff: "WIL + 4/Physisch und Teilweise Blindheit",
        eff_roll: {attribute: 'wil', mod: 4},
        eff_resist: 'pr',
        desc: ["Feuer. Dieser Zauber erschafft einen explosiven Flammenball. Der Zauberer beschwört eine kleine Flamme, bewegt eine seiner Hände in einer kreisförmigen Bewegung über der Flamme und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele innerhalb eines Radius von 4 Schritt um den Aufschlagspunkt ab. Wenn die Probe gelingt, steigt eine kleine Feuerkugel aus seiner Hand empor, die schnell den Umfang eines großen Kürbisses erreicht, bevor sie am Aufschlagspunkt in einer gewaltigen Feuerwolke explodiert. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden bei den getroffenen Zielen verursacht wird. Die von dem Zauber getroffenen Ziele sind außerdem bis zum Ende der nächsten Runde Teilweise Blind (Malus von -2 auf alle Aktionsproben)."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Ziele Ausnehmen (-Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 5,
        url: "/wiki/Fruchtbare_Erde",
        name: "Fruchtbare Erde",
        threads: 4,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Ein Jahr und ein Tag",
        area: "100 Schritt Radius",
        eff: "Macht Boden fruchtbar",
        desc: ["Erde. Dieser Zauber verwendet Blutmagie, um das Pflanzenwachstum auf einem Streifen Land zu beschleunigen. Der Zauberer schneidet sich mit einem scharfen Gegenstand in die Hand und lässt einen Tropfen Blut auf die Erde fallen, wodurch er 1 Punkt Blutmagieschaden erleidet (dieser Schaden kann geheilt werden, sobald der Zauber endet). Dann legt er eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Bodens (gewöhnlich 6) ab. Wenn die Probe gelingt, wird der Boden in einem Radius von 100 Schritt mit Magie angereichert, was ihn für ein Jahr und einen Tag besonders fruchtbar macht. Pflanzen auf diesem Boden wachsen etwa doppelt so schnell wie normal – der Spielleiter bestimmt die exakten Auswirkungen des Wachstums.", "Während der Plage überlebten viele Kaers durch diesen Zauber, und auch viele Städte in Gebieten mit schlechtem Wetter konnten so wiederaufgebaut werden. Gerüchten zufolge versuchen Jaspree-Questoren aus der Stadt Trosk, die Brachen durch großzügige Anwendung dieses Zaubers zu heilen."],
        as: {txt: "Wirkungsbereich Ausdehnen (+10 Schritt)", what: ["dist"], mod: 10},
        at: [{txt: "Wirkungsbereich Ausdehnen (+10 Schritt)"}]
    },
    {
        discipline: "Elementarist",
        circle: 5,
        url: "/wiki/Reite_den_Blitz",
        name: "Reite den Blitz",
        threads: 2,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Selbst; 4 Meilen",
        dur: "1 Runde",
        eff: "Reisen durch Blitz",
        desc: ["Luft – Elektrizität. Dieser Zauber transportiert den Zauberer an jeden Ort, den er innerhalb der Zauberreichweite sehen kann. Sowohl die aktuelle Position als auch das Ziel müssen unter offenem Himmel liegen. Der Zauber zeigt mit einer Hand auf sein Ziel, dann mit der anderen Hand zum Himmel und legt eine Spruchzauberei-Probe gegen seine eigene Mystische Verteidigung ab. Wenn die Probe gelingt, trifft ihn und den Zielort gleichzeitig ein Blitz und hinterlässt an beiden Orten ein für den Zauberer charakteristisches Zeichen auf dem Boden. Der Zauberer wird augenblicklich an den Zielort transportiert.", "Wenn der Zauberer bei der Spruchzauberei-Probe einen Erfolg erzielt, ist er desorientiert und kann in der nächsten Runde nicht handeln. Bei zwei Erfolgen kann er in der nächsten Runde normal handeln. Bei drei Erfolgen kann er sofort so handeln, als ob er in dieser Runde noch keine Aktionen unternommen hätte. Wenn die Spruchzauberei-Probe misslingt, wird der Zauberer von einem Blitz getroffen, der Willenskraft + 6 Schaden verursacht (Physische Rüstung schützt gegen diesen Schaden). Jedes erneute Wirken dieses Zaubers am selben Tag addiert einen kumulativen Modifikator von +5 auf die Wirkschwierigkeit."],
        as: {txt: "siehe Text"},
        at: [{txt: "Reichweite Erhöhen (+2 Meilen)"}]
    },
    {
        discipline: "Elementarist",
        circle: 5,
        url: "/wiki/R%C3%BCstung_Erhitzen",
        name: "Rüstung Erhitzen",
        threads: 2,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        eff: "WIL/Physisch (Rüstung schützt nicht)",
        eff_roll: {attribute: 'wil', mod: 0},
        desc: ["Feuer. Dieser Zauber heizt in Sekundenschnelle Rüstungen oder Schilde auf. Der Zauberer reibt seine Hände aneinander und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Trägers der Rüstung ab. Wenn die Probe gelingt, heizt sich die Rüstung schnell auf extreme Temperaturen auf. In jeder Runde bestimmt die Wirkungsprobe des Zauberers, wie viel Schaden jeder erleidet, der die Rüstung trägt oder berührt (der Träger erhält keinen Schutz durch die vom Zauber betroffene Rüstung)."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2),"}]
    },
    {
        discipline: "Elementarist",
        circle: 5,
        url: "/wiki/Splitternder_Stein",
        name: "Splitternder Stein",
        threads: 1,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        area: "4 Schritt Radius",
        eff: "WIL + 5/Physisch",
        eff_roll: {attribute: 'wil', mod: 5},
        eff_resist: 'pr',
        desc: ["Erde. Dieser Zauber verwandelt einen normalen Stein in ein explosives Geschoss. Der Zauberer nimmt einen faustgroßen Stein in die Hand, wirft ihn dann auf das Ziel und legt eine Spruchzauberei- Probe gegen die höchste Mystische Verteidigung aller Charaktere im Wirkungsbereich ab. Wenn die Probe gelingt, explodiert der Stein in scharfkantige Fragmente, die in alle Richtungen fliegen. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden jedem Ziel zugefügt wird. Alle getroffenen Ziele müssen eine Niederschlagsprobe gegen den erlittenen Schaden ablegen."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Elementarist",
        circle: 6,
        url: "/wiki/Erdsto%C3%9F",
        name: "Erdstoß",
        threads: 3,
        weaving: 10,
        attune: 15,
        casting: "6",
        distance: "40 Schritt",
        dur: "Rang Stunden",
        area: "10 Schritt Radius",
        eff: "WIL",
        eff_roll: {attribute: 'wil', mod: 0},
        desc: ["Erde. Dieser Zauber wirft jeden, der auf Erde oder Stein steht, wild in die Luft. Der Zauberer macht laute Geräusche, während er Kiesel, Schmutz oder kleine Steine auf den Boden wirft, und legt dann eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, wird der Wirkungsbereich explosiv, sobald er berührt wird. Der Zauberer legt eine Wirkungsprobe ab. In jeder Runde legt jeder, der sich durch den Wirkungsbereich bewegt, eine Willenskraftprobe gegen das Ergebnis der Wirkungsprobe ab. Wenn diese Probe gelingt, kann sich der Charakter normal bewegen und handeln. Misslingt die Probe, explodiert der Boden unter seinen Füßen und wirft ihn Stufe 5/W8 Schritt hoch in die Luft. Er erleidet Fallschaden je nach Fallhöhe (siehe Spielleiterhandbuch). Das Gebiet bleibt explosiv, bis der Zauber endet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+2 Stufen in die Luft schleudern)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Elementarist",
        circle: 6,
        url: "/wiki/Feuergewebe",
        name: "Feuergewebe",
        threads: 1,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "WIL + 2/Physisch",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'pr',
        desc: ["Feuer. Dieser Zauber erschafft einen schützenden Umhang aus Flammen. Der Zauberer vollführt nähende Bewegungen, berührt dann das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, legt sich ein Umhang aus Feuer um das Ziel. Jeder, der das Ziel im Nahkampf angreift, erleidet in jeder Runde Schaden durch die starke Hitze, die der Umhang abgibt. Der Träger legt eine Wirkungsprobe ab, um zu bestimmen, wie viel Schaden verursacht wird. Die Hitze des Umhangs hat keine Wirkung auf den Träger."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 6,
        url: "/wiki/Frost_und_Hitze",
        name: "Frost und Hitze",
        threads: 3,
        weaving: 10,
        attune: 15,
        casting: "6",
        distance: "40 Schritt",
        dur: "Rang Minuten",
        area: "2 Schritt Radius",
        eff: "WIL + 2",
        eff_roll: {attribute: 'wil', mod: 2},
        desc: ["Feuer oder Wasser – Kälte. Dieser Zauber verursacht eine radikale Veränderung der Umgebungstemperatur. Der Zauberer schlingt die Arme um sich und zittert, als ob ihm kalt wäre, zeigt dann auf die Stelle, an der die Wirkung zentriert werden soll, und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, verändert sich die Temperatur im Wirkungsbereich je nach Wunsch des Zauberers zu extremer Hitze oder Kälte, sodass Wasser entweder kocht oder gefriert. Der Temperaturwechsel braucht dreißig Sekunden bis zum Erreichen der finalen Temperatur. Danach bestimmt in jeder Runde die Wirkungsprobe des Zauberers den Schaden, den ein Charakter erleidet, der sich durch den Wirkungsbereich bewegt oder sich in ihm befindet. Sobald der Zauber gewirkt wurde, kann der Wirkungsbereich nicht mehr bewegt werden. Dieser Zauber wird üblicherweise verwendet, um eine Barriere zu erschaffen und andere davon abzuhalten, eine bestimmte Stelle zu passieren."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Elementarist",
        circle: 6,
        url: "/wiki/Metallfl%C3%BCgel",
        name: "Metallflügel",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 10 Minuten",
        eff: "Flug; +6 auf Stärkeproben zum Heben",
        desc: ["Erde – Metall. Dieser Zauber erschafft glänzende Flügel aus Metall, die aus den Schultern eines Charakters wachsen und ihm Flugfähigkeit verleihen. Der Zauberer berührt die Schulter des Ziels, breitet dann seine Arme aus und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erscheinen silbern glänzende Metallflügel auf dem Rücken des Ziels. Mit den Flügeln kann das Ziel mit Bewegungsrate 12 fliegen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkung Verstärken (+2 Stärkebonus)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 6,
        url: "/wiki/Steinregen",
        name: "Steinregen",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        area: "2 Schritt Radius",
        eff: "WIL + 5/Physisch",
        eff_roll: {attribute: 'wil', mod: 5},
        eff_resist: 'pr',
        desc: ["Erde. Dieser Zauber lässt einen Schauer faustgroßer Steine vom Himmel fallen. Der Zauberer zeigt dorthin, wo die Steine niederfallen sollen, und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, werden die Ziele von fallenden Steinen getroffen. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden verursacht wird. In jeder Runde regnen mehr Steine auf die Ziele, die so lange Schaden erleiden, wie sie sich im Wirkungsbereich aufhalten. Jeder, der Schaden durch diesen Zauber erleidet, muss eine Niederschlagsprobe gegen den erlittenen Schaden ablegen. Die Bewegungsraten aller Ziele im Wirkungsbereich werden halbiert."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Elementarist",
        circle: 6,
        url: "/wiki/Umhang_des_Feuerpl%C3%BCnderers",
        name: "Umhang des Feuerplünderers",
        threads: 1,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "Elementaristenkreis + 2",
        desc: ["Feuer. Bindung. Dieser Zauber beschwört einen Feuerelementar und bindet ihn temporär an ein freiwilliges Ziel. Der Zauberer überschüttet das Ziel mit Funken, berührt es dann und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, brüllt das Ziel vor Zorn auf und wird in Flammen eingehüllt. Jeder, der das Ziel im Nahkampf angreift oder von ihm angegriffen wird, erleidet automatisch Schaden in Höhe des Ergebnisses der Wirkungsprobe (Physische Rüstung schützt). Die Schadensproben des Ziels addieren Bonuswürfel für den Feuerschaden in Höhe der Wirkungsstufe.", "In jeder Runde muss das Ziel die Kampfoption Aggressiver Angriff wählen (selbst wenn das normalerweise nicht erlaubt ist, wie etwa bei der Verwendung von Fernkampfwaffen), wodurch es allerdings keine Überanstrengung erleidet. Das Ziel muss entweder angreifen oder sich mit seiner vollen Bewegungsrate auf den nächsten Gegner zubewegen, mit der erklärten Absicht, diesen Gegner anzugreifen. Führt es keine der beiden Aktionen aus, verlässt der Feuerelementar das Ziel und fügt ihm Wirkungsstufe + 2 Schaden zu (Rüstung schützt nicht gegen diesen Schaden).", "Jeder Versuch, den Elementar zu täuschen, indem man einen Gegner nicht in einen Kampf verwickelt, lässt den Zauber sofort wie oben beschrieben enden. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein und ist inkompatibel mit den Zaubern Flammenwaffe und Feuergewebe. Der Zauberer kann zum Zeitpunkt des Wirkens die Wirkungsstufe auch senken."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Elementarist",
        circle: 7,
        url: "/wiki/Donnerschlag",
        name: "Donnerschlag",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "Selbst",
        dur: "2 Runden",
        area: "6 Schritt Radius",
        eff: "-6 auf Aktionsproben; verursacht Taubheit",
        desc: ["Luft. Dieser Zauber erschafft einen lauten Donnerschlag, der jeden, der ihn hört, betäubt und taub werden lässt. Der Zauberer klatscht in die Hände und vergleicht seine Spruchzauberei-Probe mit der Mystischen Verteidigung jedes Charakters, ob Freund oder Feind, im Wirkungsbereich. Wenn die Probe gelingt, erleidet das Ziel bis zum Ende der folgenden Runde einen Malus von -6 auf alle seine Aktionsproben. Außerdem ist es für weitere Stufe 6/W10 Runden taub und erleidet in dieser Zeit einen Malus von -6 auf alle Wahrnehmungsproben, die auf Gehör basieren. Die meisten nicht intelligenten Kreaturen fliehen aus Furcht vor dem Geräusch."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+2 Schritt)"},
            {txt: "Wirkung Verstärken (Malus -2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Ziele Ausnehmen (-Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 7,
        url: "/wiki/Erdwelle",
        name: "Erdwelle",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "6",
        distance: "Selbst",
        dur: "2 Stunden",
        area: "4 Schritt Radius",
        eff: "Erschafft Erdwelle",
        desc: ["Erde. Dieser Zauber erschafft eine Welle aus Erde, die die Reisegeschwindigkeit erhöht. Der Zauberer muss auf Erde oder Stein stehen, kniet nieder und bewegt seine Hände über den Boden. Dann legt er eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, wird das Stück Boden, auf dem er steht, zu einer Welle aus Erde, auf der er mit einer Bewegungsrate von 16 durch Gebiete reiten kann, die keine offensichtlichen Hindernisse (z. B. Felsen, Bäume, Häuser usw.) enthalten. Wenn die Welle (nach Maßgabe des Spielleiters) auf ein festes Hindernis trifft, endet der Zauber sofort."],
        as: {txt: "Wirkungsdauer Verlängern (+1 Stunde)", what: ['dur'], mod: 1},
        at: [{txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+1 Stunde)"}]
    },
    {
        discipline: "Elementarist",
        circle: 7,
        url: "/wiki/Todesregen",
        name: "Todesregen",
        threads: 3,
        weaving: 11,
        attune: 16,
        casting: "MVE",
        distance: "Selbst",
        dur: "Rang Runden",
        area: "20 Schritt Radius",
        eff: "Stufe 8 (WIL + 8; siehe Text)/Physisch",
        eff_roll: {attribute: 'wil', mod: 8},
        eff_resist: 'pr',
        desc: ["Wasser – Säure. Dieser Zauber lässt einen Säureregen vom Himmel fallen. Er benötigt einen wolkenbedeckten Himmel, entweder natürlich oder durch Magie erzeugt (wie etwa durch den Zauber Wolken Beschwören, S. 173). Der Zauberer ruft die Namen seiner befreundeten Charaktere laut aus und vergleicht dann seine Spruchzauberei-Probe mit der Mystischen Verteidigung jedes nicht genannten Ziels im Wirkungsbereich. Wenn die Probe gelingt, fällt aus den Wolken Säureregen auf das Ziel. In jeder Runde, in der sich das Ziel im Wirkungsbereich des Zaubers aufhält, erleidet es Stufe 8/2W6 Schaden. Der Zauberer und die von ihm beim Wirken des Zaubers genannten Charaktere werden nicht verletzt. Wenn der Zauberer sich auf den Zauber konzentriert, nimmt der Säureregen an Intensität zu, und der Zauberer addiert seine Willenskraftstufe zur Schadensprobe des Regens in dieser Runde. Sobald seine Konzentration einmal gestört worden ist, kann er sie nicht wieder aufnehmen, ohne den Zauber neu zu wirken. Selbst wenn der Zauberer seine Konzentration verliert, wirkt der Zauber weiter, bis er endet. Während der Wirkungsdauer bleibt der Wirkungsbereich an Ort und Stelle und bewegt sich nicht."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt Radius)"}],
    },
    {
        discipline: "Elementarist",
        circle: 7,
        url: "/wiki/Umhang_des_Blutelfen",
        name: "Umhang des Blutelfen",
        threads: 1,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "Ignoriert Wundmodifikatoren und erschafft temporäre Hindernisse – für einen Preis, der in Blut gezahlt wird",
        desc: ["Holz. Bindung. Dieser Zauber beschwört einen Holzelementar und bindet ihn temporär an ein freiwilliges Ziel. Der Zauberer sticht das Ziel mit einem Dorn und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, stoßen Dornen durch das Fleisch des Ziels, und es erleidet augenblicklich eine Wunde. Das Ziel ist allerdings für die Wirkungsdauer des Zaubers immun für Modifikatoren durch Wunden. Aus diesem Grund werden viele Dämonen das Ziel für diese Zeit ignorieren.", "Das Ziel kann Überanstrengung bis zur Höhe seiner Willenskraftstufe erleiden, um in maximal 10 Schritt Entfernung eine Anzahl von 2 mal 2 Schritt großen Dornengestrüpp-Abschnitten gleich der erlittenen Überanstrengung wachsen zu lassen. Das Gestrüpp wird vom Blut des Ziels ernährt und wächst – hungrig nach mehr Blut – schnell aus dem Boden. Jeder Charakter, abgesehen vom Ziel, der mit dem Gestrüpp in Kontakt kommt, erleidet Stufe 4/W6 Schaden. Gegen diesen Schaden schützt keine Rüstung."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (von Berührung auf 10 Schritt)"},
            {txt: "Wirkung Verstärken (Schadensstufe +2)"}]
    },
    {
        discipline: "Elementarist",
        circle: 7,
        url: "/wiki/Wirbelwind",
        name: "Wirbelwind",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "6MVG",
        distance: "20 Schritt",
        dur: "Rang Runden",
        area: "4 Schritt Radius",
        eff: "WIL + 2/Physisch",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'pr',
        desc: ["Luft. Dieser Zauber erschafft eine wirbelnde Luftsäule. Der Zauberer vollführt mit seinen Fingern wirbelnde Bewegungen und legt dann eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, bildet sich eine 4 Schritt hohe Säule aus Wind, die wild um ihn herumwirbelt. In jeder Runde kann sich der Zauberer konzentrieren und den Wirbelwind auf einen oder mehrere Charaktere innerhalb der Zauberreichweite loslassen. Der Zauberer legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe, wie viel Schaden verursacht wird. Alle Ziele im Wirkungsbereich sind Bedrängt. Hört der Zauberer auf, sich zu konzentrieren, löst sich der Wirbelwind auf und der Zauber endet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Ziele Ausnehmen (-Rang)"}]
    },
    {
        discipline: "Elementarist",
        circle: 7,
        url: "/wiki/Wolken_Beschw%C3%B6ren",
        name: "Wolken Beschwören",
        threads: 3,
        weaving: 11,
        attune: 16,
        casting: "VAR",
        distance: "1 Meile (s. Text)",
        dur: "Rang Stunden",
        eff: "WIL + 6",
        eff_roll: {attribute: 'wil', mod: 6},
        desc: ["Luft. Dieser Zauber beschwört eine Wolkendecke als Vorbereitung für einen anderen Zauber, wie etwa Todesregen (S. 172), oder einfach um beeindruckende Wettereffekte zu erzeugen. Der Zauberer imitiert mit Gesten das wirbelnde Muster sich schnell bewegender Wolken, schleudert dann etwas Wasser in die Luft und legt eine Spruchzauberei-Probe gegen einen Mindestwurf ab, der von der Wolkenart abhängt. Das Beschwören normaler Wolken hat einen Mindestwurf von 8, stürmisches Wetter einen Mindestwurf von 13 und Orkanstürme einen Mindestwurf von 20 (oder mehr, je nach Maßgabe des Spielleiters). Wenn die Probe gelingt, bläht sich das Wasser zu einem Wolkenfragment auf, steigt schnell in den Himmel hinauf und wirkt wie ein \"Magnet\", der andere Wolken anzieht.", "Unter normalen Umständen brauchen die Wolken eine Stunde, um anzukommen; Sturmwolken können noch länger brauchen. Der Zauberer legt eine Wirkungsprobe ab und zieht das Ergebnis in Minuten von der Ankunftszeit der Wolken ab. Der Zauber kann mehrmals gewirkt werden, um die Ankunft der Wolken zu beschleunigen. Die Wirkung zentriert sich auf die Position des Zauberers zum Zeitpunkt des ersten Wirkens; sie bewegt sich nicht mit ihm mit. Die Zauberreichweite bestimmt auch den Radius des Bereichs, der durch die Wolken bedeckt wird. Der Zauberer kann jede Art natürlicher Wolken beschwören, die er schon einmal gesehen oder erlebt hat. Wenn er noch nie während eines Sturms im Freien gewesen ist, kann er diese Art Wetter nicht heraufbeschwören."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}],
    },
    {
        discipline: "Elementarist",
        circle: 8,
        url: "/wiki/Eisenhaut",
        name: "Eisenhaut",
        threads: 1,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "+3 auf Physische Rüstung, Wundschwelle und Niederschlagsproben",
        desc: ["Erde – Metall. Dieser Zauber verschmilzt den Körper des Ziels mit einer Art von elementarem Metall, das ihn stärkt. Der Zauberer umfasst ein Stück Metall, kreuzt beide Fäuste und schlägt das Ziel. Dann legt er eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel jeweils +3 auf seine Physische Rüstung, Wundschwelle und Niederschlagsproben. Die Wirkung dieses Zaubers spiegelt sich in der Erscheinung des Ziels wider, das ein dunkles, metallisches Aussehen annimmt. Außerdem verdoppelt sich das Gewicht des Ziels, und es verliert jeglichen Auftrieb und damit auch die Fähigkeit zu schwimmen (der Zauber verbessert nicht die Atemprozesse des Ziels; es wäre also eine bemerkenswert dumme Idee, diesen Zauber auf einen Verbündeten zu wirken, der gerade im Wasser treibt)."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+1 auf alle Boni)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 8,
        url: "/wiki/Erdwand",
        name: "Erdwand",
        threads: 3,
        weaving: 12,
        attune: 17,
        casting: "10",
        distance: "20 Schritt",
        dur: "Rang Stunden",
        eff: "Erschafft eine zusammenhängende Erdwand",
        desc: ["Erde. Dieser Zauber beschwört eine Wand aus Erde. Der Zauberer muss auf Erde oder Stein stehen, macht schaufelnde Bewegungen, als ob er einen Erdwall aushebt, und legt dann eine Spruchzauberei(10)-Probe ab. Wenn die Probe gelingt, beschwört er eine maximale Anzahl von Wandstücken gleich seinem Rang in Spruchzauberei, von denen jedes 4 Schritt hoch, 2 Schritt breit und 2 Schritt dick ist. Das Beschwören und Positionieren eines Wandstückes erfordert 1 Runde Zeit und die Konzentration des Zauberers. Die Wand kann nicht auf einem Lebewesen platziert werden; wenn der Zauberer dies versucht, wird das Wandstück sofort zerstört, zählt aber weiterhin gegen die maximale Anzahl von Wandstücken, die beschworen werden kann. Die Wand kann physisch oder magisch angegriffen werden. Jeder Wandabschnitt gilt als Barriere mit einer Physischen und Mystischen Rüstung von jeweils 12 und einer Todesschwelle von 40."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"},
            {txt: "Zusätzliche Abschnitte (+2)"}],
    },
    {
        discipline: "Elementarist",
        circle: 8,
        url: "/wiki/Giftiger_Zorn",
        name: "Giftiger Zorn",
        threads: 1,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "+3 auf Nahkampfschadensproben und Gift",
        desc: ["Holz. Dieser Zauber verstärkt eine Nahkampfwaffe mit elementarer Kraft. Der Zauberer stößt einen Kampfschrei aus, berührt dann die Nahkampfwaffe, die vom Ziel gehalten wird, und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, glänzt die Waffe hellgrün und erscheint ölig und schlüpfrig. Sie addiert +3 zu Schadensproben und vergiftet den Gegner, wenn mindestens ein Schadenspunkt verursacht wird. Das Gift führt zur Lähmung, mit einer Verzögerung von Sofort und einer Mystischen Verteidigung und Stufe gleich dem Elementaristenkreis des Zauberers +3.", "Wenn ein Gegner durch das Gift vergiftet wird, wird die Wirkungsprobe (die mit der Giftstufe abgelegt wird) mit der Zähigkeitsstufe des Gegners verglichen. Für jeden Erfolg erleidet der Gegner einen Malus von -2 auf alle Aktionsproben. Wenn der Gesamtmalus mindestens gleich der Stärkestufe des Gegners ist, ist er vollkommen gelähmt und kann sich nicht bewegen. Er fällt hin und kann keinerlei Proben (außer Widerstandsproben) ablegen, bis der Malus gesenkt wurde. Die Wirkung des Giftes verfliegt, wenn der Zauber endet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Schadensbonus +1)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Elementarist",
        circle: 8,
        url: "/wiki/Heilquelle",
        name: "Heilquelle",
        threads: 1,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Berührung",
        dur: "1 Runde",
        area: "10 Schritt Radius",
        eff: "Heilt alle Verbündeten im Wirkungsbereich",
        desc: ["Wasser. Dieser Zauber heilt alle Verbündeten des Zauberers im Wirkungsbereich. Der Zauberer kniet nieder und legt seine Handfläche auf den Boden, schließt die Augen, vergießt eine Träne und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, dringt aus dem Boden im Wirkungsbereich hell funkelndes, sprudelndes Wasser und steigt himmelwärts, wobei es jeden Betroffenen erfrischt. Alle Ziele im Wirkungsbereich dürfen eine Erholungsprobe ablegen. Der Zauberer kann den Zielen seine eigenen Erholungsproben geben, damit sie sie mit dem Zauber nutzen können (nur eine Erholungsprobe pro Ziel). Ziele, die keine Erholungsprobe übrig haben, sind vom Zauber nicht betroffen."],
        as: {txt: "Wirkung Verstärken (Erholungsprobenbonus +2)"},
        at: [{txt: "Wirkung Verstärken (Erholungsprobenbonus +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Elementarist",
        circle: 8,
        url: "/wiki/Im_W%C3%BCrgegriff_der_Erdhand",
        name: "Im Würgegriff der Erdhand",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        eff: "WIL + 2/Physisch",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'pr',
        desc: ["Erde. Dieser Zauber lässt eine massive Hand aus dem Boden schießen und einen Charakter ergreifen, der auf Erde oder Stein steht, und übt dabei eine zerquetschende Kraft auf ihn aus. Der Zauberer schüttelt seine Faust gegen das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt die Wirkungsprobe des Zauberers, wie viel Schaden in jeder Runde verursacht wird; dies erfordert die Konzentration des Zauberers, oder der Zauber endet. Das Ziel darf in jeder Runde eine Stärkeprobe gegen die Wirkungsstufe ablegen, um sich zu befreien; ansonsten kann es keine anderen Aktionen ausführen, während es im Griff des Zaubers gefangen ist."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Elementarist",
        circle: 8,
        url: "/wiki/Umhang_der_Gewittervorhut",
        name: "Umhang der Gewittervorhut",
        threads: 3,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang x 10 Minuten",
        eff: "Ziel erhält Flugfähigkeit und erhöhte Geschwindigkeit",
        desc: ["Luft – Elektrizität. Bindung. Dieser Zauber – der einen wolkenbedeckten Himmel benötigt – beschwört einen Luftelementar und bindet ihn temporär an ein freiwilliges Ziel. Der Zauberer reckt einen Arm gen Himmel und berührt mit der anderen Hand das Ziel. Dann legt er eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, trifft ein Blitz seine ausgestreckte Hand und springt auf das Ziel über, wodurch es vom Boden gehoben wird, während Elektrizität durch seinen Körper fließt.", "Das Ziel erhält eine fliegende Bewegungsrate von 16 und kann sich, solange es sich konzentriert, mit einem elektrischen Feld von 2 Schritt Radius umgeben, das alle freiwilligen Ziele im Wirkungsbereich levitiert. Dadurch können sie mit dem Ziel reisen. Führt das gebundene Ziel diese Aktion aus, kann es sich nur bewegen und Freie Aktionen ausführen.", "Das gebundene Ziel erhält einen Bonus von +2 auf Initiativeproben. Die Anwesenheit des Ziels wird durch den Zauber immer verraten, und es kann keine Überraschungsangriffe oder Angriffe aus dem Totem Winkel durchführen.", "Wenn das Ziel aus irgendeinem Grund den Boden berührt, endet der Zauber augenblicklich. Sollte der Zauber aus irgendeinem Grund vorzeitig enden, erleidet das Ziel eine Wunde, und dieser Zauber darf erst wieder nach einem Tag gewirkt werden. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein."],
        as: {txt: "Wirkungsdauer Verlängern (+10 Minuten)", what: ['dur'], mod: 10},
        at: [{txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkung Verstärken (Initiative +2)"},
            {txt: "Wirkungsdauer Verlängern (+10 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Astralspeer",
        name: "Astralspeer",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "1 Runde",
        eff: "WIL + 4/Mystisch",
        eff_roll: {attribute: 'wil', mod: 4},
        eff_resist: 'mr',
        desc: ["Dieser Zauber webt Energie aus dem Astralraum zu einem Phantomspeer. Der Zauberer bewegt seinen Arm nach hinten, lässt ihn dann nach vorne schnellen, als ob er einen Speer schleuderte, und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bildet sich ein ätherischer Speer, der die Entfernung bis zum Ziel überbrückt und es trifft. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden verursacht wird."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/%C3%84therische_Finsternis",
        name: "Ätherische Finsternis",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        area: "4 Schritt Radius",
        eff: "Erschafft magische Dunkelheit",
        desc: ["Dieser Zauber zieht ein Stück Dunkelheit aus einer anderen Dimension. Der Zauberer legt seine Hände zusammen, berührt dann den Zielcharakter, -gegenstand oder -ort, befiehlt der Dunkelheit, hervorzukommen, und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, füllt die so beschworene Dunkelheit eine Kugel von 4 Schritt Radius, mit dem Ziel im Zentrum.", "Die Dunkelheit löscht sämtliches Licht, wodurch alle im Wirkungsbereich des Zaubers den Malus für Volle Dunkelheit auf alle auf Sicht basierenden Aktionsproben erleiden. Gewöhnliches Licht durchdringt die Ätherische Finsternis nicht. Dieser Zauber wirkt auch gegen Charaktere mit Wärmesicht. Gegen Charaktere, die die Geisterbeschwörung beherrschen, wirkt dieser Zauber nicht – sie können normal sehen, als ob der Zauber nie gewirkt worden wäre."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Augenblick_des_Todes",
        name: "Augenblick des Todes",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang + 5 Runden",
        eff: "WIL + 5",
        eff_roll: {attribute: 'wil', mod: 5},
        desc: ["Mit diesem Zauber kann ein Zauberer die letzten Momente im Leben eines toten Charakters zu sehen und zu erleben. Hierfür stellt der Zauberer eine Verbindung mit der Geisterwelt her, um die Todesumstände des Charakters nachzuvollziehen. Der Zauberer schließt die Augen, zeigt dann mit seinen Handflächen auf die Leiche und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung ab, die sie zu Lebzeiten hatte. Wenn die Probe gelingt, erlebt der Zauberer die letzten Runden des Lebens des Ziels erneut, die mit dem Tod des Ziels enden.", "Der Zauberer muss sich in eine Trance versetzen und sich konzentrieren, um den Zauber aufrechtzuerhalten. Während er in diesem Zustand ist, erlebt er alles aus Sicht des Verstorbenen. Leider bedeutet das auch, dass er sämtlichen Schaden erleidet, den der Verstorbene vor seinem Tod erlitt.", "Die Wirkungsprobe des Zauberers verleiht ihm zeitweilige Schadenspunkte. Jeder Schaden, den der Zauberer erleidet, verringert zuerst die zeitweiligen Schadenspunkte, bevor er zu seinem Aktuellen Schaden addiert wird (Mystische Rüstung schützt gegen diesen Schaden). Der Zauberer kann durch die Wirkung dieses Zaubers keine Wunden erleiden. Wenn sein Aktueller Schaden aber seine Bewusstlosigkeits- bzw. Todesschwelle erreicht oder übersteigt, wird er dennoch bewusstlos bzw. stirbt."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Dunkler_Bote",
        name: "Dunkler Bote",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Stunden",
        eff: "Schickt nachtaktives Flugtier, um Botschaft zu überbringen",
        desc: ["Dieser Zauber befiehlt einem nachtaktiven Flugtier, eine Botschaft zu überbringen. Er muss nach Sonnenuntergang auf ein solches Tier gewirkt werden, das bereits unter der Kontrolle des Zauberers steht, entweder weil es ein Tiergefährte ist oder unter dem Einfluss des Talents Nachtflieger Befehligen (S. 94) steht. Die Botschaft muss kurz sein – sie darf nicht mehr als Spruchzauberei- Rang x 2 Wörter enthalten.", "Der Zauberer streichelt das Tier, flüstert ihm die Botschaft zu, benennt den Empfänger und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Tiers ab. Wenn die Probe gelingt, fliegt das Tier los, sucht zielsicher den Empfänger der Botschaft auf und überbringt sie in einer flüsternden Version der Stimme des Zauberers. Wenn das Tier den Empfänger der Nachricht nicht erreicht, bevor der Zauber endet oder die Sonne aufgeht (das frühere der beiden Ereignisse), ist die Nachricht verloren."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkung Verstärken (+Rang Wörter)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Geisterhand",
        name: "Geisterhand",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "2 Runden",
        eff: "WIL + 2/Mystisch; -2 auf Körperliche und Mystisch Verteidigung",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'mr',
        eff_mod: [{what: 'kv', mod: -2}, {what: 'mv', mod: -2}],
        desc: ["Dieser Zauber verwendet die boshafte Energie der Geister der Toten, um andere zu verletzen. Der Zauberer berührt das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe, wie viel Schaden verursacht wird. Bis zum Ende der nächsten Runde werden außerdem die Körperliche und Mystische Verteidigung des Ziels jeweils um 2 gesenkt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [
            {txt: "Wirkung Verstärken (Verteidigungswerte -1)", what: ['kv', 'mv'], mod: 1},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff'], mod: 2}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Geisterpfeil",
        name: "Geisterpfeil",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "2 Runden",
        eff: "WIL + 2/Mystisch; -2 auf Mystische Rüstung",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'mr',
        eff_mod: [{what: 'mr', mod: -2}],
        desc: ["Dieser Zauber greift einen Charakter mit einem kleinen Pfeil aus Astralenergie an. Der Zauberer zwickt sich selbst, bewegt sein Handgelenk, als ob er einen Wurfpfeil schleuderte, und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt die Wirkungsprobe, wie viel Schaden verursacht wird. Nachdem der Schaden verursacht wurde, wird die Mystische Rüstung des Ziels bis zum Ende der nächsten Runde um 2 gesenkt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [
            {txt: "Reichweite Erhöhen (+10 Schritt)", what: ['dist'], mod: 10},
            {txt: "Wirkung Verstärken (Mystische Rüstung -2)", what: ['mr'], mod: -2},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
            {txt: "Zusätzliches Ziel (+1)", what: ['addtargets'], mod: 1}
        ]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Kleiner_Bannkreis",
        name: "Kleiner Bannkreis",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "6MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        area: "4 Schritt Radius",
        eff: "WIL + 2/Mystisch",
        eff_roll: {attribute: 'wil', mod: 2},
        desc: ["Dieser Zauber erschafft einen magischen Kreis, der Untote, Dämonen und Dämonenkonstrukte abwehrt. Der Zauberer spuckt in die Hände, umreißt dann schnell mit seinen Fingern einen Kreis von 4 Schritt Radius und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, widersteht der Kreis allen Versuchen von Untoten, Dämonen oder Dämonenkonstrukten, in ihn einzudringen. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Wesens ab. Wenn die Probe gelingt, wehrt der Kreis das Wesen ab und verletzt es. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden bei dem Wesen verursacht wird.", "Der Zauber kann nur eine Kreatur pro Runde abwehren. Mehrere Feinde können den Kreis also ohne Weiteres überrennen, wenn sie ihn umzingeln. Wenn mehr als eine Wesenheit den Kreis betritt, versucht der Kreis, das Wesen mit der höchsten Mystischen Verteidigung abzuwehren. Mit genügend Vorbereitungszeit kann ein Zauberer mehrere Kleine Bannkreise wirken und so konzentrische Kreise erschaffen, die diejenigen im innersten Kreis schützen und einige Minuten lang vor mehreren Wesen Schutz bieten können."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Knochenkreis",
        name: "Knochenkreis",
        threads: 3,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Monate",
        area: "2 Schritt Radius",
        eff: "Kreis des Geisterbeschwörers",
        desc: ["Dieser Ritualzauber lädt einen wandernden Geist ein, in einem Kreis aus Knochen zu leben, und verwandelt ihn in einen Knochengeist. Die Knochen mindestens eines Tieres werden für den Bau eines Knochenkreises verwendet, der nicht größer als der Wirkungsbereich sein darf. Der Zauberer verbringt pro Zauberfaden eine Stunde damit, die Grenzen des Kreises abzugehen, wobei er magische Inschriften anbringt und die Tierknochen so platziert, dass sie den Rand des Kreises bilden. Nachdem er den Kreis vervollständigt hat, berührt er die Knochen und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Geistes ab. Wenn die Probe gelingt, wird ein Knochengeist beschworen, der fortan in dem Kreis lebt.", "Der Geist ist ein Verbündetengeist mit einer Stärke, die maximal so hoch sein kann wie der Kreis des Zauberers in der Disziplin Geisterbeschwörer. Er ist nicht besonders intelligent und hat Grenzen bezüglich der Kräfte, die er besitzen kann. Die Kräfte des Knochengeistes werden ausgewählt, wenn der Knochenkreis erschaffen wird, und er darf nur die folgenden Geisterkräfte haben: Beschwörer Unterstützen, Böser Blick, Manifestation, Unempfindlichkeit und Verwirrung. Er kann den Knochenkreis nicht verlassen, aber er wird jeden angreifen, der den Kreis betreten will oder sich bereits in ihm befindet.", "Einige Zauber, wie etwa Grabesbotschaft oder Geisterportal, benötigen einen Knochenkreis. Ein Zauberer kann maximal so viele Knochenkreise gleichzeitig aktiv haben, wie sein Rang in Spruchzauberei beträgt.", "Das Zerstreuen der Knochen und Vernichten der magischen Inschriften reicht nicht aus, um einen Knochenkreis zu zerstören – es macht es nur komplizierter, die Grenzen des Kreises zu sehen und den Geist nicht zu stören, der in ihm lebt. Ein Knochenkreis kann neutralisiert werden, aber der Zauberer muss dafür den Kreis berühren und riskiert dadurch einen Angriff durch den Geist. Der Knochengeist greift seinen Beschwörer nicht an, kann aber ansonsten nicht kontrolliert werden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Monate)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Monate)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Schattenverschmelzung",
        name: "Schattenverschmelzung",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+4 auf Proben auf Heimlicher Schritt",
        desc: ["Dieser Zauber lässt einen Charakter in den Schatten praktisch unsichtbar werden. Der Zauberer legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel während der Wirkungsdauer des Zaubers einen Bonus von +4 auf Proben auf Heimlicher Schritt, wenn es sich in der Nähe von Schatten aufhält, und darf Heimlicher Schritt als improvisierte Fertigkeit verwenden, wenn es sie nicht besitzt. Obwohl das Ziel bei Licht normal sichtbar ist, beendet Licht nicht die Wirkungsdauer des Zaubers; das Ziel wird wieder praktisch unsichtbar, indem es einfach wieder in einen Schatten tritt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Seelenlose_Augen",
        name: "Seelenlose Augen",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Minuten",
        eff: "+3 auf Einschüchterungsproben",
        desc: ["Dieser Zauber verstärkt die Fähigkeit des Ziels, andere einzuschüchtern. Traditionell verleiht er den Augen des Ziels einen grausamen Blick, sodass Betrachter keinen Zweifel daran haben, was das Ziel zu tun bereit ist, auch wenn es sich bei einigen Zauberern auf andere Weise manifestiert. Der Zauberer starrt und lächelt bösartig, legt dann seine Hand auf das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel einen Bonus von +3 auf alle Einschüchterungsproben, die es während der Wirkungsdauer des Zaubers ablegt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 1,
        url: "/wiki/Seelenr%C3%BCstung",
        name: "Seelenrüstung",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        eff: "+3 auf Mystische Rüstung",
        desc: ["Dieser Zauber verstärkt die Mystische Rüstung eines Charakters. Der Zauberer zeichnet gezackte blaue Sigillen des Schutzes in die Luft und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erscheint eine blau schimmernde Kettenrüstung, die das Ziel kurz bedeckt, bevor sie in seinen Körper sinkt. Das Ziel addiert +3 auf seine Mystische Rüstung."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Mystische Rüstung +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 2,
        url: "/wiki/Aspekt_des_Nebelgeistes",
        name: "Aspekt des Nebelgeistes",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "+3 auf Angriffs- und Schadensproben im Nahkampf, +3 auf Körperliche Verteidigung",
        desc: ["Bindung. Dieser Zauber zieht Nebel aus der umgebenden Luft zusammen, und der Zauberer kann einen bösartigen Geist an ein freiwilliges Ziel in dem Nebel binden, wenn der Zauber gewirkt wird. Der Zauberer bläst in die Luft und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel für die Wirkungsdauer des Zaubers einen Bonus von +3 auf seine Angriffs- und Schadensproben im Nahkampf. Während dieser Zeit wird der Geist es drängen, in jeder Runde das am nächsten stehende Ziel anzugreifen, mit der Ausnahme von Geistern und Untoten. Will das Ziel diesem Drang widerstehen, kann es eine Willenskraftprobe gegen die Soziale Verteidigung des Geistes (12) ablegen.", "Wenn das Ziel erfolgreich dem Drang widersteht oder es einen Geist oder Untoten angreift, endet der Zauber, und der gebundene Geist verlässt das Ziel augenblicklich (und wird sehr wahrscheinlich einen Groll gegen das Ziel hegen). Dieser Zauber und der Zauber Nebelgeist Beschwören können dann erst nach einem Tag wieder gewirkt werden. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein (einschließlich Nebelgeist Beschwören).", "Dieser Zauber kann in derselben Zaubermatrix gespeichert werden wie der Zauber Nebelgeist Beschwören."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +1)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 2,
        url: "/wiki/Kreis_der_K%C3%A4lte",
        name: "Kreis der Kälte",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        area: "2 Schritt Radius",
        eff: "Geisterbeschwörerkreis + 4/Mystisch",
        desc: ["Wasser – Kälte. Dieser Zauber erzeugt einen Kreis aus eisigem Nebel. Der Zauberer dreht sich im Kreis, hält dann plötzlich an, um niederzuknien und den Boden zu berühren, und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung aller Charaktere im Wirkungsbereich ab. Wenn die Probe gelingt, erscheint eine unheimliche Rune (die bei jedem Zauberer anders aussieht) auf dem Boden, und eine Wolke gefrierenden Nebels steigt aus dem leuchtenden Zeichen empor. Alle Charaktere, außer dem Zauberer, erleiden pro Runde Schaden gleich dem Kreis des Geisterbeschwörers + 4, und ihre Bewegungsrate ist halbiert, solange sie sich im Wirkungsbereich aufhalten."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Ziele Ausnehmen (-Rang)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 2,
        url: "/wiki/Nebelgeist_beschw%C3%B6ren",
        name: "Nebelgeist beschwören",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Geisterbeschwörerkreis + 10/Mystisch",
        desc: ["Beschwörung. Dieser Zauber zieht Nebel aus der umgebenden Luft zusammen und bringt einen bösartigen Geist dazu, ihn zu bewohnen. Der Zauberer bläst in die Luft und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Geistes (siehe unten) ab; der Zauberer kann auch einen niedrigeren Kreis für die Zauberwirkung auswählen. Wenn die Probe gelingt, erscheint der Nebelgeist innerhalb der Zauberreichweite dort, wo es der Zauberer will, und greift sofort den nächsten Charakter an (sogar den Zauberer selbst). In jeder Runde greift der Nebelgeist wahllos den Charakter an, der ihm am nächsten ist. Er verwendet die Wirkungsstufe des Zaubers für seine Angriffs- und Schadensproben, bis er zerstört wird oder der Zauber endet.", "Der Nebel ist fast undurchdringlich für physische Angriffe, aber die astrale Struktur, die den Geist enthält, kann von Angriffen verdrängt werden, die auf die Mystische Verteidigung (Geisterbeschwörerkreis + 5) oder die Körperliche Verteidigung (Geisterbeschwörerkreis + 15) des Geistes abzielen. Um die  Struktur erfolgreich zu verdrängen, muss ein Charakter mit einem einzelnen Angriff einen höheren Schaden verursachen, als die Wirkungsstufe beträgt. Die Zerstörung des Nebels verletzt nicht den Geist, der einfach in die Anderwelten zurückkehrt und auf eine weitere Gelegenheit wartet, den Lebenden Schaden zuzufügen. Ein Nebelgeist greift keine Untoten oder andere Geister an. Der Zauber kann nicht in der Wüste oder in anderen sehr trockenen Umgebungen gewirkt werden, und auch nicht, wenn die Temperatur unterhalb des Gefrierpunktes liegt. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein (einschließlich Aspekt des Nebelgeistes).", "Dieser Zauber kann in derselben Zaubermatrix gespeichert werden wie der Zauber Aspekt des Nebelgeistes."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 2,
        url: "/wiki/Nebelschild",
        name: "Nebelschild",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang + 5 Runden",
        eff: "+4 auf Proben auf Hieb Ausweichen",
        desc: ["Dieser Zauber erschafft einen Schild aus Nebel, der sich verhärtet und Hiebe aufhält, die gegen den Zauberer gerichtet sind. Der Zauberer bewegt seine Hände über seinen Körper, während Nebelschwaden aus seinen Fingerspitzen strömen. Dann legt er eine Spruchzauberei-Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, erhält er einen Bonus von +4 auf Proben auf Hieb Ausweichen gegen Nah- und Fernkampfangriffe, die gegen ihn gerichtet sind. Gelingt die Probe auf Hieb Ausweichen, wehrt der Nebel den Angriff ab, und der Zauberer erleidet keinen Schaden. Der Zauberer ist innerhalb des Nebels sichtbar, und er kann leicht hindurchsehen. Der Nebel behindert ihn nicht in seinen Aktionen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 2,
        url: "/wiki/Sch%C3%A4del_des_Todes",
        name: "Schädel des Todes",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang + 5 Runden",
        eff: "Anwendung von Verängstigen als Einfache Aktion",
        desc: ["Dieser Zauber verwandelt den Kopf des Zauberers in einen blutüberströmten Schädel und versetzt alle, die er ansieht, in Angst und Schrecken. Der Zauberer berührt sein Gesicht und legt eine Spruchzauberei-Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, kann er für die Wirkungsdauer des Zaubers sein Talent Verängstigen als Einfache Aktion anwenden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2 auf Verängstigen)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 2,
        url: "/wiki/Schattengefl%C3%BCster",
        name: "Schattengeflüster",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "100 Schritt",
        dur: "Rang + 5 Minuten",
        eff: "Durch einen Schatten lauschen",
        desc: ["Mit diesem Zauber kann der Zauberer alles hören, was ein Ziel in der Nähe eines Schattens spricht. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, hört er jedes Geräusch, das das Ziel verursacht, solange es nicht mehr als 2 Schritt von einem Schatten (einschließlich seines eigenen Schattens) entfernt ist. Das Ziel kann eine Wahrnehmungsprobe gegen das Ergebnis der Spruchzauberei-Probe ablegen. Wenn die Probe gelingt, bemerkt es, dass es irgendwie beobachtet wird."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+2 Schritt Entfernung vom Schatten)"},
            {txt: "Reichweite Erhöhen (+50 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 2,
        url: "/wiki/Schneide_der_Nacht",
        name: "Schneide der Nacht",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "Addiert Stufe 3/W4 Kälteschaden zur Waffe/ Physisch und senkt Mystische Verteidigung des Ziels um 2",
        desc: ["Wasser – Kälte. Dieser Zauber bedeckt eine Waffe mit einer Schicht aus tintenschwarzem Frost, der direkt aus dem Astralraum gezogen wird. Der Zauberer atmet in seine geballte Faust aus und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wirbeln schattige Tentakel aus gefrierendem Nebel aus seiner Faust und umhüllen die Waffe. Der Träger der Waffe addiert einen W4-Bonuswürfel zur Schadensprobe der Waffe, und jedes Ziel, das Schaden durch die Waffe erleidet, erhält bis zum Ende der nächsten Runde einen Malus von -2 auf seine Mystische Verteidigung. Der Zauber kann auf Waffen aus jedem Material – Holz, Metall, Knochen und so weiter – gewirkt werden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Schadensstufe +2)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 3,
        url: "/wiki/Aspekt_des_feigen_Herumschleichens",
        name: "Aspekt des feigen Herumschleichens",
        threads: 3,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "Gewährt einem Ziel überlegene Kundschafterfähigke – mit Nebenwirkungen",
        desc: ["Bindung. Dieser Zauber beschwört einen Geist des Schattens und bindet ihn zeitweise an ein freiwilliges Ziel. Der Zauber greift in seinen eigenen Schatten und zieht eine Handvoll einer tintenschwarzen Substanz hervor. Er verschmiert sie auf dem Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, materialisiert sich der Geist über dem Ziel und verschmilzt mit ihm. Das Ziel kauert sich augenblicklich nieder und nimmt ein eichhörnchenähnliches Verhalten an.", "Das Ziel des Zaubers erhält einen Bonus von +4 auf Proben, die auf Wahrnehmung basieren, um Informationen aus direkter Beobachtung zu erlangen, und auf Aktionsproben, um der Entdeckung zu entgehen. Es kann sich dabei auch mit voller Geschwindigkeit bewegen. Alle aktiven Drohungen gegen das Ziel führen dazu, dass es sofort mit Höchstgeschwindigkeit in Sicherheit flieht. Danach endet der Zauber augenblicklich, und das Ziel muss innerhalb der nächsten Stunde vor jeder Bedrohung fliehen. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 3,
        url: "/wiki/Aspekt_des_Knochengeistes",
        name: "Aspekt des Knochengeistes",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "Bindet einen Knochengeist",
        desc: ["Bindung. Dieser Zauber beschwört den Knochengeist aus einem der Knochenkreise des Zauberers (der maximal Spruchzauberei- Rang des Zauberers x 10 Meilen entfernt sein darf) und bindet ihn zeitweise an ein freiwilliges Ziel. Der Zauberer nimmt zwei Knochen, wirft einen zu Boden, stampft einmal darauf und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, materialisiert sich der Knochengeist und verschmilzt mit dem Ziel. Das Aussehen des Ziels wird bleich und verblasst, und seine Knochen stehen viel deutlicher hervor. Das Ziel erhält einen Bonus von jeweils +4 auf seine Mystische Verteidigung und seine Mystische Rüstung.", "Wenn das Ziel während der Wirkungsdauer des Zaubers nicht auf die Befehle des Zauberers hört, endet der Zauber sofort. Endet der Zauber vorzeitig, kann der entsprechende Knochengeist erst nach einem Tag wieder beschworen oder gebunden werden. Dieser Zauber kann in derselben Zaubermatrix platziert werden wie der Zauber Knochengeist beschwören."],
        sameAs: "Knochengeist beschwören",
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Meilen)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 3,
        url: "/wiki/Grabesbotschaft",
        name: "Grabesbotschaft",
        threads: 4,
        weaving: 7,
        attune: 12,
        casting: "6",
        distance: "20 Meilen",
        dur: "Rang Tage",
        eff: "Schickt einem Namensgeber eine Nachricht",
        desc: ["Dieser Zauber sendet einem anderen Namensgeber auf magischem Wege eine Nachricht. Der Zauberer spricht eine Nachricht von bis zu fünfzig Wörtern Länge in einem Knochenkreis, auf einem Friedhof oder an einem anderen Ort, an dem Geister aktiv sind, und legt dann eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, wird die Nachricht erfolgreich zu einem bestimmten Knochenkreis, Friedhof oder Ort geschickt, an dem Geister aktiv sind, und an einen Benannten Charakter gerichtet oder \"an jeden [füge hier Beschreibung ein], der in der Nähe ist\". Die Nachricht wird dem Ziel von einer zittrigen Geisterstimme überbracht, die sie nur einmal ausspricht."],
        as: {txt: "Reichweite Erhöhen (+20 Meilen)", what: ['dist'], mod: 20},
        at: [{txt: "Reichweite Erhöhen (+20 Meilen), Wirkungsdauer Verlängern (+2 Tage)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 3,
        url: "/wiki/Knochengeist_beschw%C3%B6ren",
        name: "Knochengeist beschwören",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Beschwört einen Knochengeist",
        desc: ["Beschwörung. Dieser Zauber beschwört den Knochengeist aus einem der Knochenkreise des Zauberers (der maximal Spruchzauberei-Rang des Zauberers x 10 Meilen entfernt sein darf), was es dem Geist ermöglicht, für einen kurzen Zeitraum außerhalb des Kreises zu existieren. Der Zauberer nimmt zwei Knochen, wirft einen auf den Boden, stampft einmal darauf und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Knochengeistes ab. Wenn die Probe gelingt, erscheint der Knochengeist vor ihm. Der Knochengeist kann sich nicht weiter als 10 Schritt vom Zauberer wegbewegen. Ist er gezwungen, dies zu tun, endet der Zauber und der Knochengeist kehrt in seinen Knochenkreis zurück.", "Der Knochengeist gehorcht jedem Befehl des Zauberers: kämpfen, berichten, was sich innerhalb der Sichtweite des Knochenkreises zuträgt, und so weiter. Knochengeister mögen es  nicht, ihren Knochenkreis zu verlassen, weswegen sie mehrmaligen Beschwörungsversuchen widerstehen. Für jeden zusätzlichen Versuch, denselben Geist am selben Tag herbeizurufen, benötigt der Zauberer einen zusätzlichen Erfolg. Der Knochengeist kehrt in seinen Kreis zurück, wenn der Zauber endet. Wenn der Geist im Kampf vernichtet wird, wird auch sein Knochenkreis zerstört. Dieser Zauber kann in derselben Zaubermatrix platziert werden wie der Zauber Aspekt des Knochengeistes."],
        sameAs: "Aspekt des Knochengeistes",
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Meilen)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 3,
        url: "/wiki/Nebel_der_Angst",
        name: "Nebel der Angst",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "6",
        distance: "20 Schritt",
        dur: "Rang Runden",
        area: "4 Schritt Radius",
        eff: "Erlaubt den Einsatz von Verängstigen gegen mehrere Ziele in Reichweite",
        desc: ["Dieser Zauber beschwört einen Nebel, der in allen Furcht erzeugt, die von seinen nebligen Tentakeln umhüllt werden. Der Zauberer schlingt seine Arme um sich, als sei ihm kalt, zeigt dann dorthin, wo der Nebel erscheinen soll, und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, bildet sich an der entsprechenden Stelle ein leuchtender, grauer kalter Nebel in einer Kugel von 4 Schritt Radius. Sobald der Nebel beschworen wurde, kann er nicht mehr bewegt werden. Der Zauberer kann in einer einzigen Aktion sein Talent Verängstigen gegen alle Ziele im Wirkungsbereich einsetzen, wobei die Nebelschwaden die Form seines bedrohlichen Gesichts annehmen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+2 Bonus auf Talent)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 3,
        url: "/wiki/Pfeil_der_Nacht",
        name: "Pfeil der Nacht",
        threads: 0,
        weaving: 7,
        attune: 12,
        casting: "6",
        distance: "Berührung",
        dur: "2 Runden",
        eff: "+6 auf eine Projektilschadensprobe, -2 auf Mystische Rüstung",
        desc: ["Dieser Zauber überzieht einen Pfeil mit einer frostigen Schicht Dunkelheit, die zu einer Silhouette geformt wird. Der Pfeil muss innerhalb einer Runde nach Wirken des Zaubers abgeschossen werden, sonst wirkt die Verzauberung nicht. Der Zauberer schließt seine Hand um die Pfeilspitze und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, legt sich Dunkelheit aus dem Astralraum um den Pfeil und addiert einen Bonus von +6 auf seine Schadensprobe.", "Erleidet das Ziel durch den Pfeil Schaden, erhält es bis zum Ende der nächsten Runde zusätzlich einen Malus von -2 auf seine Mystische Rüstung. Das Hantieren mit dem Pfeil kostet den Charakter, der ihn abschießt, 1 Punkt Überanstrengung. Der Zauber verzehrt den Pfeil, der in der Runde, nachdem er abgeschossen wurde, zu Staub zerfällt. Der Zauber wirkt auf beliebige Arten von Geschossen, einschließlich Armbrustbolzen, Steinen für Schleudern und Blasrohrnadeln."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Mystische Rüstung -2)"},
            {txt: "Wirkung Verstärken (Schaden +2)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 3,
        url: "/wiki/Schmerzen",
        name: "Schmerzen",
        threads: 0,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Fügt dem Ziel 3 temporäre Wunden zu und verlangsamt seine Bewegung",
        desc: ["Dieser Zauber erzeugt bei einem Charakter quälende Schmerzen. Der Zauberer vollführt stechende Bewegungen mit seinen Händen und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird das Ziel von Wellen quälenden Schmerzes überflutet. Die Wirkung dieses Zaubers fügt dem Ziel während der Wirkungsdauer 3 Wunden zu und halbiert seine Bewegungsrate. Der Zauber hat keine Auswirkungen auf Kreaturen, die entweder keine Schmerzen empfinden oder an Schmerzen gewöhnt sind. Dies schließt Untote, die meisten Dämonen und Dämonenkonstrukte sowie Blutelfen ein. Wenn der Zauber gegen Kadavermenschen (siehe Spielleiterhandbuch) eingesetzt wird, verfallen sie sofort in Raserei."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Wunde)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 4,
        url: "/wiki/Asprekt_des_Bedrohlichen_Tyrannen",
        name: "Aspekt des Bedrohlichen Tyrannen",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "Gewährt dem Ziel Boni bei sozialen Interaktionen  mit Nebenwirkungen",
        desc: ["Bindung. Dieser Zauber beschwört einen Geist des Schreckens und bindet ihn zeitweise an ein freiwilliges Ziel. Der Zauberer berührt das Ziel, kniet vor ihm nieder und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, materialisiert sich der Geist über dem Ziel und verschmilzt mit ihm. Die Haltung des Ziels wird augenblicklich starr, und seine Bewegungen werden energisch. Seine Gesichtszüge werden schärfer, seine Augen leuchten vor anderweltlicher Grausamkeit, und Schatten haften an ihm.", "Während dieser Zauber aktiv ist, werden alle Spielleitercharaktere so behandelt, als hätten sie gegenüber dem Ziel eine Neutrale Haltung. Das Ziel erhält einen Bonus von +6 auf soziale Proben, die auf Einschüchterung und Furcht basieren. Wenn die Wirkungsdauer endet, verschlechtert sich die Haltung jedes Spielleitercharakters, gegen den das Ziel entsprechend gehandelt hat, um einen Grad (siehe Spielleiterhandbuch).", "Alle Aktionen des gebundenen Charakters, die direkt jemand anderem als ihm helfen (wie etwa jemand anderen zu heilen oder auch nur eine Tür für jemand anderen zu öffnen), beenden den Zauber augenblicklich. Wenn das Ziel die durch den Zauber gewährten Vorteile nicht nutzt oder der Zauber vorzeitig endet, kann der Zauber erst nach einem vollen Tag wieder gewirkt werden, und das Ziel erleidet einen Malus von -3 auf Proben, die auf Willenskraft basieren, bis es eine ganze Nacht lang ruhen konnte.", "Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein. Dieser Zauber kann sehr suchterzeugend sein, denn das Gefühl der Macht, das er gewährt, ist ein erregender Rausch. Nach Maßgabe des Spielleiters kann der Geist versuchen, ans Ziel gebunden zu bleiben, wenn die Wirkungsdauer endet. Um einen widerwilligen Geist zu vertreiben, muss dem Charakter eine Willenskraftprobe gegen den Neutralisierungsmindestwurf des Zaubers gelingen. Diese Probe darf nach jedem Wirkungsdauerintervall (Rang Minuten) erneut versucht werden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+2 auf Interaktionsproben zum Einschüchtern)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 4,
        url: "/wiki/B%C3%B6ser_Blick",
        name: "Böser Blick",
        threads: 0,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Runden",
        eff: "Verbessert die Wirkung von Verängstigen",
        desc: ["Dieser Zauber lässt grünlich flackernde Flammen in den Augen des Zauberers aufleuchten. Der Zauberer starrt sein Ziel an, schließt dann ein Auge und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält der Zauberer bei jedem erfolgreichen Einsatz des Talents Verängstigen gegen das Ziel einen zusätzlichen Erfolg."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+1 zusätzlicher Erfolg auf Verängstigen-Proben)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 4,
        url: "/wiki/Dunkler_Spion",
        name: "Dunkler Spion",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        eff: "Sieht und hört durch die Augen eines nachtaktiven Flugtiers",
        desc: ["Mit diesem Zauber kann der Zauberer durch die Sinne eines nachtaktiven Flugtiers sehen und hören. Der Zauber muss nach Sonnenuntergang gewirkt werden und kann nur auf ein Tier gewirkt werden, das bereits unter der Kontrolle des Zauberers steht, entweder weil es ein Tiergefährte ist oder durch das Talent Nachtflieger Befehligen beherrscht wird.", "Der Zauberer schließt ein Auge und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Tiers ab. Wenn die Probe gelingt, übernimmt er die Kontrolle über die Sinne des Tiers und darf Wahrnehmungsproben ablegen, als wäre er selbst das Tier.", "Die maximale Entfernung, bis zu der der Zauberer die Sinne des Tiers benutzen kann, ist gleich seinem Spruchzauberei-Rang in Meilen. Die eigenen Sinne des Zauberers sind stark beeinträchtigt, und er kann nur schlecht auf externe Stimuli reagieren; er gilt für alle Aktionsproben (außer Wahrnehmungsproben mit den Sinnen des Tiers) als Bedrängt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+1 Meile)"},
            {txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+2 auf Wahrnehmungsproben)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 4,
        url: "/wiki/Letzte_Chance",
        name: "Letzte Chance",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Berührung",
        dur: "1 Runde",
        eff: "Gewährt einem toten Charakter +4 auf eine Erholungsprobe",
        desc: ["Dieser Zauber holt einen Charakter von der Schwelle des Todes zurück. Der Zauber muss innerhalb einer Minute nach dem Tod des Charakters gewirkt werden. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Gelingt die Probe, legt das Ziel sofort eine Erholungsprobe mit einem Bonus von +4 ab. Wenn es all seine an diesem Tag verfügbaren Erholungsproben schon verbraucht hat, legt es stattdessen eine Erholungsprobe mit Stufe 4/W6 ab. Sinkt der Aktuelle Schaden des Ziels unter seine Todesschwelle, überlebt es, ansonsten bleibt es tot. Dieser Zauber darf nur einmal pro Tag auf ein bestimmtes Ziel gewirkt werden."],
        as: {txt: "Wirkung Verstärken (Bonus +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 4,
        url: "/wiki/Sichtfenster",
        name: "Sichtfenster",
        threads: 2,
        weaving: 8,
        attune: 13,
        casting: "6",
        distance: "Berührung",
        dur: "Rang + 5 Minuten",
        eff: "Durch eine physische Barriere sehen",
        desc: ["Dieser Zauber durchdringt den Astralraum und erzeugt so ein nur in eine Richtung durchsichtiges Fenster durch eine Wand oder eine andere Barriere, die nicht mehr als 2 Schritt dick ist. Der Zauberer legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, wird ein Fenster von bis zu einem Quadratschritt Größe in der Wand erschaffen, durch das der Zauberer sehen kann. Das Material der Barriere wird dadurch nicht beeinflusst – eine Steinmauer ist immer noch hart wie Stein, ein Holzzaun stellt immer noch denselben Schutz zur Verfügung und so weiter. Jemand auf der anderen Seite der Wand kann das Fenster unter Umständen bemerken. Das Ergebnis der Spruchzauberei-Probe  des Zauberers ist der Entdeckungsmindestwurf für Versuche, das Fenster zu entdecken."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 4,
        url: "/wiki/Umhang_des_Nachtfliegers",
        name: "Umhang des Nachtfliegers",
        threads: 2,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang + 10 Minuten",
        eff: "Verwandelt den Zauberer in ein nachtaktives Flugtier",
        desc: ["Mit diesem Zauber kann der Zauberer die Gestalt jeder Kreatur annehmen, die er mit dem Talent Nachtflieger Befehligen beeinflussen kann. Der Zauberer muss dafür das Talent Nachtflieger Befehligen beherrschen. Er mimt das Anziehen eines Umhangs oder Mantels, flüstert dann die Art des Tiers, in das er sich verwandeln will, und legt eine Spruchzauberei-Probe gegen seine natürliche Mystische Verteidigung ab. Wenn die Probe gelingt, verwandelt er sich in das gewünschte Tier. Jegliche Kleidung und Ausrüstung, die er trägt oder mit sich führt, wird für die Wirkungsdauer des Zaubers mit ihm verwandelt; sie erscheint wieder, sobald der Zauber endet.", "Während er sich in Tiergestalt befindet, kann der Zauberer alle normalen Fähigkeiten des Tiers nutzen, einschließlich des Fliegens und verstärkter Sinne. Er kann weder sprechen noch Zauber wirken, aber er kann Talente und Fähigkeiten anwenden, die nur Gedanken oder Augenkontakt erfordern. Der Zauberer wird anfällig für das Talent Nachtflieger Befehligen. Er kann die Verwandlung jederzeit aufheben, indem er eine Standardaktion aufwendet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+2 auf Wahrnehmungsproben)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 5,
        url: "/wiki/Aspekt_des_Grausamen_Arztes",
        name: "Aspekt des Grausamen Arztes",
        threads: 1,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "Gewährt Erholungsproben – mit Nebenwirkungen",
        desc: ["Bindung. Dieser Zauber beschwört einen Geist der Schmerzen und bindet ihn zeitweise an ein freiwilliges Ziel. Der Zauberer reibt seine Hände an seiner Kleidung oder einem Tuch, als ob er sie säubern wollte, und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, materialisiert sich der Geist über dem Ziel und verschmilzt mit ihm. Die Augen des Ziels fangen an, rötlich zu leuchten, und ein bedrohliches Grinsen breitet sich über sein Gesicht aus. Das Ziel kann als Standardaktion Chirurgie an einem nahen, freiwilligen Charakter durchführen. Das Ziel der Chirurgie erleidet eine Wunde – aber nicht den entsprechenden Schaden – und legt eine kostenlose Erholungsprobe mit einem Bonus von +6 ab. Falls der gebundene Charakter eine Wunde erleidet, endet der Zauber augenblicklich. Wenn der Zauber vorzeitig endet oder die Wirkungsdauer endet, ohne dass die Chirurgie durchgeführt wurde, kann der Zauber erst nach einem vollen Tag wieder gewirkt werden. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 5,
        url: "/wiki/Astraler_Schutzkreis",
        name: "Astraler Schutzkreis",
        threads: 2,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Minuten",
        area: "8 Schritt Radius",
        eff: "+4 auf Mystische Rüstung",
        desc: ["Dieser Zauber erschafft einen Kreis des magischen Schutzes. Der Zauberer geht den Kreis ab und legt dann eine Spruchzauberei- Probe gegen die höchste Mystische Verteidigung aller Charaktere im Wirkungsbereich ab. Wenn die Probe gelingt, wird die Mystische Rüstung aller Charaktere im Kreis um +4 erhöht."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 5,
        url: "/wiki/Erblinden",
        name: "Erblinden",
        threads: 0,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        eff: "Ziel wird blind",
        desc: ["Dieser Zauber verwandelt die Augen eines Charakters in leere Augenhöhlen. Der Zauberer kratzt über seine eigenen Augen und murmelt vor sich hin, dann legt er eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, verschwinden die Augäpfel des Ziels, und zurück bleiben nur dunkle leere Höhlen. Das \"blinde\" Ziel erleidet den Modifikator für Volle Dunkelheit auf alle auf Sicht basierenden Aktionsproben. In jeder Runde darf es eine Willenskraftprobe gegen die Willenskraftstufe des Zauberers ablegen. Wenn diese Probe gelingt, endet der Zauber, und es kann wieder normal sehen. Ziele, die keine Sicht benötigen, um zu \"sehen\", werden von diesem Zauber nicht beeinträchtigt. Dieser Zauber beeinflusst nicht die astrale Wahrnehmung, z.B. durch das Talent Astralsicht."],
        as: {txt: "Wirkung Verstärken (effektive Willenskraftstufe +2)", what: ['wil'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (effektive Willenskraftstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 5,
        url: "/wiki/Staub_zu_Staub",
        name: "Staub zu Staub",
        threads: 0,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "WIL + 8/Mystisch",
        eff_roll: {attribute: 'wil', mod: 8},
        eff_resist: 'mr',
        desc: ["Dieser Zauber zerstört große Gruppen von Untoten. Der Zauberer schluckt hart und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab. Wenn die Probe gelingt, legt er eine Wirkungsprobe ab, um zu bestimmen, wie viel Schaden jedem Ziel zugefügt wird. Untote, die mehr Schaden erleiden, als ihre Todesschwelle beträgt, zerfallen sofort zu Staub. Der Zauberer kann maximal so viele Ziele treffen, wie sein Rang in Spruchzauberei beträgt. Dieser Zauber wirkt nicht gegen körperlose Geister, korrumpierte Namensgeber oder Dämonen. Er wirkt aber gegen untote Dämonenkonstrukte, wie zum Beispiel Kadavermenschen. Im Zweifelsfall bestimmt der Spielleiter, ob die betreffende Kreatur untot ist oder nicht."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1 Ziel; Fäden für Zusätzliche Ziele zählen nicht gegen das normale Maximum für zusätzliche Fäden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 5,
        url: "/wiki/Verdorren",
        name: "Verdorren",
        threads: 3,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "WIL + 6/Mystisch",
        eff_roll: {attribute: 'wil', mod: 6},
        eff_resist: 'mr',
        desc: ["Dieser gefürchtete Zauber lässt Beine, Arme, Flügel und Schwänze schrumpfen. Der Zauberer zeigt auf eine der Gliedmaßen des Opfers und flüstert \"Verdorre\". Dann legt er eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe, wie viel Schaden verursacht wird. Erleidet das Ziel eine Wunde, schrumpft seine Gliedmaße und wird schwächer, während die Muskeln verkümmern. Das Ziel gilt in jeder Runde, in der es diese Gliedmaße für eine Aktionsprobe benutzt, als Bedrängt.", "Wenn ein Arm verdorrt ist, kann das Ziel in oder an diesem Arm keinen Gegenstand tragen, der mehr als 2 Pfund wiegt, einschließlich Waffen oder Schilden. Wenn ein Bein oder Flügel verdorrt ist, wird die entsprechende Bewegungsrate halbiert. Wenn beide Beine oder Flügel verdorrt sind, kann das Ziel die entsprechende Fortbewegungsform nicht einsetzen, was gewöhnlich bedeutet, dass es Niedergeschlagen ist (keine Niederschlagsproben erlaubt) und nur noch mit Bewegungsrate 2 kriechen kann.", "Die Wunde kann erst geheilt werden, wenn die Gliedmaße wiederhergestellt wurde. Nur mächtige Heilmagie, wie etwa der Zauber Verdorren Umkehren, kann eine Gliedmaße wiederherstellen."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 5,
        url: "/wiki/Verdorren_Umkehren",
        name: "Verdorren Umkehren",
        threads: 3,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Berührung",
        dur: "1 Runde",
        eff: "Heilt verdorrte Gliedmaße",
        desc: ["Dieser Zauber kehrt die Auswirkungen des Zaubers Verdorren um und stellt die verdorrte Gliedmaße wieder her. Der Zauberer berührt die Gliedmaße und tränkt sie mit Energie aus einer anderen Ebene. Dann legt er eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, kehrt die Gliedmaße in ihren ursprünglichen Zustand zurück. Die verdorrte Gliedmaße wird nicht augenblicklich wiederhergestellt. Das Ziel erleidet immer noch einen Malus von -3 auf alle Aktionsproben mit dieser Gliedmaße, bis die durch das Verdorren verursachte Wunde geheilt ist. Nachdem die Wunde geheilt worden ist, kehrt die Gliedmaße in ihren ursprünglichen Zustand zurück."],
        as: {txt: "-"},
        at: [],
    },
    {

        discipline: "Geisterbeschwörer",
        circle: 6,
        url: "/wiki/Astralschlund",
        name: "Astralschlund",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVS",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Geisterbeschwörerkreis + 10/Physisch",
        desc: ["Dieser Zauber beschwört ein riesiges Maul aus dem Astralraum. Gerüchten zufolge ruft der Zauber einen echten Dämon herbei, was wenig dazu beiträgt, den furchteinflößenden Ruf von Zauberern, besonders von Geisterbeschwörern, zu mindern. Der Zauberer macht kauende Geräusche und legt eine Spruchzauberei- Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, wird aus den Tiefen der Anderwelten ein riesiges, zahnbewehrtes, von sich windenden Tentakeln umgebenes Maul beschworen, das groß genug ist, um einen Troll zu verschlingen. In jeder Runde greift das Maul ein vom Zauberer bestimmtes Ziel innerhalb der Zauberreichweite an, indem es die Wirkungsstufe für die Angriffsprobe verwendet. Der Zauberer muss sich konzentrieren, um das Maul aufrechtzuerhalten und zu lenken;  wenn seine Konzentration gestört wird, endet der Zauber, und das Maul verschwindet.", "Die folgenden Spezialregeln gelten für den Astralschlund:", "Schlucken: Wenn der Astralschlund drei oder mehr Erfolge bei seiner Angriffsprobe erzielt, wird ein höchstens trollgroßes Ziel in einem Stück verschlungen. Sobald es verschlungen ist, bestimmt die Wirkungsprobe, wie viel Schaden verursacht wird. Opfer können aus dem Schlund entkommen, indem sie eine erfolgreiche Stärke(12)-Probe ablegen. Charaktere, die getötet werden, während sie sich im Astralschlund befinden, bleiben im Astralraum, können aber durch einen passenden Zauber oder ein passendes Talent geborgen werden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 6,
        url: "/wiki/Durch_den_Schatten_treten",
        name: "Durch den Schatten treten",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Selbst; 100 Schritt",
        dur: "Rang + 5 Runden",
        eff: "Erschafft astralen Durchgang",
        desc: ["Mit diesem Zauber kann sich der Zauberer durch den Astralraum von einem Schatten zum nächsten bewegen. Der Zauberer, der neben einem Schatten – einschließlich seinem eigenen – stehen muss, legt eine Spruchzauberei-Probe gegen seine Mystische Verteidigung ab. Er muss den Zielschatten sehen können, kann dafür aber auch andere Methoden als seine natürliche Sicht anwenden.", "Wenn die Probe gelingt, werden die nahen Schatten zu temporären \"Toren\" am Ende eines \"Tunnels\" durch den Astralraum. Die maximale Entfernung, die der Zauberer zwischen zwei Schatten zurücklegen kann, beträgt 100 Schritt. Er bewegt sich mit seiner normalen Bewegungsrate durch den Astralraum und ist vor astralen Gefahren geschützt. Sobald der Zauberer den Astralraum verlässt, endet der Zauber. Wenn der Zauberer das gegenüberliegende Tor nicht durchschreitet, bevor die Wirkungsdauer des Zaubers endet, ist er im Astralraum gefangen. Auf diese Weise gefangene Zauberer können den Astralraum durch andere Mittel – so sie über solche verfügen – verlassen. Die Schattentore erlauben es auch astralen Wesenheiten, in die physische Ebene zu wechseln."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 6,
        url: "/wiki/Erholung",
        name: "Erholung",
        threads: 1,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Berührung",
        dur: "1 Runde",
        eff: "+5 auf Erholungsprobe",
        desc: ["Dieser Zauber stärkt die Lebenskraft eines Charakters. Der Zauberer berührt das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, legt das Ziel eine Erholungsprobe (die nicht durch weitere Heilmittel verstärkt werden darf) mit einem Bonus von +5 ab. Wenn es keine Erholungsproben mehr zur Verfügung hat, wirkt der Zauber nicht."],
        as: {txt: "Wirkung Verstärken (Bonus +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 6,
        url: "/wiki/Freundliche_Finsternis",
        name: "Freundliche Finsternis",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVG",
        distance: "Berührung",
        dur: "Rang Runden",
        area: "6 Schritt Radius",
        eff: "Erschafft magische Finsternis; +2 zu einer Art vo Aktionsprobe für freundliche Charaktere",
        desc: ["Dieser Zauber zieht Dunkelheit aus einer anderen Dimension, die alles Licht in der Nähe auslöscht. Der Zauberer legt die Hände zusammen, berührt das Ziel und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung im Wirkungsbereich ab. Wenn die Probe gelingt, füllt die so beschworene Dunkelheit eine Kugel mit einem Radius von 6 Schritt, deren Zentrum das Ziel ist. Die Dunkelheit löscht alles Licht aus, wodurch alle Charaktere innerhalb des Wirkungsbereiches den Malus für Volle Dunkelheit auf alle auf Sicht basierenden Aktionsproben erleiden.", "Der Zauberer kann eine maximale Anzahl von Charakteren gleich seinem Rang in Spruchzauberei bestimmen, die von der Dunkelheit nicht beeinflusst werden und in ihr einen Bonus von +2 auf eine Art von Aktionsprobe – Angriffsprobe, Schadensprobe, Erholungsprobe und so weiter – erhalten. Normales Licht dringt nicht durch die Dunkelheit. Gegen Charaktere, die die Geisterbeschwörung beherrschen, wirkt dieser Zauber nicht – sie können normal sehen, als ob der Zauber nie gewirkt worden wäre."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 6,
        url: "/wiki/Knochenbrecher",
        name: "Knochenbrecher",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "WIL + 6/Mystisch",
        eff_roll: {attribute: 'wil', mod: 6},
        eff_resist: 'mr',
        desc: ["Dieser Zauber zersplittert und bricht Knochen und verursacht so schrecklichen Schaden. Der Zauberer gibt knackende Geräusche von sich und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele in Reichweite ab. Wenn die Probe gelingt, legt er pro Erfolg eine Wirkungsprobe ab, um den Schaden zu bestimmen, der verursacht wird, wobei nicht mehr als zwei Wirkungsproben gegen ein einzelnes Ziel gerichtet werden dürfen. Ein Ziel, das eine Wunde erleidet, addiert +5 auf seinen Niederschlagsmindestwurf. Der Zauberer kann den Zauber gegen eine maximale Anzahl von Zielen gleich seinem Rang in Spruchzauberei wirken."],
        as: {txt: "siehe Text"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkung Verstärken (+1 Erfolg)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 6,
        url: "/wiki/Schw%C3%A4chende_D%C3%BCsternis",
        name: "Schwächende Düsternis",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        area: "6 Schritt Radius",
        eff: "Erschafft Wolke lebenentziehenden Nebels",
        desc: ["Dieser Zauber füllt den Wirkungsbereich mit einem anderweltlichen Nebel, der allen im Wirkungsbereich Anwesenden das Leben aussaugt. Der Zauberer stampft mit den Füßen rhythmisch auf den Boden, während er den Zauber wirkt, und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, dringt ein furchterregender Nebel aus Ritzen grünen Lichts, die im Boden erscheinen. Jedes Ziel im Wirkungsbereich halbiert seine Bewegungsrate und kann nicht rennen. Außerdem erleidet jedes Ziel pro Runde, in der es sich im Wirkungsbereich aufhält, eine Wunde. Diese Wunden sind kumulativ, heilen aber nach einer Stunde Ruhe, sobald das Ziel dem Nebel nicht mehr ausgesetzt ist."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {

        discipline: "Geisterbeschwörer",
        circle: 7,
        url: "/wiki/Aspekt_des_Gelegenheitsm%C3%B6rders",
        name: "Aspekt des Gelegenheitsmörders",
        threads: 1,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "+5 auf Angriffs- und Schadensproben im Nahkampf",
        desc: ["Bindung. Dieser Zauber beschwört einen Geist des Mordens und bindet ihn zeitweise an ein freiwilliges Ziel. Der Zauberer leckt langsam über die Schneide einer Klingenwaffe und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, materialisiert sich der Geist über dem Ziel und verschmilzt mit ihm. Die Fingernägel des Ziels verlängern sich, und Blut quillt aus seinen Nagelbetten hervor. Das Ziel des Zaubers wird von einem Verlangen nach Blutvergießen überwältigt und erhält einen Bonus von +5 auf Angriffs- und Schadensproben im Nahkampf gegen Gegner, die Überrascht oder Niedergeschlagen sind oder Aus dem Toten Winkel angegriffen werden.", "Wenn das Ziel die Gelegenheit hat, ein Überraschtes oder Niedergeschlagenes Ziel oder ein Ziel Aus dem Toten Winkel anzugreifen, es aber nicht tut, endet der Zauber augenblicklich. Verursacht das Ziel keinen Schaden, während es unter diesem Zauber steht, oder endet der Zauber aus irgendeinem Grund vorzeitig, erleidet es eine Wunde. Sollte dieser Zauber vorzeitig enden oder das Ziel als Folge des Zaubers eine Wunde erleiden, kann der Zauber erst nach einem vollen Tag wieder gewirkt werden. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +1)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 7,
        url: "/wiki/Astrales_Leuchtfeuer",
        name: "Astrales Leuchtfeuer",
        threads: 3,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "Erschafft ein Leuchtfeuer im Astralraum",
        desc: ["Dieser Zauber erzeugt ein helles Leuchtfeuer aus Energie im Astralraum und setzt so einen Charakter der Gefahr aus, mit einem Dämonenmal gezeichnet zu werden, als ob er gerade rohe Magie gewirkt hätte (siehe S. 155). Der Zauberer kauert sich auf dem Boden zusammen, springt dann auf, wirft die Arme in die Luft und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, legt das Ziel alle entsprechenden Proben ab, als ob es an diesem Ort gerade einen Zauber des Siebten Kreises mit roher Magie gewirkt hätte, einschließlich Verzerrungs-, Schadens- und Dämonenmal- Proben."],
        as: {txt: "Wirkung Verstärken (+1 Kreis)"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Kreis)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 7,
        url: "/wiki/Herzbeklemmung",
        name: "Herzbeklemmung",
        threads: 4,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        eff: "WIL",
        eff_roll: {attribute: 'wil', mod: 0},
        desc: ["Dieser Zauber schnürt das Herz eines Charakters mit astraler Kraft ein. Der Zauberer macht eine greifende Bewegung mit seiner Hand und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird das Herz des Ziels wie in einem Schraubstock gequetscht. In jeder Runde bestimmt die Wirkungsprobe des Zauberers, wie viel Schaden verursacht wird.", "Der Zauberer muss sich in jeder Runde konzentrieren, um Schaden zu verursachen, oder der Zauber endet. Das Ziel ist gelähmt und kann keine Aktionen ausführen, bis es eine erfolgreiche Willenskraftprobe gegen die Wirkungsstufe ablegt. Wenn die Probe gelingt, endet der Zauber. Einige Kreaturen werden nicht von diesem Zauber beeinflusst, weil sie untot sind und keine Schmerzen spüren oder weil sie kein Herz oder ähnliches Organ haben, das gequetscht werden könnte."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 7,
        url: "/wiki/Knochenpudding",
        name: "Knochenpudding",
        threads: 4,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang + 5 Runden",
        eff: "Verwandelt Knochen in Pudding",
        desc: ["Dieser Zauber verwandelt die Knochen eines Charakters in eine puddingähnliche Masse. Der Zauberer isst eine weiche Substanz, zum Beispiel Pudding, und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, nehmen die Arm- und Beinknochen des Ziels eine matschige Konsistenz an, und es erleidet 3 Wunden (aber keine Schadenspunkte). Es gelten die üblichen Modifikatoren für das Erleiden mehrerer Wunden (siehe Wundmodifikatoren, S. 227). Bewegung wird für das Ziel fast unmöglich; es hat eine effektive Bewegungsrate von 0. Das Ziel kann nur defensive Aktionen ausführen und Aktionen, bei denen seine Gliedmaßen kein Gewicht tragen müssen. Nachdem der Zauber geendet hat, verwandeln sich die Knochen des Ziels in ihre ursprüngliche Konsistenz zurück, und die Wunden können geheilt werden."],
        as: {txt: "Wirkung Verstärken (+1 Wunde)", what: ["wound"], mod: 1},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Wunde)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 7,
        url: "/wiki/L%C3%A4hmkreis",
        name: "Lähmkreis",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        eff: "WIL + Geisterbeschwörerkreis",
        desc: ["Dieser Zauber hält eine untote Kreatur, einen Dämon, ein Dämonenkonstrukt oder einen manifestierten Geist gefangen. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, umgibt ein heller Kreis aus rotem Licht, der mit goldenen Inschriften verziert ist, das Ziel und verhindert seine Bewegung.", "Das Ziel kann immer noch kommunizieren – sofern der Zauberer mit solch einer Kreatur sprechen will. In jeder Minute kann das Ziel versuchen, sich zu befreien, indem es eine Willenskraftprobe gegen die Wirkungsstufe ablegt. Wenn die Probe gelingt, wird der Kreis zerstört und der Zauber endet. Jede feindselige Aktion gegen das Ziel beendet den Zauber augenblicklich."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 7,
        url: "/wiki/%C3%9Cble_D%C3%A4mpfe",
        name: "Üble Dämpfe",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Runden",
        area: "10 Schritt Radius",
        eff: "WIL + 5/Mystisch",
        eff_roll: {attribute: 'wil', mod: 5},
        eff_resist: 'mr',
        desc: ["Dieser Zauber zapft die hässlicheren Regionen des Astralraums an und zieht die dort vorhandenen Dämpfe in die physische Ebene. Der Zauberer hält den Atem an und legt eine Spruchzauberei- Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, werden Dämpfe aus dem Astralraum gezogen und füllen den Wirkungsbereich vollständig aus. Die Dämpfe bewegen sich nicht, sobald sie beschworen wurden. Der Zauberer ist gegen die Auswirkungen der Dämpfe immun. Wer den Dämpfen ausgesetzt ist, muss sie nicht einatmen, um Schaden zu erleiden – der reine Kontakt reicht schon aus. Der Zauber wirkt sowohl gegen lebende als auch gegen untote Kreaturen. In jeder Runde legt der Zauberer eine Wirkungsprobe ab, um zu bestimmen, wie viel Schaden jedes Ziel erleidet. Alle Ziele, die durch diesen Zauber Schaden erleiden, gelten bis zur nächsten Runde als Bedrängt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Ziele Ausnehmen (-Rang)"}]
    },
    {

        discipline: "Geisterbeschwörer",
        circle: 8,
        url: "/wiki/Aspekt_des_Astralen_Gelehrten",
        name: "Aspekt des Astralen Gelehrten",
        threads: 1,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "Gewährt uneingeschränkte Wahrnehmung des Astralraums",
        desc: ["Bindung. Dieser Zauber beschwört einen Geist des Wahnsinns und bindet ihn zeitweise an ein freiwilliges Ziel. Der Zauberer schließt die Augen des Ziels, flüstert zischend und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, materialisiert sich der Geist über dem Ziel und verschmilzt mit ihm. Die Augen des Ziels werden zu schwarzen Kugeln, die von einer anderweltlichen Flamme erleuchtet werden. Das Ziel des Zaubers wird teilweise in den Astralraum gezogen und nimmt ihn ohne die Filter wahr, für die das Talent Astralsicht sorgt. Es erhält einen Bonus von +4 auf seine Körperliche Verteidigung und auf Astralsicht-Proben, die für die Wirkungsdauer des Zaubers auch keine Überanstrengung kosten.", "Zusätzlich kann der gebundene Charakter jede Wahre Struktur untersuchen, indem er eine Astralsicht-Probe gegen ihre Mystische Verteidigung ablegt, um zusätzliche Informationen darüber zu erhalten, wie sie funktioniert. Wenn die Probe gelingt, erhält er pro Erfolg einen Bonus von +2 auf Spruchzauberei- und Wirkungsproben gegen die Struktur. Statt der Boni kann er auch zusätzliche Einsichten in die Struktur erhalten, besonders in Dinge, die durch normale Astralsicht nicht sichtbar sind. Diese Einsichten unterliegen aber der Maßgabe des Spielleiters – es ist die Erkenntnis des Wahnsinns.", "Die Auswirkungen davon, den rohen Astralraum zu spüren, fügen dem Ziel in jeder Runde Schaden zu, und zwar in gleicher Höhe wie bei einem Zauberer, der einen Zauber des Ersten Kreises mit roher Magie wirkt. Dieser Zauber darf immer nur einmal gleichzeitig aktiv sein."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+2 auf Astralsicht- Proben)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 8,
        url: "/wiki/Astralklinge",
        name: "Astralklinge",
        threads: 0,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "Erlaubt einer Waffe, Ziele im Astralraum zu verletzen",
        desc: ["Dieser Zauber verstärkt eine Nahkampfwaffe, sodass sie gegen Ziele im Astralraum eingesetzt werden kann. Der Zauberer berührt die Waffe und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung ihres Trägers ab. Wenn die Probe gelingt, nimmt die Waffe eine dunkle, rauchige Erscheinung an. Während der Wirkungsdauer des Zaubers kann die Waffe nicht gegen Ziele auf der physischen Ebene eingesetzt werden; sie fährt durch solche Gegner einfach hindurch und verursacht bei ihnen nur ein leichtes Kältegefühl, verletzt sie aber ansonsten nicht. Der Träger der Waffe muss das Ziel im Astralraum sehen können, um es zu treffen. Dies bedeutet meist, dass er das Talent Astralsicht oder ähnliche Fähigkeiten oder Zauber einsetzen muss."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+2 Schaden)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 8,
        url: "/wiki/Dahinsiechen",
        name: "Dahinsiechen",
        threads: 5,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Monate",
        eff: "WIL/Mystisch",
        eff_roll: {attribute: 'wil', mod: 0},
        eff_resist: 'mr',
        desc: ["Dieser Zauber lässt einen Charakter langsam dahinsiechen, bis er stirbt. Der Zauberer äußert eine düstere Prophezeiung über das Ziel, berührt es dann und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe die Anzahl an Pfund, die das Ziel jeden Monat abnimmt (natürliche Mystische Rüstung senkt diese Zahl). Der Gewichtsverlust hält an, bis der Zauber endet oder das Ziel stirbt. Wenn das Gewicht des Ziels unter die Hälfte des Rassendurchschnitts sinkt, wird es schwach, fühlt sich schwindlig und gilt, während es sich in diesem Zustand befindet, als Bedrängt. Wenn sein Gewicht unter 25 Prozent des Rassendurchschnitts sinkt, erleidet es zusätzlich zum Gewichtsverlust pro Monat Schaden in Höhe der Wirkungsstufe des Zaubers. Dieser Schaden kann erst geheilt werden, wenn der Zauber endet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Monate)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Monate)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 8,
        url: "/wiki/D%C3%A4monenruf",
        name: "Dämonenruf",
        threads: 6,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Stunden",
        area: "4 Schritt Radius",
        eff: "Beschwört und bindet einen Dämon",
        desc: ["Dieser gefährliche Zauber beschwört einen Dämon aus dem Astralraum. Der Zauberer muss den Namen des Dämons in Erfahrung bringen, den er rufen will. Dann beschriftet er sorgfältig einen Kreis von 4 Schritt Radius und bemalt ihn in Weiß und Gold. Das Wirken dieses Zaubers ist für den Zauberer sehr anstrengend und erfordert den Einsatz von Blutmagie. Dadurch erleidet er 1 Punkt Blutmagieschaden, +1 Punkt Blutmagieschaden für jede misslungene Fadenweben-Probe während des Wirkens. Dieser Schaden kann erst nach einem Jahr und einem Tag geheilt werden. Sollte der Zauberer den Zauber abbrechen, bevor er ihn vollendet, erleidet er durch den magischen Rückschlag Stufe 25 Schaden (Mystische Rüstung schützt gegen diesen Schaden).", "Der Zauberer berührt den Kreis, spricht den Namen des Dämons laut aus und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Dämons ab. Wenn die Probe gelingt, wird der Dämon aus dem Astralraum in den Schutzkreis beschworen. Der Dämon verbleibt im Schutzkreis, bis er eine erfolgreiche Willenskraftprobe oder Probe auf Magie Neutralisieren gegen den Neutralisierungsmindestwurf des Zaubers ablegt, vom Zauberer aus dem Kreis entlassen wird oder der Zauber endet. Der Dämon kann pro Stunde eine Willenskraftprobe oder Probe auf Magie Neutralisieren ablegen. Wenn die Probe gelingt, endet der Zauber.", "Viele Dämonen versuchen, mit ihrem Beschwörer zu handeln, und bieten ihm wertvolle Schätze an, damit er sie in die physische Ebene entlässt. Wenn sein Angebot akzeptiert wird, wird der Dämon gewöhnlich zahlen, was er versprochen hat, aber oft zu einem späteren Zeitpunkt zurückkehren, um sich die Schätze zurückzuholen. Nur wenige Zauberer lehren diesen Zauber. Ein Charakter sollte sich fragen, welche Motive jemand hat, diesen Zauber zu lehren, weil viele Dämonen die Weitergabe dieses Zaubers an andere zu einem Teil ihres Handels machen. Wenn der Zauber endet, kehrt der Dämon zurück in den Astralraum."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Neutralisierungsmindestwurf +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 8,
        url: "/wiki/Geisterportal",
        name: "Geisterportal",
        threads: 4,
        weaving: 12,
        attune: 17,
        casting: "6",
        distance: "Berührung",
        dur: "Rang x 10 Minuten",
        eff: "WIL + 10 (siehe Text)",
        eff_roll: {attribute: 'wil', mod: 10},
        desc: ["Dieser Zauber erschafft einen Durchgang in den Astralraum, durch den Geister die physische Ebene oder Charaktere den Astralraum betreten können. Der Zauber muss in einem Knochenkreis gewirkt werden, der vom Zauberer gebaut wurde. Der Zauberer legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, sticht er ein kleines Loch in den Astralraum und vergrößert es, bis er ein Portal erschaffen hat. Der Zauberer hat die Kontrolle darüber, wer das Geisterportal benutzen darf, aber er muss es sehen können, um jemandem den Durchgang zu verwehren. Um ein Wesen daran zu hindern, durch das Portal zu treten, legt er eine Wirkungsprobe gegen die Willenskraftprobe des Wesens ab. Wenn die Wirkungsprobe misslingt, kann das Wesen durch das Portal treten. Gelingt sie, wird es am Durchgang gehindert."],
        as: {txt: "Wirkungsdauer Verlängern (+10 Minuten)", what: ['dur'], mod: 10},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+10 Minuten)"}]
    },
    {
        discipline: "Geisterbeschwörer",
        circle: 8,
        url: "/wiki/Schattenfessel",
        name: "Schattenfessel",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Ziele können sich nicht bewegen und sind Bedrängt",
        desc: ["Dieser Zauber verankert Charaktere durch ihre Schatten am Boden. Der Zauberer kann den Zauber gegen eine maximale Anzahl von Charakteren gleich seinem Rang in Spruchzauberei wirken. Sowohl die Ziele als auch ihre Schatten müssen für ihn sichtbar sein. Der Zauberer legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab, +1 für jedes zusätzliche Ziel.", "Wenn die Probe gelingt, werden die Schatten der Ziele am Boden verankert und fesseln ihre Besitzer an diese Position. In jeder Runde kann ein Ziel eine Stärkeprobe gegen das Ergebnis der Spruchzauberei-Probe ablegen, um sich von der Wirkung des Zaubers zu befreien. Wenn die Probe gelingt, befreit sich das Ziel von seinem Schatten. Ziele, die durch ihre Schatten gefesselt sind, sind Bedrängt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Beruhigende_Ber%C3%BChrung",
        name: "Beruhigende Berührung",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "+3 auf Mystische und Soziale Verteidigung; +3 auf Willenskraftproben gegen Furcht",
        desc: ["Dieser Zauber erhöht die Widerstandsfähigkeit des Ziels gegen Furcht. Der Zauberer denkt positive Gedanken, berührt das Ziel dann leicht, während er Dinge wie \"alles wird gut\" murmelt, und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, addiert das Ziel jeweils +3 auf seine Mystische und Soziale Verteidigung gegen Furcht erzeugende Angriffe und erhält einen Bonus von +3 auf alle Willenskraftproben zum Widerstand gegen die Auswirkungen von Furcht oder Einschüchterung (siehe Spielleiterhandbuch)."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Blitz",
        name: "Blitz",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "WIL + 1/Mystisch und -2 auf nächste Durchschauen-Probe",
        eff_roll: {attribute: 'wil', mod: 1},
        eff_resist: 'mr',
        desc: ["Dieser Zauber sieht aus und wirkt wie der Zauber Illusionärer Blitz, hat aber weniger Kraft als sein illusionärer Bruder. Der Zauberer wackelt mit den Fingern und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, trifft ein zuckender, grün leuchtender Blitz das Ziel. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden verursacht wird. Jedes Ziel erhält einen Malus von -2 auf seine nächste Durchschauen-Probe, da seine Wahrnehmung sich verzerrt.", "Dieser Zauber kann in derselben Matrix platziert werden wie der Zauber Illusionärer Blitz."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkung Verstärken (Malus -2)"},
            {txt: "Wirkung Verstärken (Malus gilt für zusätzliche Durchschauen-Probe)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,

        url: "/wiki/Botschaft_senden",
        name: "Botschaft senden",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Selbst (s. Text)",
        dur: "Rang Runden",
        eff: "Übermittelt eine Botschaft auf Papier an ein Ziel",
        desc: ["Dieser Zauber erschafft und übermittelt eine Botschaft an einen Charakter im Blickfeld des Zauberers. Der Zauberer vollführt kleine, schnelle Gesten in der Luft, als ob er die Botschaft schriebe, und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird eine temporäre Papierbotschaft in der Hand, Tasche oder an einer anderen Stelle des Körpers des Ziels (nach Wahl des Zauberers) beschworen. Die Botschaft darf nicht mehr als ein paar kurze Sätze enthalten, mit einer maximalen Anzahl von Wörtern gleich dem Spruchzauberei-Rang des Zauberers x 10."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+20 Wörter)"},
            {txt: "Wirkungsdauer Verlängern (Minuten), Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,

        url: "/wiki/Falsches_Gesicht",
        name: "Falsches Gesicht",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Minuten",
        eff: "+3 auf Proben, die auf Charisma basieren",
        desc: ["Illusion. Dieser Zauber verbirgt die Identität eines Charakters. Der Zauberer spritzt Wasser oder Parfüm auf das Gesicht des Ziels und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, verändert sich das Gesicht des Ziels zu einem Gesicht nach Wahl des Zauberers – wenn er ein bestimmtes Gesicht kopiert, muss er das betreffende Individuum innerhalb des letzten Monats gesehen haben.", "Das Ziel erhält einen Bonus von +3 auf Magische Maske (und kann Magische Maske als improvisierte Fertigkeit verwenden, wenn es sie nicht beherrscht) oder auf Proben, die auf Charisma basieren, wenn es versucht, andere von seiner falschen Identität zu überzeugen und sie entsprechend dieser irrigen Meinung zum Handeln zu bewegen. Jede Interaktionsprobe gegen das Ziel zählt als Durchschauen-Probe (siehe Illusionen, S. 158). Der Zauber verändert nur den Kopf und den Hals des Ziels, einschließlich seiner Haare und Ohren; der Rest seines Körpers wird nicht verändert. Der maximal mögliche Größenunterschied zwischen dem Gesicht des Ziels und dem Gesicht, das kopiert wird, beträgt 100 Prozent in jeder Dimension. Der Zauberer muss einen anderen Weg finden, um sonstige offensichtliche Unterschiede zu verdecken. Die Stimme des Ziels bleibt unverändert, weshalb es versuchen muss, die Sprachgewohnheiten des imitierten Charakters so gut wie möglich nachzuahmen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten), Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Illusion%C3%A4rer_Blitz",
        name: "Illusionärer Blitz",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "2 Runden",
        eff: "WIL + 4/Mystisch und -2 auf Willenskraftproben",
        eff_roll: {attribute: 'wil', mod: 4},
        eff_resist: 'mr',
        desc: ["Illusion. Dieser Zauber erschafft einen sich schlängelnden, grün leuchtenden Blitz, der durch die Luft auf einen Gegner zufliegt. Der Zauberer wackelt mit dem Finger und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe, wie viel Schaden verursacht wird. Außerdem erhält das Ziel bis zum Ende der nächsten Runde einen Malus von -2 auf Willenskraftproben. Dieser Zauber kann angezweifelt werden (siehe Illusionen anzweifeln, S. 159).", "Dieser Zauber kann in derselben Matrix platziert werden wie der Zauber Blitz."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Katastrophe",
        name: "Katastrophe",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Erschafft eine Ablenkung",
        desc: ["Gebilde. Dieser Zauber erschafft die Illusion, dass eine Katastrophe gerade eben außerhalb der normalen Sichtweite passiert. Der Zauberer schaut sich beiläufig um, hält dann inne und starrt gebannt auf einen festen Punkt am Horizont, wobei er laut etwas sagt wie \"Bei den Passionen, schaut mal da!\" oder \"Was in aller Welt kann das sein?\". Dann legt er eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab, +1 für jedes zusätzliche Ziel. Wenn die Probe gelingt, wird der illusionäre \"Beweis\" einer Katastrophe nach Wahl des Zauberers erschaffen: eine von den Dächern eines Dorfes aufsteigende Rauchwolke, die Geräusche schreiender Menschen oder ein anderer kleinerer, aber ablenkender Effekt.", "Der Zauber lenkt die Aufmerksamkeit eines Ziels auf die vermeintliche Katastrophe. Diese Ablenkung ist gut genug, um das Äquivalent eines Angriffs aus dem Toten Winkel gegen dieses Ziel ausführen zu können. Der Zauberer kann eine maximale Anzahl von Zielen gleich seinem Rang in Spruchzauberei ablenken. Der Zauber kann nicht in kleinen, geschlossenen Umgebungen, wie etwa Räumen ohne Fenster, gewirkt werden. Wenn er gegen ein Ziel gewirkt wird, das gerade kämpft oder mit einer ähnlich ablenkenden Tätigkeit beschäftigt ist, muss der Zauberer einen zusätzlichen Erfolg erzielen, damit der Zauber gegen das Ziel wirkt. Jeder, der von dem Zauber beeinflusst wird und Ziel einer Aktionsprobe (wie etwa einer Angriffsprobe) wird, die seine Aufmerksamkeit auf sich zieht, wird nicht mehr von dem Zauber beeinflusst. Wenn dieser Zauber zuvor schon einmal ein Ziel beeinflusst hat und es deswegen angegriffen wurde, kann er gegen dieses Ziel erst nach einem Tag wieder eingesetzt werden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Schreckgestalt",
        name: "Schreckgestalt",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "+2 auf Angriffs- und Schadensproben im Nahkampf, +2 auf Körperliche Verteidigung",
        desc: ["Illusion. Dieser Zauber verbessert die Kampfkraft eines Charakters, indem er Beobachter glauben macht, dass er sich in ein Monster verwandelt habe. Der Zauberer gibt fauchende und grollende Geräusche von sich, berührt dann das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bilden sich zwei rotierende Spiralen aus Licht um das Ziel, die sich zur Gestalt einer monströsen humanoiden Kreatur ausdehnen, die gewöhnlich an Größe gewinnt und anstelle ihrer Hände unnatürliche Merkmale wie Äxte, Tentakeln oder gigantische Scheren erhält. Das Ziel erhält einen Bonus von +2 auf seine Angriffs- und Schadensproben im Nahkampf und addiert +2 zu seiner Körperlichen Verteidigung. Die Illusion verleiht dem Ziel keine speziellen Angriffsformen oder Fähigkeiten. Alle körperlichen Proben, die mit dem Ziel interagieren (zum Beispiel Angriffsproben, Proben auf Hieb Ausweichen oder Riposte-Proben), gelten als Durchschauen-Proben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+1 auf alle Boni)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Spass_mit_T%C3%BCren",
        name: "Spass mit Türen",
        threads: 2,
        weaving: 5,
        attune: 10,
        casting: "MVZm6",
        distance: "20 Schritt",
        dur: "Rang + 10 Minuten",
        eff: "Erschafft/verändert Türillusionen",
        desc: ["Gebilde. Dieser Zauber erschafft verschiedene visuelle Effekte, die alle mit der Benutzung von Türen zu tun haben. Der Zauberer muss in der Lage sein, die Zieltür, -falltür oder den Zieltorbogen zu sehen. Er macht Bewegungen, als würde er die Tür mit einem imaginären Pinsel streichen, und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab (mindestens 6). Wenn die Probe gelingt, kann der Zauberer verschiedene Illusionen erschaffen, die mit der Tür zu tun haben. Alle Interaktionen mit der Tür enthüllen ihr wahres Wesen. Mit diesem Zauber erschaffene falsche Türen dürfen nicht größer als 3 Quadratschritt sein. Neu erschaffene Türen können nicht weiter als 4 Schritt von der Originaltür entfernt sein. Und natürlich kann man nicht durch eine illusionäre Tür rennen …"],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Umhang",
        name: "Umhang",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+3 auf heimliche Aktionsproben",
        desc: ["Gebilde. Dieser Zauber maskiert einen Charakter und lässt ihn für andere unauffälliger werden. Der Zauberer berührt leise das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird das Ziel halb durchsichtig und erhält einen Bonus von +3 auf alle Aktionsproben, die auf Tarnung oder Heimlichkeit abzielen, wie etwa Proben auf Heimlicher Schritt, und kann Heimlicher Schritt als improvisierte Fertigkeit verwenden, wenn es sie nicht beherrscht."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel( + Rang)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Unsichtbare_Stimmen",
        name: "Unsichtbare Stimmen",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang + 5 Runden",
        eff: "Erschafft unsichtbare Stimmen",
        desc: ["Gebilde. Dieser Zauber erschafft die Illusion unsichtbarer Stimmen, um Charaktere abzulenken. Der Zauberer murmelt leise vor sich hin und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung der Ziele ab. Wenn die Probe gelingt, erschafft er eine Anzahl illusionärer Stimmen gleich seinem Spruchzauberei-Rang. Alternativ kann er auch nur ein Ziel die Stimmen hören lassen. Der Zauber kann fast unbegrenzt viele verschiedene Stimmtypen erschaffen, die benutzt werden können. Der Zauberer muss nur diejenigen Stimmen einsetzen, die er zum Erreichen seines Ziels benötigt. Indem er sich konzentriert, kann er kontrollieren, was jede Stimme sagt; wenn er die Konzentration verliert, wiederholen die Stimmen immer wieder das, was sie in der Runde davor gesagt haben. Der Zauberer erhält keine spezielle Fähigkeit, um zu hören, was das Ziel sagt; er muss in Hörweite des Ziels sein, wenn er eine echte Unterhaltung mittels der illusionären Stimmen bestreiten will. Der Zauberer kann das Talent Stimmen Imitieren zusammen mit diesem Zauber einsetzen, um bestimmte Stimmen zu replizieren. In diesem Fall wird das Talent Stimmen Imitieren wie gewohnt eingesetzt, wenn der Zauber gelingt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Verschl%C3%BCsseln",
        name: "Verschlüsseln",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Stunden",
        eff: "Macht Text unlesbar",
        desc: ["Illusion. Dieser Zauber lässt eine vom Zauberer ausgewählte Textpassage unlesbar werden. Der Zauberer fährt mit seinen Händen über den Text und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Buchs oder Papiers ab, auf dem der Text geschrieben ist (mindestens 6). Die Mystische Verteidigung eines Grimoires ist gleich dem Neutralisierungsmindestwurf des höchstkreisigen Zaubers, den es enthält (siehe Grimoires, S. 149). Wenn die Probe gelingt, wird der Text für jeden anderen außer dem Zauberer unverständlich. Jeder, der versucht, den verschlüsselten Text zu lesen, muss eine erfolgreiche Wahrnehmungsprobe, Probe auf Lesen/Schreiben oder Probe auf Struktur Verstehen gegen den Durchschauenmindestwurf ablegen, um ihn zu lesen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 1,
        url: "/wiki/Vertrauen",
        name: "Vertrauen",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        eff: "Erschafft eine freundliche Beziehung zwischen Zauberer und Ziel",
        desc: ["Dieser Zauber bewirkt, dass ein Charakter dem Zauberer vertraut. Der Zauberer lächelt das Ziel an und nickt ihm zu. Dann legt er eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird das Ziel den Zauberer (oder andere, die ihm gegenüber offensichtlich eine Freundliche Haltung einnehmen) nicht täuschen oder verletzen, solange der Zauberer (und seine Gefährten) dies auch nicht tun. Sobald der Zauber endet, wird sich das Ziel der Manipulation bewusst, und seine Haltung gegenüber dem Zauberer verschlechtert sich um einen Grad."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 2,
        url: "/wiki/Abbild_versetzen",
        name: "Abbild versetzen",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "Projiziert Bild des Ziels",
        desc: ["Illusion. Dieser Zauber macht einen Charakter \"unsichtbar\", indem er das Bild, das andere sehen, über eine kurze Entfernung versetzt. Der Zauberer fährt schnell den Umriss des Ziels nach,  berührt dann zuerst die \"Schulter\" des Umrisses, gefolgt von der Schulter des Ziels, und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erscheint eine schemenhafte, blau schimmernde Figur in 4 Schritt Entfernung, die sich schnell in ein identisches Abbild des Ziels verwandelt. Das Ziel ist nicht länger an seiner wirklichen Position sichtbar, weil die Illusion sein Bild versetzt hat. Angriffe gegen das Abbild haben keine Wirkung, und der Zauberer muss sich konzentrieren, um die Maskerade aufrechtzuerhalten. In jeder Runde, in der er sich nicht darauf konzentriert, erhalten alle Angreifer einen Bonus von +5 auf Durchschauen- Proben gegen die Illusion. Angriffsproben gegen das Abbild zählen als Durchschauen-Proben (siehe Illusionen, S. 158)."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 2,
        url: "/wiki/Blindheit",
        name: "Blindheit",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        eff: "Verdunkelt die Sicht des Ziels",
        desc: ["Illusion. Dieser Zauber beeinflusst die Sicht des Ziels. Der Zauberer schließt ein Auge, zeigt auf das Ziel, blinzelt zweimal und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird die Sicht des Ziels von einer undurchdringlichen Schwärze verdunkelt; das Ziel ist praktisch \"blind\" und erleidet einen Malus für Volle Dunkelheit für alle auf Sicht basierenden Aktionsproben. Jede auf Sicht basierende Aktionsprobe, die das Ziel ablegt, gilt als Durchschauen-Probe. Gegen Ziele, die keine Sicht benötigen, um zu \"sehen\", wirkt dieser Zauber nicht."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 2,
        url: "/wiki/Gedankennebel",
        name: "Gedankennebel",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang + 5 Runden",
        eff: "Wirkung: WIL + 3",
        eff_roll: {attribute: 'wil', mod: 3},
        desc: ["Dieser Zauber vernebelt die Wahrnehmung eines Charakters und lässt ihn vergessen, was er eigentlich zu tun vorhatte. Der Zauberer kratzt sich am Kopf, als versuche er, sich an etwas zu erinnern, und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, kann das Ziel, bis es sich daran erinnert, was es tun wollte, nur auf Aktionen reagieren, die gegen es ausgeführt werden. Sich gegen Raufbolde zu verteidigen gilt als Reaktion, aber warum das Ziel angegriffen wird, wird ihm immer ein Geheimnis bleiben. In jeder Runde kann das Ziel eine Willenskraftprobe gegen die Wirkungsstufe ablegen, falls es Anlass hat, zu argwöhnen, dass etwas nicht stimmt. Jede Runde im Kampf verleiht dem Ziel einen kumulativen Bonus von +5 auf die Willenskraftprobe."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 2,
        url: "/wiki/Harmloses_Treiben",
        name: "Harmloses Treiben",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang + 10 Runden",
        eff: "Verbirgt Aktivität",
        desc: ["Illusion. Dieser Zauber maskiert die Aktivität eines Charakters. Der Zauberer bewegt seine Hände, als würde er auf eine große Leinwand malen, und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, sieht jeder nur ein Bild des Ziels, das einer offensichtlich harmlosen Aktivität nachgeht, die zur Umgebung passt. Wenn sich das Ziel von seiner momentanen Position fortbewegt, endet die Illusion. Ansonsten kann das Ziel jede Aktion ausführen, sogar einen Gegner angreifen, während der Zauber auf ihm liegt. Jedes offensichtlich unerklärliche Phänomen als Ergebnis einer Aktion des Ziels, wie etwa Stimmen, Zauber oder Angriffe, erlaubt Beobachtern das Ablegen einer Wahrnehmungsprobe als Durchschauen-Probe (siehe Illusionen, S. 158). Wenn die Probe gelingt, durchschaut der Beobachter die Illusion, und der Zauber endet. Misslingt die Probe, denkt sich der Beobachter unbewusst eine plausible Erklärung für das aus, was er gerade beobachtet hat."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (Minuten), Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 2,
        url: "/wiki/Phantomflamme",
        name: "Phantomflamme",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "2 Runden",
        eff: "WIL + 6/Physisch",
        eff_roll: {attribute: 'wil', mod: 6},
        eff_resist: 'pr',
        desc: ["Illusion. Dieser Zauber sieht aus wie der Magierzauber Flammenblitz, ist aber eine Illusion. Der Zauberer vollführt wilde, anfachende Bewegungen und gibt knisternde, zischende Geräusche von sich, streckt dann die Hände aus und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, strömen Flammen aus seinen Fingerspitzen hervor und baden das Ziel in magisches Feuer. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden in jeder Runde verursacht wird. Eine erfolgreiche Durchschauen- Probe negiert die Auswirkungen in den folgenden Runden. Dieser Zauber kann angezweifelt werden (siehe Illusionen anzweifeln, S. 159)."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden), Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 2,
        url: "/wiki/Sehen_von_Verborgenem",
        name: "Sehen von Verborgenem",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Minuten",
        eff: "+5 auf Wahrnehmungsproben, die auf Sicht basieren",
        desc: ["Unter Einfluss dieses Zaubers kann ein Charakter versteckte Dinge besser sehen. Der Zauberer berührt sanft die Augen des Ziels und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel einen Bonus von +5 auf alle auf Sicht basierenden Wahrnehmungsproben, wenn es versucht, versteckte Gegenstände oder Charaktere zu entdecken. Das Ziel kann mit diesem Zauber keine Dinge sehen, die es normalerweise nicht sehen kann, wie etwa Dämonen, die sich im Astralraum aufhalten – es sei denn, der Zauber wird mit einem Talent oder einer Fähigkeit kombiniert, das oder die astrale Wahrnehmung erlaubt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +1)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten), Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Illusionist",
        circle: 3,
        url: "/wiki/Blendendes_Licht",
        name: "Blendendes Licht",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Verschieden (s. Text)",
        area: "4 Schritt Radius",
        eff: "Jeder im Wirkungsbereich erhält den Malus für Volle Dunkelheit",
        desc: ["Dieser Zauber erschafft einen blendenden Lichtblitz. Der Zauberer öffnet seine Augen so weit wie möglich, bedeckt sie dann und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, ist das Ziel geblendet und erleidet für eine Anzahl von Runden gleich der Anzahl der erzielten Erfolge den Modifikator für Volle Dunkelheit. Gegen Ziele, die keine Sicht benötigen, um zu \"sehen\", wirkt dieser Zauber nicht."],
        as: {txt: "siehe Text"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 3,
        url: "/wiki/Nebel_des_Spotts",
        name: "Nebel des Spotts",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        area: "4 Schritt Radius",
        eff: "Erzürnt und demütigt alle Ziele im Wirkungsbereich",
        desc: ["Illusion. Dieser Zauber beschwört einen Nebel, der alle, die in seinen nebligen Tentakeln gefangen sind, wütend macht und demütigt. Der Zauberer schlingt die Arme um sich und schüttelt sich, als könne er vor Lachen kaum an sich halten, zeigt dann auf die Stelle, an der der Nebel erscheinen soll, und legt eine Spruchzauberei- Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, bildet sich ein leuchtender, funkelnd weißer Nebel in einem Radius von 4 Schritt um die Stelle.", "Sobald der Nebel beschworen wurde, ist er stationär, und alle Ziele, die sich in ihm befinden, werden mit lachenden, höhnenden Stimmen und Fantasiegebilden ihnen bekannter Personen bombardiert, die sie demütigen. Die Ziele im Wirkungsbereich gelten als Bedrängt und müssen die Option Aggressiver Angriff für alle Aktionen ankündigen, während sie sich im Wirkungsbereich befinden (selbst wenn sie davon keinen echten Vorteil haben). Alle Aktionen, die sie durchführen, gelten als Durchschauen-Proben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 3,
        url: "/wiki/Niemand_da",
        name: "Niemand da",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVG",
        distance: "Selbst",
        dur: "Rang + 5 Minute",
        area: "4 Schritt Radius",
        eff: "Lässt Betrachter eine Gruppe von Charakteren ignorieren",
        desc: ["Illusion. Dieser Zauber versteckt Charaktere vor anderen. Der Zauberer konzentriert sich auf den Gedanken \"niemand da\" und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung der Ziele (einschließlich seiner selbst) im Wirkungsbereich ab. Wenn die Probe gelingt, werden alle Ziele im Wirkungsbereich für jene außerhalb des Wirkungsbereichs unsichtbar. Sobald der Zauber gewirkt wurde, bewegt er sich nicht mit dem Zauberer, und nur die ursprünglichen Ziele erhalten den Vorteil der Unsichtbarkeit, nicht jene, die den Wirkungsbereich später betreten. Ziele, die sich aus dem Wirkungsbereich herausbewegen, werden wieder für andere sichtbar; sie werden erst wieder unsichtbar, wenn sie sich zurück in den Wirkungsbereich begeben.", "Ein Charakter, der den Wirkungsbereich betritt, legt eine Wahrnehmungsprobe als Durchschauen-Probe ab (siehe Illusionen, S. 158). Der beobachtende Charakter addiert einen Bonus von +3 auf seine Wahrnehmungsprobe, wenn ein unsichtbarer Charakter die Umgebung auf eine Weise manipuliert, die eine Erklärung verlangt, wie etwa das Bewegen von Gegenständen, das Öffnen und Schließen von Türen und so weiter. Der beobachtende Charakter erhält einen Bonus von +5 auf seine Wahrnehmungsprobe, wenn ein versteckter Charakter ihn körperlich berührt. Wenn die Probe gelingt, wird die Illusion für diesen Beobachter enthüllt.", "Misslingt die Probe, wird das, was der beobachtende Charakter sieht, magisch verdrängt; seine Sinne entdecken die unsichtbaren Charaktere, aber das Wissen darum wird durch den Zauber unterdrückt. Wenn ein unsichtbarer Charakter einen anderen Charakter verletzt, wird der angegriffene Charakter nicht mehr von dem Zauber beeinflusst, und alle Betrachter legen augenblicklich eine Durchschauen-Probe mit einem Bonus von +5 ab."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 3,
        url: "/wiki/Phantomkrieger",
        name: "Phantomkrieger",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Erschafft drei Abbilder des Ziels",
        desc: ["Illusion. Dieser Zauber erschafft drei Phantombilder eines Charakters und macht ihn dadurch im Kampf schwerer zu treffen. Der Zauberer bewegt seine Hände in langsamen, abstrakten Bewegungen, zeigt dann auf das Ziel und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erscheinen drei identische Bilder des Ziels. Die Abbilder bleiben immer innerhalb einer Entfernung von 1 Schritt zum Ziel und überlappen sich gelegentlich mit ihm, während sie sich bewegen. Sie bewegen sich nicht vollständig synchron mit dem Ziel; ein Bild mag ein Schwert hoch schwingen, ein anderes tief, das dritte stechen, während das Ziel selbst eine Verteidigungshaltung einnimmt. Die Abbilder verwirren Gegner; das Ziel addiert während der Wirkungsdauer +1 pro Bild (+3) zu seiner Körperlichen Verteidigung. Angriffe durch das Ziel sind für Gegner schwerer abzuwehren beziehungsweise zu vermeiden; sie erleiden auf jede defensive Aktionsprobe gegen einen Angriff des Ziels – wie etwa auf Proben auf Hieb Ausweichen, Riposte und so weiter – einen Malus von -1 pro Bild (-3). Diese Proben gelten als Durchschauen-Proben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Bild)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Illusionist",
        circle: 3,
        url: "/wiki/Und_ein_Schleier_fiel",
        name: "Und ein Schleier fiel",
        threads: 0,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "Selbst",
        dur: "2 Runden",
        eff: "+5 auf Durchschauen-Proben",
        desc: ["Dieser Zauber verbessert die Fähigkeit, Dinge so zu sehen, wie sie wirklich sind. Der Zauberer klatscht laut in die Hände und legt eine Spruchzauberei-Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, erhält er einen Bonus von +5 auf Durchschauen-Proben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 4,
        url: "/wiki/Demaskieren",
        name: "Demaskieren",
        threads: 0,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "+5 auf Proben auf Magie Neutralisieren",
        desc: ["Dieser Zauber enthüllt die wahre körperliche Erscheinung eines Charakters für alle, die hinsehen. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, darf er als Freie Aktion eine Probe auf Magie Neutralisieren mit einem Bonus von +5 gegen den höchsten Neutralisierungsmindestwurf jedes Zaubers oder Talents ablegen, mit dem die Erscheinung des Ziels verborgen wird. Gelingt diese Probe ebenfalls, werden die Auswirkungen dieser Verzauberungen unterdrückt (nicht neutralisiert), und die wahre Erscheinung des Ziels wird für eine Anzahl von Runden gleich dem Spruchzauberei-Rang des Zauberers enthüllt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Illusionist",
        circle: 4,
        url: "/wiki/Ersticken",
        name: "Ersticken",
        threads: 3,
        weaving: 8,
        attune: 13,
        casting: "MVG",
        distance: "40 Schritt",
        dur: "Rang Runden",
        area: "4 Schritt Radius",
        eff: "WIL + 2/Mystisch",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'mr',
        desc: ["Dieser Zauber erstickt Charaktere. Der Zauberer hält die Luft an, atmet dann aus und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, können die Ziele nicht mehr atmen und beginnen zu ersticken. Sie gelten für alle Aktionen außer Willenskraftproben als Bedrängt, und ihre Bewegungsrate wird halbiert, bis sie sich aus dem Wirkungsbereich bewegen oder der Zauber endet. In jeder Runde bestimmt die Wirkungsprobe des Zauberers, wie viel Schaden verursacht wird. Die Ziele dürfen in jeder Runde eine Willenskraftprobe gegen die Wirkungsstufe ablegen, um die Wirkung zu beenden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 4,
        url: "/wiki/Gro%C3%9Fe_Waffe",
        name: "Große Waffe",
        threads: 0,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "Gegner sind Bedrängt",
        desc: ["Illusion. Dieser Zauber lässt eine Nahkampfwaffe von mindestens Größe 2 gefährlicher und größer erscheinen, als sie tatsächlich ist. Der Zauberer vollführt bedrohliche Gesten und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Trägers der Waffe ab. Wenn die Probe gelingt, gilt jeder Gegner, der sich der Waffe gegenübersieht, für die Wirkungsdauer des Zaubers als Bedrängt. Alle defensiven Aktionsproben, die im Kampf gegen den Träger oder die Waffe abgelegt werden, gelten als Durchschauen-Proben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 4,
        url: "/wiki/Halt,_Stehenbleiben",
        name: "Halt, Stehenbleiben",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "WIL",
        eff_roll: {attribute: 'wil', mod: 0},
        desc: ["Dieser Zauber immobilisiert einen Charakter. Der Zauberer hebt eine Hand, ruft so laut wie möglich \"Halt!\" und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bewegen sich die Füße des Ziels nicht mehr von der Stelle; seine Bewegungsrate ist 0 und kann nicht erhöht werden, aber ansonsten kann es normal handeln, wobei es allerdings Bedrängt ist. In jeder Runde darf es eine Willenskraftprobe gegen die Wirkungsstufe ablegen und erhält dafür einen Bonus von +5, sofern es in dieser Runde Schaden erlitten hat. Wenn die Probe gelingt, kann es sich wieder bewegen und der Zauber endet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 4,
        url: "/wiki/Phantomblitzschlag",
        name: "Phantomblitzschlag",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "WIL + 7/Physisch",
        eff_roll: {attribute: 'wil', mod: 7},
        eff_resist: 'pr',
        desc: ["Illusion. Dieser Zauber erscheint wie der Zauber Blitzschlag, ist aber eine Illusion. Der Zauberer hebt seine Hände zum Himmel, zeigt dann auf das Ziel und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schießen knisternde Blitze aus seinen Fingern und treffen das Ziel. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden verursacht wird. Die ursprüngliche Spruchzauberei- Probe wird gegen jedes zusätzliche Ziel verwendet, das sich ergeben mag. Zusätzliche Erfolge bei sekundären Zielen verursachen keine zusätzlichen Blitzschläge. Dieser Zauber kann angezweifelt werden (siehe Illusionen anzweifeln, S. 159)."],
        as: {txt: "Zusätzliches Ziel (+1)"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2), Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 4,
        url: "/wiki/Suggestive_Stimme",
        name: "Suggestive Stimme",
        threads: 3,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "Rang Runden",
        eff: "WIL + 4",
        eff_roll: {attribute: 'wil', mod: 4},
        desc: ["Gebilde. Dieser Zauber erschafft eine imaginäre Stimme, die andere dazu überredet, nach dem Willen des Zauberers zu handeln. Der Zauberer spricht leise zu sich selbst und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab, +1 für jedes zusätzliche Ziel.", "Wenn die Probe gelingt, übersetzt eine illusionäre Stimme, die über beachtliche Autorität verfügt, die Worte des Zauberers automatisch in eine Sprache, die das Ziel versteht. Das Ziel handelt dann gemäß den Anweisungen der Stimme, solange dies nicht offensichtlich schädlich für andere ist.", "Bei drei Erfolgen führt das Ziel die vorgeschlagene Handlung auf jeden Fall aus, selbst wenn sie offensichtlich schädlich für andere ist. Wenn das Ziel davon überzeugt wurde, eine Handlung auszuführen, die andere verletzen würde oder irgendwie gegen es selbst gerichtet ist, kann es eine Willenskraftprobe gegen die Wirkungsstufe ablegen, bevor es die Anweisung ausführt. Der Zauberer kann eine maximale Anzahl von Zielen gleich seinem Spruchzauberei-Rang beeinflussen. Das Ziel wird sich nicht selbst verletzen, und Befehle, dies zu tun, beenden die Zauberwirkung auf das Ziel sofort."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 4,
        url: "/wiki/Unauff%C3%A4lligkeit",
        name: "Unauffälligkeit",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "Erschafft die Illusion, dass das Ziel nicht da is",
        desc: ["Illusion. Dieser Zauber maskiert einen Charakter, sodass andere ihn vollständig ignorieren. Der Zauberer berührt leise das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird jeder im Bereich des Ziels es ignorieren und ihm unbewusst aus dem Weg gehen, um seine Anwesenheit nicht zu bemerken. Wenn das Ziel mit irgendetwas in dem Bereich interagiert, können Betrachter entsprechende Durchschauen-Proben ablegen. Jeder, der aktiv aufpasst (wie z. B. Wachen), kann Wahrnehmungsproben als Durchschauen- Proben ablegen. Jede Absicht, Gewalt auszuüben, beendet den Zauber augenblicklich. Dieser Zauber schützt ausdrücklich nicht vor Arten des astralen Spürens (z. B. Astralsicht)."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 5,
        url: "/wiki/Auge_der_Wahrheit",
        name: "Auge der Wahrheit",
        threads: 1,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Minuten",
        eff: "+5 auf Durchschauen-Proben",
        desc: ["Dieser Zauber erlaubt es, mit fast absoluter Klarheit hinter den Schleier der Illusion zu blicken. Der Zauberer reibt klares, sauberes Wasser über die Augen des Ziels und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel für die Wirkungsdauer des Zaubers einen Bonus von +5 auf alle Durchschauen-Proben gegen Illusionen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Illusionist",
        circle: 5,
        url: "/wiki/Band_der_Verschwiegenheit",
        name: "Band der Verschwiegenheit",
        threads: 2,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Minuten",
        eff: "WIL + 4",
        eff_roll: {attribute: 'wil', mod: 4},
        desc: ["Dieser Zauber hindert einen Charakter daran, direkt über ein bestimmtes Thema, Ereignis oder Individuum zu sprechen (obwohl er immer noch indirekte Hinweise geben kann). Der Zauberer hält den Atem an und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, legt das Ziel immer, wenn es über das verbotene Thema sprechen will, eine Willenskraftprobe gegen die Wirkungsstufe ab. Gelingt diese Probe, kann es normal und frei sprechen und der Zauber endet. Wenn sie misslingt, versagt seine Stimme, und es kann erst weitersprechen, wenn es wieder über ein erlaubtes Thema redet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 5,
        url: "/wiki/Illusion",
        name: "Illusion",
        threads: 3,
        weaving: 9,
        attune: 14,
        casting: "6",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        area: "10 Schritt Radius",
        eff: "Erschafft Illusionen",
        desc: ["Illusion. Dieser Zauber erschafft illusionäre Effekte. Der Zauberer legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, erschafft er eine Illusion, die ein Gebiet von bis zu 10 Schritt Radius ausfüllt. Die Illusionen sind einfach und können keine Namensgeber oder andere komplexe Bilder darstellen. Eine illusionäre Tür zum Beispiel könnte ein paar Zoll auf und zu schwingen, sich aber nicht vollkommen öffnen oder schließen. Ein illusionäres Banner könnte im Wind flattern, ließe sich aber nicht vom Fahnenmast lösen. Der Zauberer kann die Illusion über die normale Wirkungsdauer des Zaubers hinaus aufrechterhalten, indem er zusätzliche Spruchzauberei(6)-Proben (maximale Anzahl gleich seinem Spruchzauberei-Rang) ablegt. Wenn irgendeine Spruchzauberei-Probe misslingt, endet der Zauber, und die Illusion verschwindet. Ein Charakter, der mit der Illusion interagiert, legt mit einer für die Interaktion geeigneten Fähigkeit eine Durchschauen-Probe ab. Zum Beispiel würde ein Charakter, der eine illusionäre Tür öffnet, eine Geschicklichkeitsprobe ablegen, die auch als Durchschauen-Probe zählt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsbereich Ausdehnen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 5,
        url: "/wiki/Phantomfeuerball",
        name: "Phantomfeuerball",
        threads: 1,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "2 Runden",
        area: "4 Schritt Radius",
        eff: "WIL + 5/Physisch und Teilweise Blindheit",
        eff_roll: {attribute: 'wil', mod: 5},
        eff_resist: 'pr',
        desc: ["Illusion. Dieser Zauber erschafft einen illusionären Ball magischen Feuers, ähnlich dem des Zaubers Feuerball. Der Zauberer legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, entspringt eine kleine Feuerkugel in seiner Hand und bewegt sich schnell zum Zielpunkt, während sie sich bis auf den Umfang eines großen Kürbisses ausdehnt, und explodiert dann plötzlich in einer gewaltigen Feuerwolke. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden jedem Ziel zugefügt wird. Von dem Zauber getroffene Ziele sind außerdem bis zum Ende der nächsten Runde Teilweise Blind (Malus von -2 auf alle Aktionen). Dieser Zauber kann angezweifelt werden (siehe Illusionen anzweifeln, S. 159)."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 5,
        url: "/wiki/Presto!",
        name: "Presto!",
        threads: 1,
        weaving: 9,
        attune: 14,
        casting: "6",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Verbindet zwei kleine Öffnungen",
        desc: ["Illusion. Dieser Zauber verbindet die Öffnungen von zwei kleinen Behältern, die gerade so groß sind, dass man die Hand hindurchstecken kann (z. B. ein Hut und ein Krug), und die höchstens 10 Schritt voneinander entfernt sind. Der Zauberer muss einen der Behälter halten und den anderen sehen können. Er wedelt mit seiner Hand über einen der Behälter, während er magische Worte spricht, und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, kann der Zauberer durch die Öffnung des Behälters, den er hält, greifen, und seine Hand kommt aus dem anderen Behälter hervor oder greift in ihn hinein. Der Zauberer kann durch das Miniportal jeden Gegenstand zurückziehen, der durch die Öffnung passt. Die Öffnungen werden durch eine noch kaum verstandene Verzerrung des Astralraums verbunden. Die Verzerrung ist real, aber um die Magie zu beugen, nimmt der Zauber eine Reihe von illusionären \"Abkürzungen\", die zerstört werden können, um die Verbindung zu unterbrechen. Eine erfolgreiche Durchschauen-Probe kappt die Verbindung und beendet den Zauber."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 5,
        url: "/wiki/Rollentausch",
        name: "Rollentausch",
        threads: 3,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        eff: "Vertauscht das Aussehen des Zauberers mit dem des Ziels",
        desc: ["Illusion. Dieser Zauber vertauscht das Aussehen des Zauberers mit dem eines anderen Charakters. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, sieht der Zauberer nun wie das Ziel aus und umgekehrt. Aktionsproben, die gegen das Ziel oder den Zauberer abgelegt werden, gelten als Durchschauen-Proben (siehe Illusionen, S. 158)."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 6,
        url: "/wiki/Astralschatten",
        name: "Astralschatten",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "Verbirgt Ziel vor dem Astralraum",
        desc: ["Illusion. Dieser Zauber macht Lebewesen, die sich in der physischen Welt befinden, im Astralraum schlechter sichtbar. Der Zauberer schwenkt einen Seidenschal vor dem Gesicht des Ziels und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Gelingt die Probe, kann das Ziel, wenn es im Astralraum betrachtet wird, leicht übersehen werden. Das Ziel mit astralen Spürfähigkeiten, wie etwa dem Talent Astralsicht, zu lokalisieren, gilt als Durchschauen-Probe. Abgesehen davon, dass der Zauber die Präsenz des Ziels im Astralraum verschleiert, erhält es keinen Schutz gegen Zauber oder Dämonenkräfte (wie z. B. die Kraft Dämonenmal)."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Illusionist",
        circle: 6,
        url: "/wiki/Echte_Geschosse",
        name: "Echte Geschosse",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "1 Runde",
        area: "6 Schritt Radius",
        eff: "WIL + 4/Physisch und -2 auf nächste Durchschauen-Probe",
        eff_roll: {attribute: 'wil', mod: 4},
        eff_resist: 'pr',
        desc: ["Dieser Zauber sieht genauso aus und wirkt auch genauso wie der Zauber Illusionäre Geschosse, ist aber schwächer als sein illusionärer Zwilling. Der Zauberer bewegt seinen Arm, als werfe er einen Stein, und legt dann eine Spruchzauberei- Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, geht ein Hagel echter Geschosse auf das Gebiet nieder. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden bei jedem Ziel verursacht wird, und jedes Ziel erleidet einen Malus von -2 auf seine nächste Durchschauen-Probe, da seine Wahrnehmung sich verzerrt. Dieser Zauber kann in derselben Zaubermatrix platziert werden wie der Zauber Illusionäre Geschosse."],
        sameAs: "Illusionäre Geschosse",
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 6,
        url: "/wiki/Fliegender_Teppich",
        name: "Fliegender Teppich",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "7",
        distance: "Berührung",
        dur: "Rang Stunden",
        eff: "Erschafft das klassische Transportmittel für Zauberer",
        desc: ["Dieser Zauber verzaubert einen Teppich oder ein anderes Stück Tuch von nicht mehr als vier Quadratschritt Größe in eine fliegende Plattform. Der Zauberer schüttelt den Teppich oder das Tuch energisch aus und legt dann eine Spruchzauberei(7)- Probe ab. Wenn die Probe gelingt, wird das Material belebt und schwebt einige Zoll über dem Boden. Die Grundtragkraft des Teppichs beträgt 200 Pfund. Er hat dieselbe Körperliche und Mystische Verteidigung wie der Zauberer, und wenn er Schaden gleich oder größer seiner Todesschwelle (30) erleidet, endet der Zauber.", "Der Zauberer kann den Teppich verbal kontrollieren, wofür er sich aber konzentrieren muss. Er kann das Kommando über den Teppich auch einem anderen Charakter übergeben, der den Teppich auf die gleiche Weise kontrollieren kann. Der Zauberer kann die Kontrolle über den Teppich jederzeit mit einer erfolgreichen Spruchzauberei(7)-Probe wiedererlangen. Der Teppich ist nicht besonders intelligent und kann leicht verwirrt werden, deshalb müssen die Befehle an ihn einfach sein und sollten am besten nur aus ein paar Wörtern bestehen. Der Teppich fliegt normalerweise mit einer Bewegungsrate von 16 ein paar Zoll über dem Boden, kann aber auf Befehl bis zu 100 Schritt über dem Boden fliegen, wobei er sich pro 2 Schritt horizontaler Bewegung 2 Schritt vertikal bewegt. Der Zauberer kann die Wirkungsdauer auf ein Jahr und einen Tag verlängern, indem er 2 Punkte Blutmagieschaden erleidet. Dieser Schaden kann erst geheilt werden, wenn der Teppich zerstört wird oder der Zauber endet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+200 Pfund)"},
            {txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 6,
        url: "/wiki/Ged%C3%A4chtnisnotiz",
        name: "Gedächtnisnotiz",
        threads: 4,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Stunden",
        eff: "WIL + 6",
        eff_roll: {attribute: 'wil', mod: 6},
        desc: ["Dieser Zauber verändert das Gedächtnis eines Charakters, sodass er sich anders an Dinge erinnert, als sie sich tatsächlich zugetragen haben. Der Zauberer berührt das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, kann er pro Erfolg eine Tatsache verändern, an die sich das Ziel über ein bestimmtes Thema oder Ereignis erinnert. Eine erfolgreiche Willenskraftprobe gegen die Wirkungsstufe beendet den Zauber.", "Das Ziel legt außerdem jedes Mal eine Willenskraftprobe ab, wenn es sich an die gefälschte Erinnerung \"erinnert\". Wenn die Probe gelingt, oder wenn der Zauber endet, erinnert sich das Ziel wieder ganz normal. Der Zauberer kann die Wirkungsdauer des Zaubers auf ein Jahr und einen Tag verlängern, indem er 3 Punkte Blutmagieschaden erleidet. Dieser Schaden kann erst geheilt werden, wenn der Zauber endet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 6,
        url: "/wiki/Illusion%C3%A4re_Geschosse",
        name: "Illusionäre Geschosse",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "1 Runde",
        area: "6 Schritt Radius",
        eff: "WIL + 8/Physisch",
        eff_roll: {attribute: 'wil', mod: 8},
        eff_resist: 'pr',
        desc: ["Illusion. Dieser Zauber erschafft ein illusionäres Trommelfeuer von Geschossen. Der Zauberer bewegt seinen Arm, als werfe er einen Stein, und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, geht ein Hagel illusionärer Geschosse auf das Gebiet nieder. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden bei jedem Ziel verursacht wird. Dieser Zauber kann angezweifelt werden (siehe Illusionen anzweifeln, S. 159).", "Dieser Zauber kann in derselben Zaubermatrix platziert werden wie der Zauber Echte Geschosse."],
        sameAs: "Echte Geschosse",
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 6,
        url: "/wiki/Positiontausch",
        name: "Positiontausch",
        threads: 3,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "1 Runde",
        eff: "Vertauscht die Position des Zauberers mit der des Ziels",
        desc: ["Dieser Zauber sieht genauso aus wie der Zauber Rollentausch, führt aber zu einem echten Austausch anstelle eines illusionären. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, tauscht der Zauber die Position des Zauberers mit der des Ziels. Der physische Austausch ist nicht durch magische oder lebende Barrieren hindurch möglich."],
        as: {txt: "-"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 6,
        url: "/wiki/Vorgezeichneter_Weg",
        name: "Vorgezeichneter Weg",
        threads: 3,
        weaving: 10,
        attune: 15,
        casting: "6",
        distance: "Berührung",
        dur: "Rang Stunden",
        area: "60 Schritt",
        eff: "WIL + 8",
        eff_roll: {attribute: 'wil', mod: 8},
        desc: ["Dieser Zauber lässt andere einen Weg nach Wahl des Zauberers beschreiten, wenn sie mehrere Wege zur Auswahl haben. Der Zauberer betrachtet einen Weg (ein Paar Türen, eine Straßengabelung und so weiter), den er gerade sieht, macht dann seine Wahl kenntlich und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt und andere mit einer Richtungswahl an demselben Ort konfrontiert werden, denken sie, dass sie die Entscheidung getroffen haben, aber in Wahrheit wählen sie genau den Weg aus, den der Zauberer bestimmt hat. Die Täuschung wird offensichtlich, sobald sie außer Reichweite des Zaubers gelangen oder der Zauber endet. Sollte die Zielgruppe entscheiden, ihre Spuren zurückzuverfolgen und den korrekten Weg von demselben Punkt aus zu nehmen, legt sie eine Willenskraftprobe gegen die Wirkungsstufe ab, um zu sehen, ob sie wieder auf den falschen Weg gebracht wird oder nicht."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 7,
        url: "/wiki/Gebrabbel",
        name: "Gebrabbel",
        threads: 1,
        weaving: 11,
        attune: 16,
        casting: "MVG+",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        eff: "Bringt die Sprache des Ziels durcheinander",
        desc: ["Illusion. Dieser Zauber bringt die Sprache durcheinander. Der Zauberer murmelt unsinnige Silben vor sich hin und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab, +1 für jedes zusätzliche Ziel. Wenn die Probe gelingt, werden die Worte der Ziele zu Unsinn verändert; zum Beispiel würde sich \"Tötet sie!\" wie \"Slig covo bebop buttery!\" anhören. Niemand versteht, was die Ziele sagen. Jede Fremdsprachen-Probe, die die Ziele ablegen, gilt als Durchschauen-Probe (siehe Illusionen, S. 158). Der Zauberer kann eine maximale Anzahl von Zielen gleich seinem Rang in Spruchzauberei beeinflussen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 7,
        url: "/wiki/Illusion%C3%A4re_Stampede",
        name: "Illusionäre Stampede",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "Rang Runden",
        eff: "Ziele sind Bedrängt",
        desc: ["Illusion. Dieser Zauber erschafft die Illusion einer Stampede. Der Zauberer stampft auf und schnaubt und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe in Zauberreichweite ab, +1 für jedes zusätzliche Ziel. Wenn die Probe gelingt, glauben die Ziele, dass eine Stampede auf sie zukommt, und werden Bedrängt. Das Wirken dieses Zaubers in einem Gebiet, in dem eine Stampede normalerweise unmöglich ist (in einem Haus, auf einem Luftschiff und so weiter), erlaubt den Zielen eine Durchschauen-Probe (S. 158) mit einem Bonus von +5. Der Zauberer kann eine maximale Anzahl von Zielen gleich seinem Rang in Spruchzauberei beeinflussen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 7,
        url: "/wiki/Lautlose_Stampede",
        name: "Lautlose Stampede",
        threads: 4,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Stunden",
        eff: "Dämpft Geräusche, +4 auf alle auf Heimlichkeit basierenden Aktionsproben",
        desc: ["Dieser Zauber dämpft die Geräusche, die von einer Gruppe von Charakteren oder Tieren verursacht werden, einschließlich Bewegung, Gesprächen, Atmen, Pferdegewieher und so weiter. Der Zauberer wandert um die Gruppe herum und berührt jeden Charakter und jedes Tier, das von dem Zauber beeinflusst werden soll. Dann legt er eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab, +1 für jedes zusätzliche Ziel. Wenn die Probe gelingt, werden alle Geräusche unterdrückt, die die Zielgruppe verursacht. Alle Mitglieder der Gruppe erhalten einen Bonus von +4 auf alle auf Heimlichkeit basierenden Aktionsproben. Die Ziele können Heimlicher Schritt als improvisierte Fertigkeit verwenden, selbst wenn sie sie nicht beherrschen. Der Entdeckungsmindestwurf aller auf Gehör basierenden Wahrnehmungsproben, um Mitglieder der Gruppe zu entdecken, wird um +4 erhöht. Der Zauberer kann mit diesem Zauber gleichzeitig eine maximale Anzahl von Charakteren und Tieren gleich seinem Spruchzauberei-Rang x 3 beeinflussen. Der Zauber verbirgt die Zielgruppe nicht vor Wahrnehmungsproben, die auf Sicht, Geruch oder Berührung basieren."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 7,
        url: "/wiki/Schwindelgef%C3%BChl",
        name: "Schwindelgefühl",
        threads: 1,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "30 Schritt",
        dur: "Rang Runden",
        eff: "Pro Erfolg -2 auf Aktionsproben",
        desc: ["Dieser Zauber desorientiert einen Charakter. Der Zauberer dreht sich um sich selbst und führt so einen leichten Drehwurm herbei. Dann legt er eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, kann das Ziel nicht länger oben von unten unterscheiden und ist äußerst desorientiert. Es erleidet pro Erfolg bei der Spruchzauberei- Probe einen Malus von -2 auf seine Aktionsproben."],
        as: {txt: "siehe Text"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Erfolg)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Illusionist",
        circle: 7,
        url: "/wiki/Tanzender_Drache",
        name: "Tanzender Drache",
        threads: 4,
        weaving: 11,
        attune: 16,
        casting: "12",
        distance: "60 Schritt",
        dur: "Rang Runden",
        eff: "Illusionistenkreis + 8/Physisch",
        desc: ["Illusion. Dieser Zauber beschwört die Illusion eines wilden Drachen aus tiefschwarzen Schatten. Der Zauberer erzeugt mit seinen Händen den Schatten eines Drachenkopfes auf einer Wand oder anderen Oberfläche und legt eine Spruchzauberei(12)- Probe ab. Wenn die Probe gelingt, fließt ein 6 Schritt hoher, 10 Schritt langer und 4 Schritt breiter Drache aus den umgebenden Schatten zusammen. In jeder Runde kann sich der Zauberer konzentrieren, um ein Ziel neben dem Drachen auszuwählen, das der Drache mit der Spruchzaubereistufe des Zauberers angreift. Wenn diese Probe gelingt, kann der Zauberer eine Schadensprobe mit seiner Wirkungsstufe ablegen. Der Drache hat eine Bewegungsrate von 16 und kann über Hindernisse fliegen, wenn genügend Platz ist. Jede Probe, die mit dem Drachen interagiert (z. B. Angriffsproben oder Hieb Ausweichen), gilt als Durchschauen-Probe."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 7,
        url: "/wiki/Zeitweilige_%C3%96ffnung",
        name: "Zeitweilige Öffnung",
        threads: 1,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 15 Runden",
        eff: "Erschafft eine zeitweilige Öffnung durch ein Hindernis",
        desc: ["Dieser Zauber erschafft eine zeitweilige Öffnung durch eine Wand, ein Tor oder ein anderes Hindernis, das nicht mehr als 2 Schritt dick ist. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Hindernisses ab. Wenn die Probe gelingt, wird eine Öffnung erschaffen, die allerdings nicht sehr stabil ist. Sie windet sich, erweitert sich und zieht sich zufällig zusammen. Die Anzahl der Erfolge bestimmt, wie groß die Öffnung im Vergleich zu einem Menschen ist. Bei einem Erfolg kann sich ein Charakter pro Runde hindurchwinden, wozu er allerdings eine erfolgreiche Geschicklichkeits(7)- Probe ablegen muss. Bei zwei Erfolgen kann ein Charakter pro Runde einfach durch die Öffnung treten (es ist keine Geschicklichkeitsprobe erforderlich). Bei drei Erfolgen können pro Runde so viele Charaktere durch die Öffnung treten, wie der Rang des Zauberers in Spruchzauberei beträgt."],
        as: {txt: "siehe Text"},
        at: [{txt: "Wirkung Verstärken (+1 Erfolg)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 8,
        url: "/wiki/Dimensionstor",
        name: "Dimensionstor",
        threads: 3,
        weaving: 12,
        attune: 17,
        casting: "MVS",
        distance: "1 Meile",
        dur: "Rang Stunden",
        eff: "Verbindet zwei Portale",
        desc: ["Illusion. Dieser Zauber verbindet zwei Portale, die nicht weiter als eine Meile voneinander entfernt sind. Der Zauber muss innerhalb von zwei Stunden zweimal gewirkt werden, zuerst auf das Zielportal, dann auf das Startportal.", "Der Zauberer legt für jedes Portal eine Spruchzauberei-Probe gegen seine eigene Mystische Verteidigung ab. Wenn ihm beide Proben gelingen, überwinden Charaktere, die durch das Startportal gehen, sofort die Entfernung zum Zielportal. Die Portale sind durch eine noch kaum verstandene Verzerrung des Astralraums miteinander verbunden. Die Verzerrung ist real, aber um die Magie zu beugen, nimmt der Zauber eine Reihe von illusionären \"Abkürzungen\", die zerstört werden können, um die Verbindung zu unterbrechen. Eine erfolgreiche Durchschauen- Probe kappt die Verbindung und beendet den Zauber."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+1 Meile)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 8,
        url: "/wiki/Gesichtslos",
        name: "Gesichtslos",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang + 5 Runden",
        eff: "Entfernt die Gesichtszüge des Ziels",
        desc: ["Illusion. Mit diesem Zauber kann der Zauberer das Ziel und alle Zuschauer davon überzeugen, dass die Gesichtszüge des Ziels entfernt worden sind, sodass es weder sehen noch sprechen kann. Der Zauberer reibt sich mit den Händen wild im Gesicht herum, schaut dann das Ziel an und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird das Gesicht des Ziels vollständig strukturlos. Das Ziel kann weder sprechen noch irgendwelche Talente oder Fähigkeiten einsetzen, die Sprache erfordern, ist effektiv \"blind\" und erleidet den Malus für Volle Dunkelheit auf Aktionsproben, die auf Sicht basieren. Alle auf Sicht oder Sprache basierenden Aktionsproben, die das Ziel ablegt, gelten als Durchschauen- Proben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Illusionist",
        circle: 8,
        url: "/wiki/Gestalttausch",
        name: "Gestalttausch",
        threads: 4,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Minuten",
        eff: "Tauscht Position und Aussehen mit einem Ziel",
        desc: ["Illusion. Dieser Zauber vertauscht die Position und das Aussehen des Zauberers mit einem anderen Charakter. Der Zauberer schaut das Ziel intensiv an und merkt sich dessen Position und Aussehen. Dann legt er eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, tauscht der Zauberer die Gestalt mit dem Ziel – er sieht jetzt genauso aus wie das Ziel und steht dort, wo das Ziel ursprünglich stand, während das Ziel nun da steht, wo der Zauberer stand, und aussieht wie er. Wenn der Zauber endet, verschwindet das illusionäre Bild, aber das Ziel und der Zauberer bleiben an ihren neuen Positionen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Illusionist",
        circle: 8,
        url: "/wiki/Gestank",
        name: "Gestank",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        area: "4 Schritt Radius",
        eff: "Verhindert Aktionen durch überwältigenden Gestank",
        desc: ["Illusion. Dieser Zauber erschafft die Illusion eines fürchterlichen Gestanks, und alle, die ihn riechen, müssen unkontrolliert würgen und sich erbrechen. Der Zauberer zerdrückt mehrere Blüten des Stinkkrauts oder einer ähnlich stinkenden Pflanze und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab.", "Wenn die Probe gelingt, entsteht ein entsetzlicher Gestank, der alle beeinflussten Ziele komplett unfähig werden lässt, etwas anderes zu tun, als sich darauf zu konzentrieren, ihre letzte Mahlzeit bei sich zu behalten. Ein beeinflusstes Ziel muss eine erfolgreiche Willenskraftprobe als Durchschauen-Probe ablegen, um überhaupt irgendetwas tun zu können, einschließlich Bewegung. Wenn die Probe gelingt, kann das Ziel normal handeln und erkennt die Illusion, wird aber weiterhin von dem Gestank beeinflusst, wenn es im Wirkungsbereich bleibt. Misslingt die Probe, kann es nichts anderes tun, als sich zu erbrechen, und gilt als Niedergeschlagen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Illusionist",
        circle: 8,
        url: "/wiki/Rebellische_Gliedma%C3%9Fe",
        name: "Rebellische Gliedmaße",
        threads: 1,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "WIL + 4",
        eff_roll: {attribute: 'wil', mod: 4},
        desc: ["Dieser Zauber übernimmt die Kontrolle über eine Gliedmaße. Der Zauberer schüttelt eine seiner eigenen Gliedmaßen gegen das Ziel und legt dann eine Spruchzauberei gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, übernimmt er die Kontrolle über eine der Gliedmaßen des Ziels. Er kontrolliert die Bewegung der Gliedmaße so lange, wie sich das Ziel innerhalb der Zauberreichweite befindet. Die Gliedmaße handelt mit allen passenden körperlichen Talenten ihres Besitzers, d. h. ein Arm kann angreifen, ein Bein kann treten und so weiter. In jeder Runde kann das Ziel versuchen, die Kontrolle über seine Gliedmaße wiederzuerlangen, indem es eine erfolgreiche Willenskraftprobe gegen die Wirkungsstufe ablegt. Wenn das Ziel durch seine eigene Gliedmaße angegriffen wird, erhält es einen Bonus von +3 auf seine Willenskraftprobe."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"}]
    },
    {
        discipline: "Illusionist",
        circle: 8,
        url: "/wiki/Zauber_%C3%9Cberschatten",
        name: "Zauber Überschatten",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        eff: "WIL + 4",
        eff_roll: {attribute: 'wil', mod: 4},
        desc: ["Dieser mächtige Zauber schwächt die Wirkung der Zauber eines Zauberers ab, indem der Großteil ihrer Kraft zurück in den Astralraum gelenkt wird. Der Zauberer legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Zielzauberers ab. Wenn die Probe gelingt, wird das Ergebnis der Wirkungsprobe vom Ergebnis jeder Wirkungsprobe abgezogen, die vom Ziel abgelegt wird. Wenn der Zauber das Ergebnis einer Wirkungsprobe des Ziels auf 0 senkt, wird der Zauber zu einem harmlosen Schatten seiner selbst – Erscheinung ohne Wirkung. In jeder Runde kann das Ziel eine Willenskraftprobe gegen die Wirkungsstufe ablegen. Wenn die Probe gelingt, endet der Zauber. Dieser Zauber wirkt nicht gegen Talente, Kreaturenkräfte oder andere Formen der Magie außer Spruchzauberei."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Astralsinn",
        name: "Astralsinn",
        threads: 2,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang + 10 Minuten",
        area: "30 Schritt",
        eff: "Verstärkt astrales Spüren",
        desc: ["Dieser Zauber verstärkt die Anwendung des Talents Astralsicht. Der Zauberer verdreht seine Augen und legt eine Spruchzauberei-Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, kann er das Talent Astralsicht verwenden, ohne Überanstrengung zu erleiden, und kann magische Präsenzen spüren, die sich nicht in seinem Blickfeld befinden (weil sie zum Beispiel hinter ihm oder auf andere Weise verborgen sind). Wenn er das Talent Astralsicht nicht beherrscht, kann er Astralsicht-Proben mit seiner Wahrnehmungsstufe ablegen. Die Verstärkungen auf Astralsicht wirken nur auf Ziele im Wirkungsbereich. Nach dem Wirken des Zaubers nimmt sich ein Zauberer gewöhnlich ein paar Augenblicke Zeit, um den Wirkungsbereich abzusuchen und sicherzustellen, dass eine astrale Präsenz nicht von einem seiner Gefährten stammt. Der Zauberer kann versuchen, einen Zauber auf ein Ziel zu wirken, das er astral gespürt hat, selbst wenn er es nicht auf andere Weise sehen kann.", "Zauberer verwenden diesen Zauber aus vielen unterschiedlichen Gründen. Er wird oft gewirkt, um astrale Untersuchungen weniger anstrengend zu machen. Wie bei der normalen Anwendung von Astralsicht kann ein Zauberer, der Astralsinn zum Betrachten eines Fadengegenstands einsetzt, die Wahre Struktur des Gegenstands spüren und erfahren, dass der Gegenstand magisch ist. Er erhält aber keine Informationen über die Geschichte des Gegenstands und erfährt auch keine Schlüsselinformationen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsbereich Ausdehnen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Aura_Lesen",
        name: "Aura Lesen",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "Sammelt Informationen über den Zustand des Ziels",
        desc: ["Dieser Zauber offenbart Aspekte der Aura von Lebewesen. Der Zauberer starrt das Ziel durchdringend an und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt er, was er aus der Aura des Ziels herauslesen will – dies kann alles sein, von Gefühlszuständen wie Zorn oder Furcht bis hin zu Verletzungen oder Erschöpfung. Der Zauberer kann für jeden Erfolg einen Aspekt in Erfahrung bringen."],
        as: {txt: "siehe Text"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Erfolg)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Blendende_Zurschaustellung_Logischer_Analyse",
        name: "Blendende Zurschaustellung Logischer Analyse",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Minuten",
        eff: "+4 auf verbale Proben, die auf Charisma basieren",
        desc: ["Dieser Zauber verstärkt die eigenen Argumente in einem Streit oder einer Debatte. Der Zauberer richtet sich zu seiner vollen Größe auf und legt eine Spruchzauberei-Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, erhält er einen Bonus von +4 auf alle auf Charisma basierenden Proben, die mit Konversation, Debattieren, Streiten oder anderen verbalen Spielarten der Rhetorik zu tun haben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Eiserne_Hand",
        name: "Eiserne Hand",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "+3 auf Nahkampfschadensproben",
        desc: ["Dieser Zauber erhöht die Fähigkeit eines Charakters, Schaden zu verursachen. Der Zauberer ahmt eine Schlagbewegung nach und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird die Haut des Ziels mattgrau, und es erhält einen Bonus von +3 auf alle Schadensproben im Nahkampf, die es während der Wirkungsdauer des Zaubers ablegt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Flammenblitz",
        name: "Flammenblitz",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "2 Runden",
        eff: "WIL + 5/Physisch",
        eff_roll: {attribute: 'wil', mod: 5},
        eff_resist: 'pr',
        desc: ["Feuer. Dieser Zauber gibt einen Feuerstoß blauer arkaner Flammen auf einen Gegner ab. Der Zauberer vollführt wilde, anfachende Bewegungen und gibt knackende, zischende Geräusche von sich, streckt dann seine Hände aus und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, schießen Flammen aus seinen Fingerspitzen und baden das Ziel in magischem Feuer. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden in jeder Runde verursacht wird."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Katzenaugen",
        name: "Katzenaugen",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "Ziel erhält Nachtsicht",
        desc: ["Dieser Zauber verleiht dem Ziel die Fähigkeit, in fast völliger Dunkelheit zu sehen. Der Zauberer blinzelt mehrere Male, berührt dann das Ziel leicht an den Augenlidern und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel die Fähigkeit Nachtsicht – seine Pupillen werden zu vertikalen Schlitzen, ähnlich denen einer Katze, reflektieren das auf sie treffende Licht und scheinen in der Dunkelheit zu leuchten. Dieser Zauber hat keine Wirkung auf Ziele mit Nachtsicht."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Kletterhilfe",
        name: "Kletterhilfe",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+4 auf Klettern-Proben",
        desc: ["Dieser Zauber verbessert die Kletterfähigkeit eines Charakters. Der Zauberer kriecht auf allen Vieren, berührt dann das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel einen Bonus von +4 auf Klettern-Proben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Mentaler_Dolch",
        name: "Mentaler Dolch",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "2 Runden",
        eff: "WIL + 2/Mystisch und -2 auf Körperliche Verteidigung",
        eff_resist: 'mr',
        eff_roll: {attribute: 'wil', mod: 2},
        eff_mod: [{what: "kv", mod: -2, type: 'rounds', duration: 2}],
        desc: ["Dieser Zauber greift einen Gegner durch reine Willensstärke an und lässt ihn taumeln. Der Zauberer bewegt seinen Arm, als schleuderte er einen Dolch, und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe, wie viel Schaden einmalig verursacht wird. Zusätzlich erleidet das Ziel bis zum Ende der nächsten Runde einen Malus von -2 auf seine Körperliche Verteidigung."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (-2 auf Körperliche Verteidigung)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Schneller_zu_Fu%C3%9F",
        name: "Schneller zu Fuß",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Stunden",
        eff: "Bewegungsrate +2",
        eff_mod: [{what: "movement", mod: 2, type: 'hours', duration: 2}],
        desc: ["Dieser Zauber erhöht die Laufgeschwindigkeit. Der Zauberer geht schnellen Schrittes in einem Kreis um das Ziel herum, berührt es dann und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhöht das Ziel seine Bewegungsrate um +2."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Schnelllesen",
        name: "Schnelllesen",
        threads: 1,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Stunden",
        eff: "+4 auf alle Forschen-Proben",
        eff_mod: [{what: "Forschen", mod: +4, type: 'hours', duration: 'rang'}],
        desc: ["Dieser Zauber erlaubt es einem Zauberer, mit unglaublicher Geschwindigkeit zu lesen, und stellt eine perfekte Erinnerung an die gelesenen Informationen zur Verfügung. Der Zauberer schließt die Augen, atmet langsam aus und legt eine Spruchzauberei- Probe gegen seine Mystische Verteidigung ab.", "Wenn die Probe gelingt, wird er von einer tiefen Konzentration erfüllt, sodass er einen Malus von -5 auf alle Wahrnehmungsproben erleidet, um irgendetwas außerhalb seines Fokus zu bemerken. Er erhält allerdings auch die Fähigkeit, eine Seite pro Sekunde zu lesen, und kann sich für die Wirkungsdauer des Zaubers an all diese gelesenen Informationen ohne Fehler erinnern. Dies gewährt ihm einen Bonus von +4 auf alle Forschen- Proben und kann die Intervalle für Forschen-Proben (nach Maßgabe des Spielleiters) verkürzen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (+2 auf Forschen- Proben)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Magier",
        circle: 1,
        url: "/wiki/Verzauberte_R%C3%BCstung",
        name: "Verzauberte Rüstung",
        threads: 0,
        weaving: 5,
        attune: 10,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "+3 auf Physische Rüstung",
        eff_mod: [{what: "pr", mod: +3, type: 'rounds', duration: 'rang'}],
        desc: ["Dieser Zauber erzeugt eine geisterhafte violette Schicht über dem Ziel. Der Zauberer schlägt das Ziel, macht dabei ein weiches, gedämpftes Geräusch, als ob ein unwirksamer Treffer erzielt wurde, und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhöht das Ziel seine Physische Rüstung für die Wirkungsdauer des Zaubers um +3. Ziele, die mit diesem Zauber belegt sind, leuchten in einem schwachen Violett, das im Dunkeln oder mit Astralsicht wahrnehmbar ist."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Physische Rüstung +2)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 2,
        url: "/wiki/Astralschild",
        name: "Astralschild",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZa",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "+2 auf Mystische Verteidigung",
        eff_mod: [{what: "mv", mod: 2, type: 'rounds', duration: 'rang'}],
        desc: ["Dieser Zauber verstärkt die Resistenz eines Charakters gegen Magie. Der Zauberer schlägt mit der Hand ein schützendes Zeichen, zeigt auf das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Charaktere, die der Zauberer astral gespürt hat (siehe S. 123), können als Zusätzliche Ziele mit dem Zauber belegt werden, was die Wirkschwierigkeit jeweils um +1 erhöht. Wenn die Probe gelingt, erhöht das Ziel seine Mystische Verteidigung um +2."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Mystische Verteidigung +2)", what: ['mv'], mod: 2},
            {txt: "Wirkungsdauer Verlängern (Minuten)", what: ['dur'], mod_duration: 'minutes'}
        ]
    },
    {
        discipline: "Magier",
        circle: 2,
        url: "/wiki/Ausweichschub",
        name: "Ausweichschub",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang + 5 Runden",
        eff: "+2 für Proben auf Hieb Ausweichen",
        desc: ["Dieser Zauber verbessert die Fähigkeit eines Charakters, Angriffen im Kampf auszuweichen. Der Zauberer schwankt seitwärts und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel einen Bonus von +2 für alle Proben auf Hieb Ausweichen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 2,
        url: "/wiki/Fadenkreuz",
        name: "Fadenkreuz",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 5 Runden",
        eff: "+3 auf Angriffsproben im Fernkampf",
        desc: ["Dieser Zauber schärft Sicht und Fokus des Ziels und optimiert sie für den Fernkampf. Der Zauberer fährt mit den Fingern am Kopf des Ziels entlang, über seine Augen und legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, nehmen die Augen des Ziels eine unnatürliche Erscheinung an (die bei jedem Zauberer anders aussieht). Das Ziel erhält einen Bonus von +3 auf seine Fernkampfangriffsproben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 2,
        url: "/wiki/Interferenzausgleich",
        name: "Interferenzausgleich",
        threads: 0,
        weaving: 6,
        attune: 11,
        casting: "MVZa",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "Eliminiert Modifikatoren durch Astrale Interferen",
        desc: ["Dieser Zauber eliminiert alle Modifikatoren, die durch das Talent Astrale Interferenz verursacht werden, indem er das \"Rauschen\" isoliert und es auf das Niveau des restlichen Astralraums im Wirkungsbereich senkt. Der Zauberer hält beide Hände in Bauchhöhe, bringt eine Hand im Bogen nach oben und lässt sie dann auf seine andere Hand fallen, und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Charaktere, die der Zauberer astral gespürt hat (siehe S. 123), können als Zusätzliche Ziele mit dem Zauber belegt werden, was die Wirkschwierigkeit jeweils um +1 erhöht. Wenn die Probe gelingt, werden die durch Astrale Interferenz verursachten Modifikatoren eliminiert."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"}]
    },
    {
        discipline: "Magier",
        circle: 2,
        url: "/wiki/Strickleiter",
        name: "Strickleiter",
        threads: 2,
        weaving: 6,
        attune: 11,
        casting: "6",
        distance: "Berührung",
        dur: "Rang Minuten",
        area: "50 Schritt Radius",
        eff: "Erschafft eine Leiter aus Seil",
        desc: ["Dieser Zauber erschafft eine Leiter aus einem Seil. Der Zauberer entrollt das Seil und legt dann eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, bewegt sich das Seil innerhalb des Wirkungsbereichs mit Bewegungsrate 10 zu einem Ort, den der Zauberer auswählt. Der Zauberer kann das Seil nicht so präzise steuern, dass es sich beispielsweise um ein Fenstergitter schlingt. Es bewegt sich einfach direkt von A nach B. Charaktere, die an dem Seil emporklettern, erhalten einen Bonus von +4 auf ihre Klettern-Proben. Das Seil kann ein maximales Gewicht von 600 Pfund halten."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsbereich Ausdehnen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Magier",
        circle: 2,
        url: "/wiki/Vernichtender_Wille",
        name: "Vernichtender Wille",
        threads: 1,
        weaving: 6,
        attune: 11,
        casting: "MVZ",
        distance: "50 Schritt",
        dur: "2 Runden",
        eff: "WIL + 3/Mystisch und -2 auf Mystische Verteidigung",
        eff_roll: {attribute: 'wil', mod: 2},
        eff_resist: 'mr',
        eff_mod: [{what: 'mv', mod: -2, type: 'rounds', duration: 2}],
        desc: ["Dieser Zauber greift direkt den Willen eines Charakters an. Der Zauberer zieht seine Augenbrauen zusammen, starrt das Ziel an und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt die Wirkungsprobe, wie viel Schaden einmalig verursacht wird. Zusätzlich erleidet das Ziel bis zum Ende der nächsten Runde einen Malus von -2 auf seine Mystische Verteidigung."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", mod: 2, mod_duration: 'round'},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['wil'], mod: 2},
            {txt: "Wirkung Verstärken (Mystische Verteidigung -2)", what: ['mv'], mod: -2},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 3,
        url: "/wiki/Astralvisier",
        name: "Astralvisier",
        threads: 0,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Runden",
        eff: "+2 auf Spruchzauberei- und Wirkungsproben",
        eff_mod: [
            {what: 'Spruchzauberei', mod: -2, type: 'rounds', duration: 'rang'},
            {what: 'eff', mod: 2, type: 'rounds', duration: 'rang'}
        ],
        desc: ["Dieser Zauber verbessert die Zauber des Zauberers gegen ein Ziel, das er astral gespürt hat (S. 123). Der Zauberer öffnet seine Augen weit, und leuchtend rotes Licht geht von ihnen aus. Dann legt er eine Spruchzauberei-Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, schweben leuchtend rote Runen vor seinen Augen, und er erhält einen Bonus von +2 auf seine Spruchzauberei- und Wirkungsproben gegen jedes Ziel, das er astral gespürt hat."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", mod: 2, mod_duration: 'round'},
        at: [{txt: "Wirkungsdauer Verlängern (Minuten)", mod_duration: 'minutes'}]
    },
    {
        discipline: "Magier",
        circle: 3,
        url: "/wiki/Auraschlag",
        name: "Auraschlag",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "WIL + 3/Mystisch",
        eff_roll: {attribute: 'wil', mod: 3},
        eff_resist: 'mr',
        desc: ["Dieser Zauber leitet destruktive Energien in schwache Teile der Struktur eines Charakters, den der Zauberer astral gespürt hat (S. 123). Der Zauberer zieht die Augenbrauen zusammen, blinzelt mit den Augen und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt die Wirkungsprobe, wie viel Schaden verursacht wird. Das Ziel erleidet immer genau eine Wunde durch diesen Zauber – egal, wie viel Schaden es erlitten hat."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['wil'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['wil'], mod: 2},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 3,
        url: "/wiki/Kampfeswut",
        name: "Kampfeswut",
        threads: 0,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 10 Runden",
        eff: "+2 auf Angriffsproben im Nahkampf",
        desc: ["Dieser Zauber versetzt einen freiwilligen Charakter im Kampf in Raserei. Der Zauberer schimpft und gestikuliert wild, berührt dann das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erhält das Ziel einen Bonus von +2 auf Angriffsproben im Nahkampf. Das Ziel darf während der Wirkungsdauer des Zaubers nur Nahkampfangriffe ausführen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", mod_duration: 'rounds', mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 3,
        url: "/wiki/Levitation",
        name: "Levitation",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVG",
        distance: "40 Schritt",
        dur: "Rang + 10 Minuten",
        area: "2 Schritt Radius",
        eff: "Levitiert bis zu 1.000 Pfund",
        desc: ["Dieser Zauber bewegt Gegenstände auf einer unsichtbaren Plattform mit 2 Schritt Radius nach oben oder unten. Der Zauberer hebt und senkt seine Hände und legt eine Spruchzaubereiprobe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, wird eine Plattform erschaffen, die auf Befehl des Zauberers alle, die sich darauf befinden, mit einer Geschwindigkeit von 4 Schritt pro Runde (bis zu einer maximalen Höhe gleich der Zauberreichweite) nach oben oder nach unten bewegen kann. Ein einzelner Zauber kann bis zu 1.000 Pfund heben.", "Der Zauberer kann mehrere Levitationszauber verknüpfen, um die Wirkung zu verbessern. Er kann einen weiteren Zauber auf eine existierende Plattform wirken, um das maximale Gewicht, das levitiert werden kann, zu erhöhen. Der Zauberer kann sich auch bis zum oberen Ende des ersten Levitationszaubers levitieren und dort einen weiteren (oder mehrere) Levitationszauber wirken, um noch höher zu gelangen. Verknüpfte Levitationszauber erfordern einige Sorgfalt; sobald einer der niedrigeren Zauber endet, enden auch alle Levitationszauber in größerer Höhe sofort. Charaktere und Gegenstände, die sich auf einer Plattform befinden, wenn sie sich auflöst, erleiden Fallschaden (siehe Spielleiterhandbuch) entsprechend der Höhe, aus der sie fallen.", "Die Plattform zu bewegen erfordert die Konzentration des Zauberers, egal, wie viele verknüpfte Levitationszauber er gerade kontrolliert. Wenn er die Konzentration verliert, sinkt die Plattform automatisch mit einer Geschwindigkeit von 4 Schritt pro Runde zu Boden.", "Der Zauberer muss eine Spruchzauberei-Probe ablegen, wenn die Zahl der Gegenstände oder Charaktere auf einer Plattform steigt (weil zum Beispiel ein weiterer Charakter auf die Plattform springt). Wenn diese Probe misslingt, endet der Zauber."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Magier",
        circle: 3,
        url: "/wiki/Magie_Identifizieren",
        name: "Magie Identifizieren",
        threads: 1,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "1 Runde",
        eff: "Identifiziert Magieart",
        desc: ["Dieser Zauber identifiziert die Art von Magie, die auf eine Person, einen Ort oder einen Gegenstand wirkt. Der Zauberer starrt das Ziel durchdringend an und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt die Anzahl der Erfolge, was er erfährt. Ein Erfolg enthüllt, ob das Ziel magisch ist. Zwei Erfolge enthüllen allgemein die Art von Magie, die das Ziel besitzt – Adeptenfähigkeiten, inhärente Magie, Spruchzauberei und so weiter. Drei Erfolge enthüllen die genaue Art der Magie – im Falle von Adepten die Disziplin und den Kreis, im Falle von magischen Gegenständen die Kräfte und Fähigkeiten. Das Wirken dieses Zaubers auf einen Fadengegenstand offenbart keine Informationen zu Schlüsselinformationen, sondern nur, dass es sich um einen Fadengegenstand handelt, und ein allgemeines Gefühl von seinen Kräften."],
        as: {txt: "Wirkung Verstärken (siehe Text)"},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (+1 Erfolg)"}]
    },
    {
        discipline: "Magier",
        circle: 3,
        url: "/wiki/Magiermal",
        name: "Magiermal",
        threads: 2,
        weaving: 7,
        attune: 12,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Stunden",
        eff: "Platziert astrale Markierung auf Ziel",
        desc: ["Dieser Zauber platziert ein Symbol oder Zeichen auf der astralen Struktur des Ziels. Der Zauberer legt eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird ein Zeichen auf dem astralen Abdruck des Ziels platziert, das für jeden sichtbar ist, der astrale Wahrnehmung (wie etwa das Talent Astralsicht, S. 76) einsetzt, und dazu dienen kann, das Ziel wegen eines Verbrechens oder ähnlichem zu brandmarken.", "Das Zeichen dient außerdem als Verbindung zwischen dem Zauberer und dem Ziel. Auf diese Weise kann der Zauberer Zauber gegen das Ziel wirken, als befände es sich in Berührungsreichweite, solange er es sehen kann. Das Aussehen des Mals ist für jeden Zauberer einzigartig. Gerüchten zufolge könnte ein Dämon die Namensgeber diesen Zauber gelehrt haben, weshalb er oft mit Argwohn beäugt wird."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 4,
        url: "/wiki/Ber%C3%BChrung_des_Gauklers",
        name: "Berührung des Gauklers",
        threads: 2,
        weaving: 8,
        attune: 13,
        casting: "MVG",
        distance: "10 Schritt",
        dur: "Rang Runden",
        area: "2 Schritt Radius",
        eff: "WIL + 6/Physisch",
        eff_roll: {attribute: 'wil', mod: 6},
        eff_resist: 'pr',
        desc: ["Dieser Zauber lässt kleine Gegenstände wild umherfliegen. Der Zauberer vollführt jonglierende Bewegungen und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele innerhalb des Wirkungsbereichs ab. Wenn die Probe gelingt, beginnen alle kleinen Gegenstände im Wirkungsbereich, wild umherzufliegen, und treffen dabei alle in der Nähe befindlichen Ziele. Die Wirkungsprobe bestimmt, wie viel Schaden bei jedem Ziel verursacht wird.", "Der Zauberer kann den Wirkungsbereich um bis zu 2 Schritt verlagern, indem er eine erfolgreiche Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im neuen Wirkungsbereich ablegt (selbst wenn es sich dabei (teilweise) um dieselben Ziele handelt). Das Jonglieren der Gegenstände erfordert die Konzentration des Zauberers in der entsprechenden Runde; die einzige Aktion, die er durchführen kann, ohne dass der Zauber endet, ist eine Spruchzauberei-Probe, um die Wirkung des Zaubers zu verlagern. Wenn es im Wirkungsbereich keine kleinen Gegenstände gibt, hat der Zauber keine Wirkung."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Ziele Ausnehmen (-Rang)"},
            {txt: "Zusätzliche Wirkung (erfordert 2 Fäden, Konzentration für diesen Zauber als Einfache Aktion)"}]
    },
    {
        discipline: "Magier",
        circle: 4,
        url: "/wiki/Fesselnde_F%C3%A4den",
        name: "Fesselnde Fäden",
        threads: 2,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Runden",
        eff: "WIL + 3",
        eff_roll: {attribute: 'wil', mod: 3},
        desc: ["Dieser Zauber beschwört ein Netz aus magischen Fäden, das einen Gegner umschlingt. Der Zauberer zeigt auf das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bildet sich eine Masse bunter magischer Fäden in der Luft, fliegt auf das Ziel zu und umschlingt es mit mächtigen magischen Fesseln. In jeder Runde kann das Ziel eine Stärkeprobe gegen die Wirkungsstufe ablegen. Misslingt die Probe, bleibt es gefesselt, kann seine Hände nicht zum Angreifen oder Wirken von Zaubern verwenden und ist Bedrängt. Wenn die Probe gelingt, ist es nur Bedrängt. Der Bedrängt-Malus gilt nicht für Versuche, sich aus den Fesseln zu befreien."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)}"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 4,
        url: "/wiki/Gewachsenes_Bewusstsein",
        name: "Gewachsenes Bewusstsein",
        threads: 2,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Minuten",
        eff: "+4 auf Wissensproben und Proben auf Struktur Verstehen",
        desc: ["Dieser Zauber verbessert die Fähigkeit des Zauberers, sich an Informationen zu erinnern und sie zu verarbeiten. Der Zauberer sammelt sich mit einem für ihn einzigartigen Ritual, scheint aber keinen Zauber zu wirken. Anschließend legt er eine Spruchzauberei- Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, erlangt er eine ungewöhnliche Klarheit in seinen Gedanken und häufig eine schroffe Haltung gegenüber denen, die sein Niveau der Erleuchtung nicht erreicht haben. Er erhält einen Bonus von +4 auf alle Wissensproben und Proben auf Struktur Verstehen, die er während der Wirkungsdauer des Zaubers ablegt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"}]
    },
    {
        discipline: "Magier",
        circle: 4,
        url: "/wiki/Last_Erleichtern",
        name: "Last Erleichtern",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang Stunden",
        area: "2 Schritt Radius",
        eff: "WIL + 2",
        eff_roll: {attribute: 'wil', mod: 2},
        desc: ["Dieser Zauber senkt zeitweise das Gewicht von Gegenständen in seinem Wirkungsbereich. Der Zauberer beugt sich hinab, tut so, als hebe er eine schwere Last, richtet sich dann auf und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Zielgegenstände im Wirkungsbereich ab. Wenn die Probe gelingt, legt er eine Wirkungsprobe ab. Das summierte Gewicht der Gegenstände wird für die Wirkungsdauer des Zaubers um das Ergebnis der Wirkungsprobe x 50 Pfund (bis zu einem Minimum von 10 Pfund) gesenkt. Die Zielgegenstände dürfen sich nicht bewegen, wenn der Zauber gewirkt wird."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Magier",
        circle: 4,
        url: "/wiki/Leitfaden",
        name: "Leitfaden",
        threads: 3,
        weaving: 8,
        attune: 13,
        casting: "6",
        distance: "verschieden (s. Text)",
        dur: "Rang Stunden",
        eff: "WIL + 4",
        eff_roll: {attribute: 'wil', mod: 4},
        desc: ["Dieser Zauber beschwört ein Knäuel aus Fäden mystischer Energie. Der Zauberer knotet einen imaginären Knoten an einen Gegenstand, der den Ausgangspunkt markiert, und legt eine Spruchzauberei(6)-Probe ab. Wenn die Probe gelingt, erscheint ein Knäuel aus magischen Fäden in seiner Hand. Das Knäuel kann in eine Tasche oder einen Beutel gelegt werden; der Faden rollt sich automatisch aus, während der Zauberer geht. Einmal pro Stunde legt der Zauberer eine Wirkungs(10)-Probe ab. Gelingt die Probe, gibt das Knäuel immer mehr Faden aus und verheddert sich nicht. Misslingt die Probe, reißt der Faden, und der Zauber endet.", "Möchte der Zauberer zum Ausgangspunkt zurückkehren, rollt er den Faden wieder auf. Sobald er damit beginnt, leuchtet der Faden in einem weißen Licht auf. Wenn er dem leuchtenden Faden folgt, wird der Zauberer unfehlbar zum Ausgangspunkt zurückgeleitet."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Magier",
        circle: 4,
        url: "/wiki/Umhang_des_Magiers",
        name: "Umhang des Magiers",
        threads: 1,
        weaving: 8,
        attune: 13,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Minuten",
        eff: "+6 auf Mystische Verteidigung gegen Versuche, das Ziel astral zu entdecken",
        desc: ["Dieser Zauber erschafft einen magischen Umhang, der das Ziel im Astralraum verbirgt. Der Zauberer tut so, als lege er einen Umhang um seine Schultern und ziehe die Kapuze über seinen Kopf. Dann berührt er das Ziel und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, erscheint für einen kurzen Moment ein schwach leuchtender Umhang aus mystischer Energie, der dann im Körper des Ziels verschwindet. Das Ziel addiert gegen alle Zauber oder Fähigkeiten, um seine Anwesenheit astral zu entdecken oder Informationen über es zu erlangen, +6 zu seiner Mystischen Verteidigung."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Minuten)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 5,
        url: "/wiki/Fliegen",
        name: "Fliegen",
        threads: 2,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang x 10 Minuten",
        eff: "Verleiht Flugfähigkeit mit Bewegungsrate 12",
        desc: ["Dieser Zauber verleiht die Kraft des Fliegens. Der Zauberer bewegt seine Arme auf und nieder und legt dann eine Spruchzauberei- Probe gegen seine natürliche Mystische Verteidigung ab. Wenn die Probe gelingt, kann er mit Bewegungsrate 12 fliegen."],
        as: {txt: "Wirkungsdauer Verlängern (+10 Minuten)", what: ['dur'], mod: 10},
        at: [{txt: "Wirkung Verstärken (Bewegungsrate +2)"},
            {txt: "Wirkungsdauer Verlängern (+10 Minuten)"}]
    },
    {
        discipline: "Magier",
        circle: 5,
        url: "/wiki/Mystischer_Schock",
        name: "Mystischer Schock",
        threads: 2,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "1 Runde",
        eff: "WIL + 4/Mystisch",
        eff_roll: {attribute: 'wil', mod: 4},
        eff_resist: 'mr',
        desc: ["Dieser Zauber verletzt einen Charakter, indem er astrale Energie durch einen Gegenstand oder eine Oberfläche leitet. Der Zauberer muss das Ziel nicht sehen können; der Zauber kann durch jeden Gegenstand und jede Oberfläche – einschließlich Böden und Wänden – gewirkt werden, der oder die sowohl vom Zauberer als auch vom Ziel berührt wird. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt seine Wirkungsprobe, wie viel Schaden verursacht wird."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 5,
        url: "/wiki/Riesenwuchs",
        name: "Riesenwuchs",
        threads: 1,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "+4 auf reine Stärke- und Zähigkeitssowie Schadensproben",
        desc: ["Dieser Zauber lässt einen Charakter größer werden. Der Zauberer steht auf den Zehenspitzen oder bauscht seine Kleidung auf, sodass er größer erscheint, und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird das Ziel sofort 50 Prozent größer als normal und erhält während der Wirkungsdauer des Zaubers einen Bonus von +4 auf reine Stärke- und Zähigkeitsproben sowie auf Schadensproben, aber nicht auf Heilung, wie Feuerblut und Erholungsproben.", "Die Kleidung und Rüstung des Ziels vergrößern sich ebenfalls und kehren zu ihrer ursprünglichen Größe zurück, sobald der Zauber endet. Waffen und sonstige Ausrüstung verändern ihre Größe jedoch nicht. Dieser Zauber sollte in beengten Räumen, wie etwa Kaers oder Tunneln, nur mit Vorsicht gewirkt werden."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 5,
        url: "/wiki/Talent_Unterbrechen",
        name: "Talent Unterbrechen",
        threads: 0,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "2 Runden",
        eff: "Blockiert die Fähigkeit, ein Talent anzuwenden",
        desc: ["Dieser Zauber hindert einen Adepten daran, ein Talent anzuwenden. Der Zauberer mimt das Ziehen eines Fadens mit der einen Hand und dann das Durchschneiden des Fadens mit der anderen Hand. Dann legt er eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, verliert das Ziel bis zum Ende der nächsten Runde den Zugang zu dem Talent, das es zuletzt eingesetzt hat. Wenn der Zauberer das Ziel astral gespürt hat, kann er ein Talent aus den drei zuletzt benutzten Talenten auswählen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 5,
        url: "/wiki/Verlangsamen",
        name: "Verlangsamen",
        threads: 2,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "Halbiert Bewegung; -5 auf Proben, die auf Geschicklichkeit basieren",
        desc: ["Dieser Zauber verlangsamt Bewegung. Der Zauberer mimt das Wirken eines Zaubers in Zeitlupe und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, wird die Bewegungsrate des Ziels halbiert (abgerundet). Außerdem erleidet es einen Malus von -5 auf alle Proben, die auf Geschicklichkeit basieren, einschließlich Initiativeproben."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Malus -2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 5,
        url: "/wiki/Waffe_Herbei",
        name: "Waffe Herbei",
        threads: 2,
        weaving: 9,
        attune: 14,
        casting: "MVZ",
        distance: "Berührung; 100 Schritt",
        dur: "Rang Wochen (s. Text)",
        eff: "Wirkung: WIL + 6",
        eff_roll: {attribute: 'wil', mod: 6},
        desc: ["Dieser Ritualzauber erschafft eine Verbindung zwischen einer Waffe und einem Charakter, wodurch die Waffe ihren Weg zurückfinden kann, falls sie einmal verloren gehen sollte. Eine Woche lang verbringt der Zauberer jeweils bei Tagesanbruch eine halbe Stunde damit, mit einem Tropfen seines Blutes ein kleines Zeichen auf die Waffe zu zeichnen. Den ersten Zauberfaden webt er am Ende dieser Woche. Die nächste Woche über verbringt er jeweils bei Tagesanbruch eine halbe Stunde damit, dem Charakter eine Narbe beizubringen, die genauso aussieht wie das Zeichen, das er auf die Waffe gezeichnet hat. Am Ende dieser Woche webt er den letzten Zauberfaden.", "Sobald das Ritual vollendet ist, legt der Zauberer eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Charakters ab. Wenn die Probe gelingt, leuchten die Zeichen hell auf und verblassen dann wieder zu ihrem normalen Zustand. Zwischen dem Charakter und der Waffe wurde eine sympathetische Verbindung erschaffen. Der Tod des Charakters oder die Zerstörung der Waffe kappt auch die Verbindung, wonach sowohl das Zeichen auf der Waffe als auch die Narbe auf dem Charakter verblassen, ohne eine Spur zu hinterlassen.", "Jedes Mal, wenn die Waffe verloren geht, kann der Charakter eine Wirkungsprobe (mit seiner eigenen Willenskraftstufe) gegen die Mystische Verteidigung der Waffe ablegen. Wenn die Probe gelingt und die Waffe nicht mehr als 100 Schritt von ihm entfernt ist, bewegt sie sich mit einer Bewegungsrate von 6 auf den Charakter zu.", "Der Charakter muss die Waffe nicht sehen können, um sie wiederzubekommen. Sollte die Waffe eine Attributsprobe ablegen müssen – zum Beispiel um aus einem Schrank auszubrechen (Stärke) oder ein schmales Fensterbrett entlangzugleiten (Geschicklichkeit) –, legt der Charakter statt dieser Attributsprobe eine Wirkungsprobe ab."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Wochen)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Wochen)"}]
    },
    {
        discipline: "Magier",
        circle: 6,
        url: "/wiki/Energieschild",
        name: "Energieschild",
        threads: 1,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang Runden",
        eff: "Erschafft einen Schild aus Energie, der Angriffe abwehrt",
        desc: ["Dieser Zauber erschafft einen Schild, mit dem physische Angriffe und Zauber pariert werden können, die eine sichtbare Komponente haben (wie z. B. Erdpfeile). Der Zauberer streckt seine Hand aus, ballt sie zur Faust und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Gelingt die Probe, wird die schwache Hand des Ziels von blau leuchtender Energie umgeben, die in einen Schild genau vor seiner Hand ausgeweitet werden kann. Wenn dieser Schild benutzt wird, gewährt er einen Bonus von +4 auf Hieb Ausweichen und Eiserner Wille, und das Ziel kann nicht nur Hieb Ausweichen, sondern auch Eiserner Wille als improvisierte Fertigkeit verwenden. Der Bonus auf Eiserner Wille gilt nur gegen Zauber, die eine sichtbare Komponente haben. Wenn dieser Zauber aktiv ist, kann das Ziel keine Waffe in seiner schwachen Hand verwenden, kann mit ihr aber weiterhin einen Schild halten oder Zauber wirken."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (Minuten)"},
            {txt: "Zusätzliches Ziel (+Rang)"}]
    },
    {
        discipline: "Magier",
        circle: 6,
        url: "/wiki/Intuitives_Ausweichen",
        name: "Intuitives Ausweichen",
        threads: 0,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Runden",
        eff: "Verbessert Proben auf Hieb Ausweichen",
        desc: ["Dieser Zauber bewahrt den Zauberer vor Verletzungen. Der Zauberer hüpft wild auf und ab und legt dann eine Spruchzauberei- Probe gegen seine Mystische Verteidigung ab. Wenn die Probe gelingt, erhält er einen magischen \"sechsten Sinn\", der direkte oder indirekte Angriffe gegen ihn spürt und ihn automatisch in Sicherheit bringt. Dazu gehören auch Angriffe, denen man mit Hieb Ausweichen normalerweise nicht entgehen kann, wie etwa Angriffe aus dem Toten Winkel oder Überraschungsangriffe. Dazu gehören aber keine Angriffe, denen man mit Hieb Ausweichen niemals ausweichen kann, wie zum Beispiel die meisten Zauber.", "Jedes Mal, wenn der Zauberer angegriffen wird, kann er eine Probe auf Hieb Ausweichen gegen die Angriffsprobe ablegen. Wenn die Probe gelingt, bewegt er sich 2 Schritt weit weg in eine Richtung, die er selbst bestimmt. Sollten sich Hindernisse im Weg befinden, bewegt sich der Zauberer so weit, wie er kann, und verharrt dann. Wenn die zurückgelegte Entfernung nicht ausreicht, um dem Angriff auszuweichen, erleidet der Zauberer die Auswirkungen des Angriffs wie gewohnt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: []
    },
    {
        discipline: "Magier",
        circle: 6,
        url: "/wiki/Schlaf",
        name: "Schlaf",
        threads: 2,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        area: "8 Schritt Radius",
        eff: "Lässt Ziel einschlafen",
        desc: ["Dieser Zauber versetzt einen oder mehrere Charaktere in einen tiefen Schlaf. Der Zauberer gähnt herzhaft und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab. Wenn die Probe gelingt, fallen die Ziele sofort in einen magischen Schlaf und wachen erst auf, wenn sie Schaden erleiden oder der Zauber endet. In jeder Runde kann ein schlafendes Ziel eine Willenskraftprobe gegen die Willenskraftstufe des Zauberers ablegen. Gelingt die Probe, wacht es auf. Der Zauber wirkt nur gegen Charaktere oder Kreaturen, die Schlaf benötigen; er wirkt beispielsweise nicht gegen die meisten Untoten. Der Zauberer kann eine maximale Anzahl von Zielcharakteren gleich seinem Rang in Spruchzauberei beeinflussen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Willenskraft- stufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Magier",
        circle: 6,
        url: "/wiki/Verw%C3%BCstung",
        name: "Verwüstung",
        threads: 1,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "Rang + 5 Runden",
        eff: "+3 auf Angriffs- und Schadensproben im Nahkampf",
        desc: ["Dieser Zauber entfesselt die unterdrückte Aggression derjenigen, die in der Nähe des Zauberers stehen. Der Zauberer zeigt nacheinander auf jedes Ziel, stößt dann einen Schrei aus, der das Blut gefrieren lässt, und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab. Wenn die Probe gelingt, erhalten die betroffenen Ziele einen Bonus von +3 auf ihre Angriffs- und Schadensproben im Nahkampf. Außerdem müssen sie in jeder Runde die Kampfoption Aggressiver Angriff wählen (die auch wie gewohnt Überanstrengung kostet). Der Zauberer kann maximal so viele Ziele beeinflussen, wie sein Rang in Spruchzauberei beträgt."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+2 Schritt)"},
            {txt: "Wirkung Verstärken (Bonus +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Magier",
        circle: 6,
        url: "/wiki/Zauber_Verleihen",
        name: "Zauber Verleihen",
        threads: 1,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "Berührung",
        dur: "Rang + 10 Runden",
        eff: "Verleiht Zauber an eine andere Person",
        desc: ["Dieser Zauber verschafft einem Charakter zeitweisen Zugang zu einer Zaubermatrix. Der Zauberer bestimmt, welche seiner Zaubermatrizen er verleihen will, wirft dem Ziel dann einen kleinen Gegenstand – zum Beispiel eine Münze oder ein Amulett – zu und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, kann das Ziel den in der \"geliehenen\" Matrix befindlichen Zauber wirken.", "Das Ziel verwendet sein eigenes Spruchzauberei- und geeignetes Fadenweben-Talent, um den geliehenen Zauber zu wirken. Es muss in der Lage sein, alle nötigen Fäden für den geliehenen Zauber zu weben, oder sie müssen bereits gewebt sein, wie etwa im Fall einer \"geliehenen\" Erweiterten Matrix. Wenn das Ziel nicht über das Talent Spruchzauberei verfügt, legt es eine Wahrnehmungsprobe statt einer Spruchzauberei-Probe ab. Während", "er die Zaubermatrix verliehen hat, kann der Zauberer den Zauber in ihr nicht wirken und sie auch nicht auf einen neuen Zauber abstimmen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (erfordert 2 Fäden; Matrix wird zwischen Ziel und Zauberer geteilt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Magier",
        circle: 6,
        url: "/wiki/Zerschmettern",
        name: "Zerschmettern",
        threads: 3,
        weaving: 10,
        attune: 15,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "1 Runde",
        eff: "WIL + 7/Physisch und -4 auf Physische Rüstung",
        eff_roll: {attribute: 'wil', mod: 7},
        eff_resist: 'pr',
        desc: ["Dieser Zauber erschafft eine leuchtende, wirbelnde Kugel aus grünem Licht und Energie, die einen vernichtenden Schlag gegen einen zähen Gegner landet. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt die Wirkungsprobe des Zauberers, wie viel Schaden verursacht wird. Die Physische Rüstung des Ziels wird um 4 gesenkt, bis sie repariert werden kann (oder sie sich, im Falle von Fadengegenständen, selbst repariert)."],
        as: {txt: "Wirkung Verstärken (Physische Rüstung -2)", what: ['pr'], mod: -2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Physische Rüstung -2)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 7,
        url: "/wiki/Hypergeschwindigkeit",
        name: "Hypergeschwindigkeit",
        threads: 1,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        eff: "WIL + 2",
        eff_roll: {attribute: 'wil', mod: 2},
        desc: ["Dieser Zauber beschleunigt einen kleinen Gegenstand von etwa der Größe eines Kieselsteins auf unglaubliche Geschwindigkeit. Der Zauberer streckt seinen Arm aus, zeigt auf das Ziel und levitiert den Gegenstand genau vor seinem Finger. Wenn der Zauber vollständig ist, flüstert er \"Bumm!\" und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, überwindet der Gegenstand die Entfernung zum Ziel innerhalb eines Augenblicks und perforiert das Ziel. Der Zauberer legt eine Wirkungsprobe ab, um den Schaden zu bestimmen. Gegen diesen Schaden schützt keine Rüstung."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 7,
        url: "/wiki/Mystisches_Netz",
        name: "Mystisches Netz",
        threads: 3,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang + 5 Runden",
        area: "16 Schritt Radius",
        eff: "WIL + 3",
        eff_roll: {attribute: 'wil', mod: 3},
        desc: ["Dieser Zauber ist eine Flächenversion des Zaubers Fesselnde Fäden. Der Zauberer mimt das Zusammenbinden mehrerer Stücke Faden zu einem komplexen Knoten und legt dann eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, springt eine Masse leuchtender magischer Fäden aus seinen Händen und bildet ein Netz, das die Ziele fesselt. In jeder Runde darf ein betroffenes Ziel eine Stärkeprobe gegen die Wirkungsstufe ablegen. Misslingt die Probe, ist es gefesselt, kann seine Hände nicht zum Angreifen oder Wirken von Zaubern verwenden und ist Bedrängt. Wenn die Probe gelingt, ist es nur Bedrängt. Der Bedrängt-Malus gilt nicht für Versuche, sich aus den Fesseln zu befreien. Der Zauberer kann eine maximale Anzahl von Zielen gleich seinem Rang in Spruchzauberei beeinflussen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Magier",
        circle: 7,
        url: "/wiki/Ruf",
        name: "Ruf",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "100 Meilen",
        dur: "1 Runde",
        eff: "Überbringt eine Botschaft",
        desc: ["Dieser Zauber überbringt eine Botschaft über eine große Entfernung. Die Botschaft kann eine maximale Anzahl von Wörtern gleich dem Spruchzauberei-Rang des Zauberers enthalten und muss an jemanden innerhalb der Zauberreichweite geschickt werden, den der Zauberer kennt. Der Zauberer bewegt seinen Mund, als ob er spricht, und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, sieht und hört das Ziel ein magisches Bild des Zauberers, das die Botschaft spricht. Das Ziel erhält nur die Information, die der Zauberer überbringen will, sei es eine Drohung, eine Warnung, ein Hilferuf oder ein einfacher Gruß. Der Zauber erlaubt nur die Kommunikation in eine Richtung; der Zauberer weiß, ob der Zauber funktioniert hat, aber nicht, ob das Ziel die Botschaft verstanden hat. Er erfährt auch nichts über den derzeitigen Aufenthaltsort und Zustand des Ziels."],
        as: {txt: "Wirkung Verstärken (+Rang Wörter)"},
        at: [{txt: "Reichweite Erhöhen (+20 Meilen)"},
            {txt: "Wirkung Verstärken (+Rang Wörter)"}]
    },
    {
        discipline: "Magier",
        circle: 7,
        url: "/wiki/Verknotete_F%C3%A4den",
        name: "Verknotete Fäden",
        threads: 1,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "1 Runde",
        area: "4 Schritt Radius",
        eff: "WIL",
        eff_roll: {attribute: 'wil', mod: 0},
        desc: ["Dieser Zauber verwirrt die Fähigkeit eines Zauberers, Zauberfäden zu weben. Der Zauberer schüttelt den Kopf und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung innerhalb der Zielgruppe ab, +1 für jedes zusätzliche Ziel (Ziele, die der Zauberer zuvor astral gespürt hat, erhöhen den Mindestwurf nicht). Wenn die Probe gelingt, vergleicht er seine Wirkungsprobe mit der Fadenwebenstufe jedes Ziels. Wenn diese Probe gelingt, verlieren die betroffenen Ziele alle Zauberfäden, die sie gerade weben oder schon zu ihren Zaubern gewebt haben. Der Zauberer kann eine maximale Anzahl von Zielen gleich seinem Rang in Spruchzauberei beeinflussen."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"}]
    },
    {
        discipline: "Magier",
        circle: 7,
        url: "/wiki/Zauber_Verdr%C3%A4ngen",
        name: "Zauber Verdrängen",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "1 Runde",
        eff: "WIL + 5",
        eff_roll: {attribute: 'wil', mod: 5},
        desc: ["Dieser Zauber verdrängt einen zufälligen Zauber aus einer Zaubermatrix. Das Ziel muss eine oder mehrere Matrizen besitzen (dazu zählen auch Matrixgegenstände). Der Zauberer blinzelt mit den Augen und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bestimmt der Spielleiter zufällig eine der Matrizen des Ziels. Hat der Zauberer das Ziel astral gespürt, wird der Zauber in der Matrix enthüllt, und der Zauberer kann eine andere Zaubermatrix auswählen (er kennt allerdings nicht den Zauber in dieser neuen Matrix).", "Der Zauberer legt eine Wirkungsprobe gegen einen Neutralisierungsmindestwurf ab, der auf dem Rang der ausgewählten Zaubermatrix basiert (siehe Magie neutralisieren, S. 158). Gelingt die Wirkungsprobe, werden alle Zauber verdrängt, die in der Matrix platziert sind, und die Matrix bleibt leer zurück. Wenn ein Zauber in der betroffenen Matrix gerade gewirkt wird, kann das Ziel sich aussuchen, ob es den Zauber abbrechen oder ihn mittels roher Magie wirken will. Dieser Zauber kann gegen jede Art von Matrix (Zaubermatrix, Erweiterte, Gepanzerte oder Summenmatrix) und Matrixgegenstand gewirkt werden. Eine Zaubermatrix, die durch diesen Zauber geleert wurde, kann neu abgestimmt werden, entweder auf einen neuen Zauber oder auf den, den sie vorher enthielt."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 7,
        url: "/wiki/Zauberspeicher",
        name: "Zauberspeicher",
        threads: 2,
        weaving: 11,
        attune: 16,
        casting: "siehe Text",
        distance: "Berührung",
        dur: "Rang Stunden",
        eff: "Speichert einen Zauber zeitweise in einem Gegenst",
        desc: ["Dieser Zauber platziert die Struktur eines Zaubers in einem Gegenstand, sodass dieser Zauber später gewirkt werden kann. Der Gegenstand kann alles sein und benötigt keine spezielle Verzauberung. Der Zauberer berührt den Gegenstand und legt eine Spruchzaubereiprobe gegen den Neutralisierungsmindestwurf des Zaubers ab, der gespeichert werden soll. Wenn die Probe gelingt, wird der Zauber in dem Gegenstand platziert. Jeder, der den Gegenstand hält, kann den Zauber wie aus einer Matrix  heraus wirken, wobei er seine eigene Stufe in Spruchzauberei verwendet. Wenn der Zauber Fäden erfordert, muss der Charakter das entsprechende Fadenweben-Talent beherrschen. Er muss den Gegenstand berühren, um den darin gespeicherten Zauber zu wirken.", "Sobald der gespeicherte Zauber gewirkt wurde oder die Wirkungsdauer des Zauberspeichers endet, verschwindet die Zauberstruktur aus dem Gegenstand."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Stunden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkungsdauer Verlängern (+2 Stunden)"}]
    },
    {
        discipline: "Magier",
        circle: 8,
        url: "/wiki/Astrale_Katastrophe",
        name: "Astrale Katastrophe",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "30 Schritt",
        dur: "1 Runde",
        area: "6 Schritt Radius",
        eff: "WIL + 5/Mystisch und -2 auf alle Aktionsproben",
        eff_roll: {attribute: 'wil', mod: 5},
        eff_resist: 'mr',
        desc: ["Dieser Zauber entfesselt mystische Energie im physischen und Astralraum des Wirkungsbereichs. Der Zauberer vollführt eine dramatische reißende Bewegung mit beiden Händen und legt eine Spruchzauberei-Probe gegen die höchste Mystische Verteidigung aller Ziele im Wirkungsbereich ab. Wenn die Probe gelingt, strömt chaotische Energie in den Wirkungsbereich – sowohl auf der physischen als auch auf der Astralebene. Die Wirkungsprobe bestimmt, wie viel Schaden jedes Ziel im Wirkungsbereich in jeder Runde erleidet, in der der Zauber aktiv ist. Außerdem erleiden alle Ziele, die durch den Zauber Schaden erlitten haben, bis zum Ende der Runde einen Malus von -2 auf alle Aktionsproben. Der Zauber wirkt nicht gegen den Zauberer selbst."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Malus -2)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsbereich Ausdehnen (+2 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Magier",
        circle: 8,
        url: "/wiki/Karmablockade",
        name: "Karmablockade",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "40 Schritt",
        dur: "Rang Runden",
        eff: "Verhindert die Verwendung von Karma",
        desc: ["Dieser Zauber neutralisiert kurzzeitig die Fähigkeit eines Charakters, Karma zu verwenden. Der Zauberer schnippt mit den Fingern und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, kann er jeden Versuch des Ziels, Karma einzusetzen, vereiteln, indem er einen seiner eigenen Karmapunkte ausgibt. Keiner der beiden würfelt Karmawürfel für die ausgegebenen Karmapunkte, aber die von beiden Parteien ausgegebenen Karmapunkte sind verloren. In jeder Runde kann das Ziel eine Willenskraftprobe gegen das Ergebnis der Spruchzauberei-Probe ablegen. Wenn die Probe gelingt, endet der Zauber, und das Ziel kann wieder Karma einsetzen."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Magier",
        circle: 8,
        url: "/wiki/Zauber_Einfangen",
        name: "Zauber Einfangen",
        threads: 1,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "Selbst",
        dur: "Rang Runden",
        eff: "WIL + 2",
        eff_roll: {attribute: 'wil', mod: 2},
        desc: ["Dieser Zauber fängt andere Zauber ein. Der Zauberer tut so, als fange er einen Gegenstand auf, und legt dann eine Spruchzauberei- Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, legt er eine Wirkungsprobe gegen das Ergebnis der Spruchzauberei-Probe eines beliebigen Zaubers ab, den das Ziel direkt gegen ihn wirkt (was bedeutet, dass der Zauber nicht gegen Flächenzauber wirkt). Wenn die Probe gelingt, fängt er den Zauber ein und kann ihn halten, bis sein Zauber endet oder er eine Spruchzauberei-Probe ablegt, um den gefangenen Zauber auf ein Ziel innerhalb der Zauberreichweite des gefangenen Zaubers zu wirken – einschließlich des ursprünglichen Zauberwirkers. Wenn der Zauberer den gefangenen Zauber wirkt, basieren alle seine Wirkungen auf den Spielwerten des ursprünglichen Wirkers. Wenn Zauber Einfangen endet, während der Zauberer einen Zauber gefangen hält, wirkt dieser Zauber wie gewohnt auf ihn. Der Zauberer kann keine anderen Zauber wirken, solange er einen Zauber gefangen hält, ansonsten endet sein Zauber Einfangen sofort."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"}]
    },
    {
        discipline: "Magier",
        circle: 8,
        url: "/wiki/Zauberdiebstahl",
        name: "Zauberdiebstahl",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "10 Schritt",
        dur: "1 Runde (s. Text)",
        eff: "WIL + 4",
        eff_roll: {attribute: 'wil', mod: 4},
        desc: ["Dieser Zauber stiehlt einen Zauber aus der Zaubermatrix eines anderen Zauberers und fügt ihn in eine der eigenen Matrizen des Zauberers ein. Zauberer ersetzen für gewöhnlich den Zauberdiebstahl durch den gestohlenen Zauber, können aber jeden beliebigen Zauber in ihren Matrizen ersetzen. Der Zauberer legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Zielzauberers ab. Wenn die Probe gelingt, bestimmt der Spielleiter zufällig eine der Zaubermatrizen des Ziels. Der Zauberer legt eine Wirkungsprobe gegen einen Neutralisierungsmindestwurf ab, der auf dem Kreis des zu stehlenden Zaubers beruht. Wenn diese Probe gelingt, verlässt der Zauber seine Matrix und erscheint in einer Matrix des Zauberers. Der gestohlene Zauber bleibt in der Matrix des Zauberers, bis er gewirkt oder ersetzt wurde, was vom Zauber abhängig ist.", "Wenn der Zauberer den gestohlenen Zauber nicht wirken kann (weil er das benötigte Fadenweben-Talent nicht beherrscht oder sein Kreis nicht hoch genug ist), kann er ihn dennoch aus der Ma- trix wirken, als würde er ihn aus einem Grimoire wirken, das er abgestimmt hat (S. 157). In diesem Fall verschwindet der Zauber aus seiner Matrix, sobald er gewirkt wurde. Wenn der Zauberer den gestohlenen Zauber wirken kann, kann er ihn wie gewohnt einsetzen. In diesem Fall bleibt der gestohlene Zauber in seiner Matrix, bis er von einem anderen Zauber ersetzt oder durch eine misslungene Neuabstimmung gelöscht wird. Wenn der Zauberer den gestohlenen Zauber nicht kennt, kann er versuchen, ihn mit einer Probe auf Struktur Verstehen zu lernen (siehe Zauber lernen, S. 148). Wenn die Probe gelingt, kann er die entsprechenden Legendenpunkte ausgeben und den Zauber in sein Grimoire übertragen."],
        as: {txt: "Wirkung Verstärken (Wirkungsstufe +2)", what: ['eff_roll'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"}]
    },
    {
        discipline: "Magier",
        circle: 8,
        url: "/wiki/Zauberk%C3%A4fig",
        name: "Zauberkäfig",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang + 5 Runden",
        area: "2 Schritt Radius",
        eff: "-5 auf Spruchzauberei- und Fadenweben-Proben",
        desc: ["Dieser Zauber setzt einen Charakter in einem magischen Käfig gefangen. Der Zauberer gibt einen pfeifenden, tiefer werdenden Ton von sich, gefolgt von einem \"Klong!\", und legt dann eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, bildet sich ein Käfig um das Ziel herum. Das Ziel muss in den Käfig passen, sonst misslingt der Zauber automatisch. Sobald der Käfig beschworen wurde, kann er nicht mehr bewegt werden.", "Das Ziel kann nicht aus dem Käfig entkommen, weil er keine Tür hat. Während es im Käfig gefangen ist, erleidet es einen Malus von -5 auf Spruchzauberei- und Fadenweben-Proben, einschließlich Versuchen, Zauber gegen den Käfig selbst zu wirken. Der Käfig kann durch Angriffe zerstört werden und gilt dafür als Barriere mit einer Physischen und Mystischen Rüstung von jeweils 10 und einer Todesschwelle von 40."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Wirkung Verstärken (Malus -1)"},
            {txt: "Wirkung Verstärken (Todesschwelle +10)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    },
    {
        discipline: "Magier",
        circle: 8,
        url: "/wiki/Zerquetschen",
        name: "Zerquetschen",
        threads: 2,
        weaving: 12,
        attune: 17,
        casting: "MVZ",
        distance: "20 Schritt",
        dur: "Rang Runden",
        eff: "WIL + 3/Physisch",
        eff_roll: {attribute: 'wil', mod: 3},
        eff_resist: 'pr',
        desc: ["Dieser Zauber setzt einen Charakter in einer magischen Blase gefangen. Der Zauberer legt seine Hände zusammen, als ob er eine Kugel hielte, breitet dann die Arme aus und legt eine Spruchzauberei-Probe gegen die Mystische Verteidigung des Ziels ab. Wenn die Probe gelingt, formt sich ein Feld aus Energie zu einer dehnbaren, aber widerstandsfähigen Blase um das Ziel. Die Wirkungsprobe des Zauberers bestimmt, wie viel Schaden verursacht wird, während die Blase das Ziel zusammenquetscht und seine Handlungen behindert.", "In jeder Runde muss sich der Zauberer konzentrieren, um die Blase zusammenzudrücken und dem Ziel zusätzlichen Schaden zuzufügen. Er kann sich aber auch einfach entfernen und das Ziel in der Blase gefangen lassen, bis der Zauber endet. Die Blase kann von außen zerstört werden, indem ihre Todesschwelle auf 0 gesenkt wird. Die Blase gilt als Barriere mit einer Physischen und Mystischen Rüstung von jeweils 10 und einer Todesschwelle von 20. Das Ziel kann aus der Blase ausbrechen, indem es eine erfolgreiche Stärkeprobe gegen die Wirkungsstufe des Zaubers ablegt. Waffen oder Zauber des Ziels haben keine Wirkung gegen das Innere der Blase."],
        as: {txt: "Wirkungsdauer Verlängern (+2 Runden)", what: ['dur'], mod: 2},
        at: [{txt: "Reichweite Erhöhen (+10 Schritt)"},
            {txt: "Wirkung Verstärken (Wirkungsstufe +2)"},
            {txt: "Wirkungsdauer Verlängern (+2 Runden)"},
            {txt: "Zusätzliches Ziel (+1)"}]
    }
]

export default data_spells